export default {
  detectionDescriptionContentVersion: function(isHd) {
    if (isHd) return this.HdDetectionDescriptionContent;
    return this.detectionDescriptionContent;
  },
  updateDefaultContent: function(originalContent, temp, isSupportSkinType) {
    if (isSupportSkinType) {
      originalContent = this.updateContent(originalContent, temp, [
        'normal_non_sensitive',
        'dry_non_sensitive',
        'oily_non_sensitive',
        'combination_non_sensitive',
        'normal_sensitive',
        'dry_sensitive',
        'oily_sensitive',
        'combination_sensitive',
      ]);
    }
    return originalContent;
  },
  updateContent: function(originalContent, temp, keysToInsert) {
    for (let lang in originalContent) {
      if (originalContent[lang] && temp[lang]) {
        keysToInsert.forEach(key => {
          if (!originalContent[lang][key] && temp[lang][key]) {
            originalContent[lang][key] = temp[lang][key];
          }
        });
      }
    }
    return originalContent;
  },
  detectionDescriptionContent: {
    en: {
      age_spot:
        'The AI algorithm identifies different levels of dark spots and excludes non-dark-spot areas like skin mole, facial hair, or other false readings.',
      redness:
        'Skin redness can be caused by a variety of factors. The AI algorithm can detect subtle symptoms before the condition starts to cause irritation.',
      moisture:
        'A sophisticated AI deep learning algorithm analyzes and detects skin hydration levels. Various indicators of skin dehydration are recognized.',
      oiliness:
        'AI algorithm categorizes oiliness into three levels and shows results using AR overlays to help users recognize skin areas requiring more attention.',
      wrinkle:
        'AI identifies various types of wrinkles, from fine lines to deep creases. The technology focuses on facial areas where the wrinkles are most common.',
      texture:
        'AI algorithm for texture detects bumps and dents on users’ skin and offers users an overall assessment of their skin smoothness.',
      eye_bag:
        'AI algorithm for dark circles can also analyze eye bag condition. AR overlays delineate the size and the puffiness of the user’s eye bag condition.',
      firmness:
        'AI algorithm analyzes skin firmness and identifies levels of skin sagging on both sides of the chin.',
      droopy_upper_eyelid:
        'AI algorithm examines the outer corner of the upper eyelid and identifies levels of sagging around it for one/both eyes.',
      droopy_lower_eyelid:
        'AI algorithm examines the outer corner of the lower eyelid and identifies levels of sagging around it for one/both eyes.',
      radiance:
        'AI algorithm analyzes overall skin clarity and luminosity to provide an assessment score, helping user to improve the appearance of radiant skin.',
      acne:
        'The algorithm can do a 180-degree full face analysis to identify three types of acne: inflammatory acne, whiteheads, and blackheads.',
      pore:
        "AI algorithm detects visible pores and highlights them with AR overlays. Pore analysis shows the condition of user's skin for the best treatment plan.",
      dark_circle_v2:
        'AI algorithm scans the under-eye area for dark circles. The dark circle area is clearly marked and users can see the severity of this condition.',
      skin_age:
        "Our innovative skin technology was developed with skincare experts and uses over 70,000 medical-grade images, across different skin types, ethnicities, gender, and age groups. Based on that knowledge and data, the AI algorithm is able to estimate the age of the user's skin.",
      skin_health:
        "Powered by AI deep learning technology, our algorithm gives a health score to the user's skin based on the scores of the multiple skin concerns it analyzes.",
    },
    fr: {
      age_spot:
        "L'algorithme de l'analyseur de peau identifie l’intensité de taches et exclut ce qui ne relève pas de la tache comme les grains de beauté, les poils ou autres.",
      redness:
        "Les rougeurs ont des causes variées. L'algorithme en IA perçoit les symptômes les plus subtiles avant l'arrivée des premières irritations.",
      moisture:
        "Un algorithme performant de Deep Learning détecte le niveau d'hydratation de la peau. Plusieurs signaux de déshydratation sont détectés.",
      oiliness:
        'Notre algorithme en IA détecte 3 niveaux de brillances et les visualise par superposition grâce à la RA qui délimite les zones concernées.',
      wrinkle:
        "L'IA identifie les différentes types de rides (des ridules aux rides profondes) et s'attarde sur les zones les plus fréquemment touchées.",
      texture:
        'Notre algorithme en IA détecte les irrégularités de la peau et évalue à quel point celle-ci est lisse.',
      eye_bag:
        "L'algorithme en IA analyse également les poches sous les yeux. La RA permet de délimiter la taille et le côté gonflé de la poche.",
      firmness:
        "Notre algorithme en IA évalue l'affaissement de la peau au niveau des paupières supérieures, inférieures et autour du menton.",
      droopy_upper_eyelid:
        "L'algorithme en IA examine le coin extérieur de la paupière supérieure afin d'identifier l'affaissement à ce niveau.",
      droopy_lower_eyelid:
        "L'algorithme en IA examine le coin extérieur de la paupière inférieure afin d'identifier l'affaissement à ce niveau.",
      radiance:
        "L'algorithme en IA évalue la clareté et la luminosité de la peau afin d'aider l'utilisateur à améliorer l'apparence de sa peau.",
      acne:
        "Notre algorithme analyse la peau de visage à 180° pour identifier 3 types d'acné : l'acné inflammatoire, les points blancs et les points noirs.",
      pore:
        "L'algorithme en IA détecte les pores et les montre en RA ce qui permet de proposer le meilleur traitement adapté à l'état de la peau.",
      dark_circle_v2:
        "L'algorithme en IA identifie les cernes. La zone sombre est clairement représentée et l'utilisateur peut évaluer la sévérité des cernes.",
      skin_age:
        "Notre technologie innovante a été développée avec l'aide d'experts de la peau. Elle utilise plus de 70 000 images évaluées médicalement et intégrant différents types de peau, de sexes et de tranches d'âge. En s'appuyant sur ces données, l'algorithme en IA est capable de déterminer un âge estimatif de la peau de l'utilisateur.",
      skin_health:
        "Grâce à la technologie de deep learning en IA, notre algorithme donne un score de santé pour la peau de l'utilisateur en s'appuyant sur le score des multiples problèmes de peau analysés.",
    },
    ja: {
      age_spot:
        'AI アルゴリズムは、異なるレベルのシミを識別し、ほくろ、うぶ毛、または誤認など、シミではないものを除外します。',
      redness:
        '肌が赤くなるのにはさまざまな原因があります。AI アルゴリズムは、症状が悪化する前に微妙な状態を検出できます。',
      moisture:
        '高性能の AI ディープラーニング アルゴリズムによる分析で肌の水分レベルを検出します。さまざまな水分不足状態が分かります。',
      oiliness:
        'AIアルゴリズムは油分を3つのレベルに分類し、AR オーバーレイで表示することで、ユーザーに注意エリアを分かり易く提示します。',
      wrinkle:
        'AI は細いシワから深いシワまで、あらゆるシワを識別します。この技術は、シワが最も気になる顔の部分を中心に検出します。',
      texture:
        'AI アルゴリズムは、ユーザーの肌の凹凸を検出し、ユーザーの肌の全体的な滑らかさを評価します。',
      eye_bag:
        'AI アルゴリズムは、目袋の状態を分析することができます。AR オーバーレイで、ユーザーの目袋の大きさとむくみ状態を示します。',
      firmness:
        'AI アルゴリズムは、肌のハリを分析し、顎の両側のたるみ状態を識別します。',
      droopy_upper_eyelid:
        'AI アルゴリズムは、上まぶたの目尻を調べ、片眼/両眼の周りのたるみ状態を識別します。',
      droopy_lower_eyelid:
        'AI アルゴリズムは、下まぶたの目尻を調べ、片眼/両眼の周りのたるみ状態を識別します。',
      radiance:
        'AI アルゴリズムは、全体的な肌の透明度、明るさ、変色を分析して、スコアで評価します。',
      acne:
        'このアルゴリズムは、180度のフルフェイス分析を行い、炎症性吹き出物、白ニキビ、黒ずみという3種類のニキビを特定します。',
      pore:
        'AI アルゴリズムは目立つ毛穴を検出し、AR オーバーレイでハイライトします。.毛穴分析は、ユーザーの肌の状態を示し、トリートメントプランに役立ちます。',
      dark_circle_v2:
        'AI アルゴリズムは、目の下のエリアをスキャンしてクマを検出します。クマは分かり易くマークが付けられるため、ユーザーは状態を明確に把握できます。',
      skin_age:
        'スキンケアの専門家とともに開発したこの肌技術は、さまざまな肌タイプ、民族、性別、年齢層にわたる、7万枚以上の医療用画像を使用しています。その知識とデータをもとに、AIアルゴリズムがユーザーの肌年齢を推定しています。',
      skin_health:
        'AIのディープラーニング技術を搭載し、アルゴリズムが分析した複数の肌悩みのスコアから、ユーザーの肌スコアを解析します。',
    },
    ko: {
      age_spot:
        'AI 알고리즘이 다양한 잡티를 식별하며, 점이나 수염, 기타 잡티가 아닌 것을 잡티로 잘못 판독하지 않도록 합니다.',
      redness:
        '피부 홍조는 다양한 이유로 발생할 수 있습니다. 당사의 AI 알고리즘은 피부 문제가 시작되기 전 발생하는 미묘한 증상까지도 감지합니다.',
      moisture:
        '정교한 AI 딥러닝 알고리즘이 피부 수분기를 분석하고 감지합니다. 피부 건조와 관련된 다양한 지표를 인식하여 피부 타입 진단을 도출합니다.',
      oiliness:
        'AI 알고리즘이 피부의 유분기를 측정하여 AR을 통해 피부 고민을 시각화하고 피부 타입 진단을 도출합니다.',
      wrinkle:
        'AI가 잔주름부터 깊은 주름까지 다양한 유형의 주름을 식별합니다. 해당 기술은 주름이 일반적으로 많이 나타나는 부위에 더욱 집중합니다.',
      texture:
        'AI 알고리즘이 요철을 감지하고 피부의 매끄러운 정도를 전반적으로 평가하여 피부 타입을 진단합니다.',
      eye_bag:
        '다크서클에 사용되는 알고리즘이 눈 밑 지방 상태도 분석합니다. AR 오버레이가 개인의 눈 밑 지방 상태의 크기와 붓기를 상세하게 묘사하여 표시합니다.',
      firmness:
        'AI 알고리즘이 피부 탄력을 분석하고 턱 양쪽의 피부 처짐 정도를 확인합니다.',
      droopy_upper_eyelid:
        'AI 알고리즘이 위 눈꺼풀의 바깥쪽 모서리를 분석하여 한쪽 또는 양쪽 눈의 눈꺼풀 주위에 처지는 정도를 식별합니다.',
      droopy_lower_eyelid:
        'AI 알고리즘이 아랫눈꺼풀의 바깥쪽 모서리를 분석하여 한쪽 또는 양쪽 눈의 눈꺼풀 주위에 처지는 정도를 식별합니다.',
      radiance:
        'AI 알고리즘이 전반적인 피부 투명도, 광채 및 변색을 분석하여 평가 점수를 제공합니다.',
      acne:
        '해당 알고리즘은 얼굴 전체를 180도 분석하여 염증성 여드름, 화이트헤드, 블랙헤드와 같은 세 가지 여드름 타입을 식별합니다.',
      pore:
        'AI 알고리즘이 피부 모공을 감지하고 AR 오버레이를 통해 모공을 강조합니다. 피부 상태를 시각화하여 효과적인 피부 타입 진단을 도출합니다.',
      dark_circle_v2:
        'AI 알고리즘이 눈 아랫부분을 스캔하여 다크서클을 확인합니다. AR을 통해 피부 고민 부위가 명확하게 표시되어 상태의 심각도를 볼 수 있습니다.',
      skin_age:
        '당사의 혁신적인 피부 기술은 스킨케어 전문가와 함께 개발되었으며 다양한 피부 타입, 인종, 성별 및 연령대에 걸쳐 70,000개 이상의 의료 등급 이미지를 사용합니다. 이러한 데이터를 기반으로 개발된 AI 알고리즘이 사용자의 피부 나이를 추정합니다.',
      skin_health:
        'AI 딥 러닝 기술을 기반으로 하는 당사의 알고리즘은 여러 피부 문제의 분석 점수를 토대로 사용자의 피부 건강 점수를 부여합니다.',
    },
    de: {
      age_spot:
        'Der KI-Algorithmus identifiziert verschiedene Intensitäten dunkler Flecken und schließt Bereich ohne dunkle Flecken wie Muttermale, Gesichtsbehaarung oder andere falsche Werte effektiv aus.',
      redness:
        'Rötungen der Haut können durch verschiedenste Faktoren hervorgerufen werden. Der KI-Algorithmus kann bereits leichte Symptome erkennen, bevor der Zustand zu Reizungen führt.',
      moisture:
        'Ein raffinierter KI-Deep Learning Algorithmus analysiert und erkennt die Hydrierungsstufen der Haut. Es werden verschiedene Anzeichen der Dehydrierung der Haut erkannt.',
      oiliness:
        'Der KI-Algorithmus kategorisiert die Fettigkeit der Haut in drei Stufen und zeigt die Ergebnisse anhand unserer intuitiven AR-Überlappungen auf, um den Nutzer:innen zu helfen, spezifische Hautbereiche zu erkennen, die mehr Aufmerksamkeit brauchen.',
      wrinkle:
        'Der KI-Algorithmus identifiziert diverse Arten von Falten – von feinen Fältchen bis hin zu tiefen Falten. Die Technologie konzentriert sich auf Gesichtsbereiche, wo Falten am häufigsten auftreten.',
      texture:
        'Der KI-Algorithmus für Textur erkennt Knötchen und Vertiefungen auf der Haut der Nutzerin/des Nutzers und stellt eine Gesamtbeurteilung der Hautglätte bereit.',
      eye_bag:
        'Der KI-Algorithmus, den wir für Augenringe anwenden, kann auch Tränensäcke erkennen. AR-Überlappungen zeichnen die Größe und die Schwellung der Tränensäcke einer Person nach.',
      firmness:
        'Der KI-Alogrithnus analysiert die Festigkeit der Haut und identifiziert, wie sehr die Haut bereits hängt.',
      droopy_upper_eyelid:
        'Der KI-Algorithmus untersucht die äußere Ecke des oberen Augenlids und stellt fest, wie sehr die Haut darum herum an einem/beiden Auge/n hängt.',
      droopy_lower_eyelid:
        'Der KI-Algorithmus untersucht die äußere Ecke des unteren Augenlids und stellt fest, wie sehr die Haut darum herum an einem/beiden Auge/n hängt.',
      radiance:
        'Der KI-Algorithmus analysiert insgesamt die Klarheit der Haut, das Strahlen und den Farbverlust, um eine Beurteilung zu ermöglichen.',
      acne:
        'DDer Algorithmus kann eine 180°-Vollgesichtsanalyse durchführen, um drei Arten von Akne zu entdecken: Entzündliche Akne, Pickel und Mitesser.',
      pore:
        'Der KI-Algorithmus entdeckt sichtbare Poren und betont sie mit AR-Überlagerungen. Porenanalyse zeigt den Zustand der Haut einer Nutzerin/eines Nutzers für den besten Behandlungsplan.',
      dark_circle_v2:
        'Der KI Algorithmus scannt den Bereich unter den Augen nach Augenringen ab. Der Bereich wird klar markiert und Nutzer:innen können sehen, wie schlimm der Zustand ist.',
      skin_age:
        'Unsere innovative Hauttechnologie wurde mit Hautpflegeexperten entwickelt und verwendet über 70.000 Bilder in medizinischer Qualität für verschiedene Hauttypen, Ethnien, Geschlechter und Altersgruppen. Basierend auf diesem Wissen und diesen Daten ist der KI-Algorithmus in der Lage, das Alter der Haut des Benutzers zu schätzen.',
      skin_health:
        'Angetrieben von KI-Deep-Learning Technologie gibt unser Algorithmus der Haut des Benutzers einen Gesundheits-Score welcher auf dem Score der verschiedenen, analysierten Hautprobleme basiert.',
    },
    es: {
      age_spot:
        'El algoritmo de IA identifica diferentes niveles de manchas en la piel desde oscuras y excluye las zonas que no lo son, como los lunares de la piel, el vello facial u otras partes de la piel.',
      redness:
        'El enrojecimiento de la piel puede ser causado por diversos factores. El algoritmo de IA puede detectar síntomas sutiles antes de que el enrojecimiento de la piel cause irritación.',
      moisture:
        'Un sofisticado algoritmo de aprendizaje profundo de IA analiza y detecta los niveles de hidratación de la piel. Se reconocen varios indicadores de deshidratación de la piel.',
      oiliness:
        'La piel grasa es identificada mediante el algoritmo de IA la cual clasifica la grasa de la piel en tres niveles y muestra los resultados mediante superposiciones de RA para ayudar a los usuarios a reconocer las zonas de la piel que requieren más atención.',
      wrinkle:
        'La IA identifica varios tipos de arrugas, y los usuarios pueden ver arrugas online desde líneas finas hasta pliegues profundos. La tecnología se centra en las zonas del rostro donde las arrugas son más frecuentes.',
      texture:
        'El algoritmo de IA para identificar la textura de piel detecta protuberancias y abolladuras en la piel de los usuarios y les ofrece una evaluación general de la suavidad de su piel.',
      eye_bag:
        'El algoritmo de IA para las ojeras también puede analizar el estado de las bolsas en los ojos. Las superposiciones de RA delinean el tamaño y la hinchazón del estado de las bolsas en los ojos del usuario.',
      firmness:
        'El algoritmo de IA analiza la flacidez facial e identifica los niveles de flacidez de la piel en ambos lados del mentón.',
      droopy_upper_eyelid:
        'El algoritmo de IA examina la esquina exterior del párpado superior e identifica los niveles de flacidez a su alrededor para uno o ambos ojos.',
      droopy_lower_eyelid:
        'El algoritmo de IA examina la esquina exterior del párpado inferior e identifica los niveles de flacidez a su alrededor para uno o ambos ojos.',
      radiance:
        'El algoritmo de IA analiza la claridad y la luminosidad general de la piel para proporcionar una puntuación de evaluación, ayudando al usuario a conseguir una piel luminosa.',
      acne:
        'El diagnostico piel de 180 grados se aplica en toda la cara para identificar tres tipos de acné: acné inflamatorio, puntos blancos y puntos negros.',
      pore:
        'El algoritmo de IA detecta los poros vde la piel isibles y los resalta con superposiciones de RA. El análisis de los poros de la piel muestra el estado de la piel del usuario para el mejor plan de tratamiento.',
      dark_circle_v2:
        'Las ojeras son identificadas mediante el algoritmo de IA el cual escanea la zona de debajo de los ojos en busca de ojeras. La zona de las ojeras se marca claramente y los usuarios pueden ver la gravedad de esta condición.',
      skin_age:
        'Nuestra innovadora tecnología de la piel fue desarrollada con expertos en el cuidado de la piel y utiliza más de 70.000 imágenes de grado médico, a través de diferentes tipos de piel, etnias, género y grupos de edad. Basándose en esos conocimientos y datos, el algoritmo de IA es capaz de estimar la edad de la piel del usuario.',
      skin_health:
        'Angetrieben von KI-Deep-Learning Technologie gibt unser Algorithmus der Haut des Benutzers einen Gesundheits-Score welcher auf dem Score der verschiedenen, analysierten Hautprobleme basiert.',
    },
    it: {
      age_spot:
        'L’algoritmo tramite AI indica in maniera precisa l’area delle macchie con una sovrapposizione visiva, e determina anche la densità e l’intensità delle macchie.',
      redness:
        "L'AI rileva le aree arrossate, rilevando condizioni tra cui rosacea, dermatite e scottature. Determina anche la densità e la gravità degli arrossamenti.",
      moisture:
        'L’AI rileva i diversi sintomi di disidratazione della pelle, tra cui linee sottili, rugosità, opacità e irritazione.',
      oiliness:
        'Gli utenti possono vedere quali aree del loro viso hanno un’eccessiva secrezione di sebo.',
      wrinkle:
        'L’AI riconosce il livello di gravità dei diversi tipi di rughe, comprese le linee della fronte, le zampe di gallina, le rughe di espressione, le rughe della marionetta e altre.',
      texture:
        "La diagnostica della pelle tramite AI è in grado di classificare diversi livelli di profondità della struttura della pelle e d'individuare superfici irregolari sulla pelle.",
      eye_bag:
        'Rilevamento avanzato dei tre diversi tipi di occhiaie, compresi pigmentazione, vascolarizzazione e i tipi strutturali.',
      firmness:
        'L’algoritmo AI analizza la compattezza della pelle e identifica i livelli di cedimento della pelle su entrambi i lati del mento.',
      droopy_upper_eyelid:
        'L’algoritmo di AI esamina l’angolo esterno della palpebra superiore e identifica i livelli di rilassamento intorno a essa per uno/entrambi gli occhi.',
      droopy_lower_eyelid:
        'L’algoritmo di AI esamina l’angolo esterno della palpebra inferiore e identifica i livelli di cedimento intorno a essa per uno/entrambi gli occhi.',
      radiance:
        'L’algoritmo di AI analizza la trasparenza generale della pelle, la radiosità e lo scolorimento per fornire una valutazione',
      acne:
        'Skin test viso a 180 gradi dei problemi di acne per identificarne diversi fattori e condizioni, tra cui iperpigmentazione post-infiammatoria (PIH), reazioni infiammatorie e punti neri.',
      pore:
        'Pori visibili L’algoritmo di AI rileva i pori visibili e li evidenzia con sovrapposizioni di AR. L’analisi dei pori mostra la condizione della pelle dell’utilizzatore per il miglior piano di trattamento.',
      dark_circle_v2:
        'Rilevamento avanzato dei tre diversi tipi di occhiaie, compresi pigmentazione, vascolarizzazione e i tipi strutturali.',
      skin_age:
        "La nostra tecnologia pelle innovativa è stata sviluppata con esperti della cura della cute e visagisti, e sfrutta oltre 70.000 immagini di livello medico, per tutti i tipi di pele e carnagione, etnia, genere, e età. In base a questo set di dati, l'algoritmo AI è capace di stimare l'età dell'utente (e della sua pelle).",
      skin_health:
        "Forte della tecnologia di apprendimento profondo AI, il nostro algoritmo valuta la cute dell'utente e produce un punteggio di salute basato su tutte le problematiche della pelle che analizza.",
    },
    'zh-Hant': {
      skin_age:
        '我們的創新 AI 肌膚分析是與皮膚保養專家一同開發，使用超過 7 萬張橫跨各種膚質、人種、性別及年齡的醫療等級照片所訓練出的 AI 演算法能推測出使用者的肌膚年齡。',
      skin_health:
        '以 AI 深度學習技術支援的肌膚偵測演算法能依據多重肌膚狀況分析出使用者肌膚健康程度。',
      age_spot:
        'AI 演算法能智慧辨識不同程度的黑斑，並排除痣、臉部毛髮或其他誤判的非黑斑區域。',
      wrinkle:
        'AI 引擎能識別不同類型的皺紋，從淺層細紋到深層皺紋。此技術著重在皺紋最常出現的臉部區域。',
      texture:
        'AI 肌膚紋理演算法可檢測出用戶肌膚上的凹凸不平處，並提供對其肌膚平滑度的整體評估。',
      dark_circle_v2:
        'AI 演算法會檢測黑眼圈區域，有黑眼圈的區域會被清楚地標記，用戶也可以看到黑眼圈的嚴重程度。',
      redness:
        '肌膚泛紅可能由多種因素引起，AI 演算法能夠檢測出早期泛紅徵兆，預防泛紅問題擴大。',
      oiliness:
        'AI 演算法會將出油情況分為三個等級，並透過 AR 疊加顯示結果，幫助用戶辨識需要更多關注的肌膚區域。',
      eye_bag:
        '黑眼圈的 AI 演算法也能分析眼袋狀況，透過 AR 疊加覆蓋並標示出用戶眼袋大小和浮腫情形。',
      moisture:
        'AI 深度學習演算法能分析並檢測肌膚保濕程度，肌膚缺水的各種指標都能被偵測到。',
      droopy_upper_eyelid:
        'AI 演算法能分析至上眼瞼外側，並辨識出單眼/雙眼周圍的眼瞼下垂程度。',
      droopy_lower_eyelid:
        'AI 演算法能分析至下眼瞼外測，並辨識出單眼/雙眼周圍的眼瞼下垂程度。',
      firmness: 'AI 演算法能分析肌膚緊緻度並檢測下巴兩側皮膚的下垂程度。',
      radiance:
        'AI 演算法能分析整體肌膚的光澤和亮度，提供評估分數，幫助用戶改善膚況，更加容光煥發。',
      acne:
        'AI 演算法能進行 180 度的全臉分析，辨別三種類型的面皰：發炎性青春痘、白頭粉刺和黑頭粉刺。',
      pore:
        'AI 演算法能檢測出可見毛孔，並使用 AR 疊加顯示出它們的位置。毛孔分析將顯示用戶的膚況，以提供最佳治療方案。',
    },
    'zh-Hans': {
      acne:
        'AI 算法可以做 180 度的全脸分析，识别三种类型的痤疮：炎症性痤疮、白头粉刺和黑头粉刺。',
      skin_age:
        '我们的创新 AI 肌肤分析是与皮肤保养专家一同开发，使用超过 7 万张横跨各种肤质、人种、性别及年龄的医疗等级照片所训练出的 AI 算法，能推测出用户的肌肤年龄。',
      skin_health:
        '以 AI 深度学习技术支持的肌肤检测算法，能依据多种肌肤状况分析出使用者肌肤健康程度。',
      age_spot:
        'AI 算法可以识别不同程度的暗斑，并排除非暗斑区域，如皮肤痣、面部毛发或其他虚假数据。',
      wrinkle:
        'AI 可以识别各种类型的皱纹，从细纹到深皱纹。该技术专注于识别面部最易出现皱纹的区域。',
      texture:
        'AI 算法检测用户皮肤上的凸起和凹陷，并为用户提供对其皮肤光滑度的整体评估。',
      dark_circle_v2:
        'AI 算法扫描眼下区域的黑眼圈。黑眼圈区域被清晰地标记出来，用户可以看到黑眼圈的严重程度。',
      pore:
        'AI 算法可检测可见的毛孔，并通过 AR 叠加突出显示它们。毛孔分析显示用户的皮肤状况，以便制定最佳治疗方案。',
      radiance: 'AI 算法分析整体皮肤的清晰度、亮度和色斑，提供分数评估。',
      droopy_upper_eyelid:
        'AI 算法可检查上眼皮的外眼角，并确定单/双眼的下垂程度。',
      droopy_lower_eyelid:
        'AI 算法分析皮肤紧致度，并确定下眼睑两侧皮肤的下垂程度。',
      firmness: 'AI 算法分析皮肤紧致度，并确定下巴两侧皮肤的下垂程度。',
      eye_bag:
        '黑眼圈的 AI 算法也可分析眼袋状况。AR技术 叠加可确定眼袋状况的大小和浮肿程度。',
      moisture:
        '采用先进的人工智能深度学习算法分析和检测皮肤的含水量，识别皮肤缺水的各种指标。',
      oiliness:
        'AI 算法将出油情况分为三个等级，并使用 AR技术 叠加显示结果，帮助用户识别需要更多关注的皮肤区域。',
      redness:
        '皮肤发红可能是由各种因素所起，AI 算法可以在病情开始造成刺激之前发现细微的症状。',
    },
    pt: {
      skin_age:
        'Nossa inovadora tecnologia de pele foi desenvolvida com especialistas em cuidados com a pele e usa mais de 70.000 imagens de nível médico, em diferentes tipos de pele, etnias, gênero e faixas etárias. Com base nesse conhecimento e dados, o algoritmo de IA é capaz de estimar a idade da pele d@ usuári@.',
      skin_health:
        'Alimentado pela tecnologia de aprendizado profundo de IA, nosso algoritmo fornece uma pontuação de saúde para a pele d@ usuári@ com base nas pontuações das várias questões de pele que analisa.',
      age_spot:
        'O algoritmo de IA identifica diferentes níveis de manchas escuras e exclui áreas essas manchas, como verrugas na pele, pêlos faciais ou outras leituras falsas.',
      redness:
        'A vermelhidão da pele pode ser causada por uma variedade de fatores. O algoritmo de IA pode detectar sintomas sutis antes que a condição comece a causar irritação.',
      moisture:
        'Um sofisticado algoritmo de aprendizado profundo de IA analisa e detecta os níveis de hidratação da pele. Vários indicadores de desidratação da pele podem ser reconhecidos.',
      oiliness:
        'O algoritmo de IA categoriza a oleosidade em três níveis e mostra resultados usando sobreposições de RA para ajudar @s usuári@s a reconhecer áreas da pele que exigem mais atenção.',
      wrinkle:
        'A IA identifica vários tipos de rugas, desde linhas finas até vincos profundos. A tecnologia se concentra nas áreas faciais onde as rugas são mais comuns.',
      texture:
        'O algoritmo de IA para textura detecta inchaços e irregularidades na pele d@s usuári@s e oferece uma avaliação geral da suavidade da pele.',
      eye_bag:
        'O algoritmo de IA para olheiras também pode analisar a condição de bolsa ocular. As sobreposições de AR delineiam o tamanho e o inchaço da condição da bolsa ocular d@ usuári@.',
      firmness:
        'O algoritmo de IA analisa a firmeza da pele e identifica os níveis de flacidez da pele em ambos os lados do queixo.',
      droopy_upper_eyelid:
        'O algoritmo de IA examina o canto externo da pálpebra superior e identifica os níveis de flacidez ao redor para um/ambos os olhos.',
      droopy_lower_eyelid:
        'O algoritmo de IA examina o canto externo da pálpebra inferior e identifica os níveis de flacidez ao redor para um/ambos os olhos.',
      radiance:
        'O algoritmo de IA analisa a clareza e a luminosidade geral da pele para fornecer uma pontuação de avaliação, ajudando \n@ usuári@ a melhorar a aparência da pele.',
      acne:
        'O algoritmo pode fazer uma análise facial completa de 180 graus para identificar três tipos de acne: acne inflamatória, espinhas e cravos.',
      pore:
        'Algoritmo de IA detecta poros visíveis e os destaca com sobreposições RA. A análise de poros mostra a condição da pele d@ usuári@ para um plano de tratamento adequado.',
      dark_circle_v2:
        'O algoritmo de IA verifica a área sob os olhos em busca de olheiras. A área do círculo escuro está claramente marcada e @s usuári@s podem ver a gravidade dessa condição.',
    },
    ar: {
      skin_age:
        'طورت تقنيتنا المبتكرة للبشرة مع خبراء العناية بالبشرة وتستخدم أكثر من 70.000 صورة طبية لمختلف أنواع البشرة والأعراق والأجناس والفئات العمرية. بناءً على تلك المعرفة والبيانات ، فإن خوارزمية الذكاء الاصطناعي في التطبيق قادرة على تقدير عمر بشرة المستخدمة.',
      skin_health:
        'مدعومًا بتقنية التعلم العميق بالذكاء الاصطناعي حيث تمنح الخوارزمية درجة صحية لجلد المستخدمة بناءً على درجة مشاكل البشرة المتعددة التي يحللها.',
      age_spot:
        'تحدد خوارزمية الذكاء الاصطناعي في التطبيق المستويات المختلفة من البقع الداكنة وتستبعد المناطق غير المعنية مثل شامة الجلد أو شعر الوجه أو أي قراءات خاطئة أخرى.',
      wrinkle:
        'يحدد الذكاء الاصطناعي أنواعًا مختلفة من التجاعيد ، بداية من الخطوط الدقيقة إلى التجاعيد العميقة. تركز التقنية على مناطق الوجه حيث تكون التجاعيد أكثر انتشارًا.',
      texture:
        'تكتشف خوارزمية الذكاء الاصطناعي الخاصة بالملمس النتوءات والخدوش على بشرة المستخدمين وتقدم للمستخدمين تقييمًا شاملاً لنعومة بشرتهم.',
      eye_bag:
        'يمكن لخوارزمية الذكاء الاصطناعي للدوائر المظلمة أيضًا تحليل حالة الأكياس المنتفخة تحت العين. يحدد التطبيق طبقة حجم وانتفاخ حالة الأكياس المنتفخة تحت العين.',
      firmness:
        'تحلل خوارزمية الذكاء الاصطناعي متانة الجلد وتحدد مستويات ترهل الجلد على جانبي الذقن.',
      droopy_upper_eyelid:
        'تفحص خوارزمية الذكاء الاصطناعي الزاوية الخارجية للجفن العلوي وتحديد مستويات الترهل حوله لعين واحدة / كلتا العينين.',
      droopy_lower_eyelid:
        'تفحص خوارزمية الذكاء الاصطناعي الزاوية الخارجية للجفن السفلي وتحديد مستويات الترهل حوله لعين واحدة / كلتا العينين.',
      radiance:
        'تحلل خوارزمية الذكاء الاصطناعي وضوح البشرة وإشراقها بشكل عام لتقدم درجة تقييم، مما يساعد المستخدم على تحسين مظهر البشرة المتلألأ.',
      acne:
        'تستطيع الخوارزمية إجراء تحليل كامل للوجه 180 درجة بغرض تحديد ثلاثة أنواع من حب الشباب: حب الشباب الالتهابي ، والرؤوس البيضاء ، والرؤوس السوداء.',
      pore:
        'تكتشف خوارزمية الذكاء الاصطناعي المسام المرئية وتبرزها بشكل طبقات بواسطة الواقع المعزز. يوضح تحليل المسام حالة بشرة المستخدمة للحصول على أفضل خطة علاج.',
      dark_circle_v2:
        'تقوم خوارزمية الذكاء الاصطناعي بمسح منطقة أسفل العين بحثًا عن الهالات المظلمة. تم تحديد منطقة الدائرة المظلمة بوضوح ويمكن للمستخدمين رؤية مدى خطورة هذه الحالة.',
      redness:
        'قد يحدث احمرار الجلد بسبب مجموعة متنوعة من العوامل. يمكن لخوارزمية الذكاء الاصطناعي في التطبيق اكتشاف الأعراض الدقيقة قبل بدء حدوث سبب التهيج.',
      moisture:
        'تحلل خوارزمية التعلم العميق المتطورة في التطبيق وتكتشف مستويات ترطيب البشرة. حيث تتعرف على مؤشرات مختلفة لجفاف الجلد.',
      oiliness:
        'تصنف خوارزمية الذكاء الاصطناعي البشرة الدهنية إلى ثلاثة مستويات وتظهر النتائج باستخدام تراكبات الواقع المعزز لمساعدة المستخدمين على التعرف على مناطق البشرة التي تتطلب مزيدًا من الاهتمام.',
    },
  },
  HdDetectionDescriptionContent: {
    en: {
      hd_spot:
        'The AI algorithm identifies different levels of dark spots and excludes non-dark-spot areas like skin mole, facial hair, or other false readings.',
      hd_redness:
        'Skin redness can be caused by a variety of factors. The AI algorithm can detect subtle symptoms before the condition starts to cause irritation.',
      hd_moisture:
        'A sophisticated AI deep learning algorithm analyzes and detects skin hydration levels. Various indicators of skin dehydration are recognized.',
      hd_oiliness:
        'AI algorithm categorizes oiliness into three levels and shows results using AR overlays to help users recognize skin areas requiring more attention.',
      hd_wrinkle:
        'AI identifies various types of wrinkles, from fine lines to deep creases. The technology focuses on facial areas where the wrinkles are most common.',
      hd_wrinkle_forehead:
        'AI algorithm detects fine lines and deep wrinkles on the forehead, showing their severity to help users recognize areas needing attention for smoother skin.',
      hd_wrinkle_glabellar:
        'AI detects wrinkles between the eyebrows, assessing severity and helping users take steps toward reducing lines.',
      hd_wrinkle_crowfeet:
        'AI algorithm detects wrinkles at the outer corners of the eyes, showing their depth and severity to help users focus on this common wrinkle zone.',
      hd_wrinkle_periocular:
        'AI algorithm detects the fine lines and wrinkles beneath the eyes, providing a severity score to help users monitor the condition of their under-eye area',
      hd_wrinkle_nasolabial:
        'AI algorithm detects wrinkles in the nasolabial folds, providing a severity score to help users understand the depth and prominence of these wrinkles.',
      hd_wrinkle_marionette:
        'AI algorithm detects wrinkles in the marionette lines, providing a severity score to help users assess the depth and visibility of these wrinkles.',
      hd_texture:
        'AI algorithm for texture detects bumps and dents on users’ skin and offers users an overall assessment of their skin smoothness.',
      hd_eye_bag:
        'AI algorithm for dark circles can also analyze eye bag condition. AR overlays delineate the size and the puffiness of the user’s eye bag condition.',
      hd_firmness:
        'AI algorithm analyzes skin firmness and identifies levels of skin sagging on both sides of the chin.',
      hd_droopy_upper_eyelid:
        'AI algorithm examines the outer corner of the upper eyelid and identifies levels of sagging around it for one/both eyes.',
      hd_droopy_lower_eyelid:
        'AI algorithm examines the outer corner of the lower eyelid and identifies levels of sagging around it for one/both eyes.',
      hd_radiance:
        'AI algorithm analyzes overall skin clarity and luminosity to provide an assessment score, helping user to improve the appearance of radiant skin.',
      hd_acne:
        'The algorithm can do a 180-degree full face analysis to identify three types of acne: inflammatory acne, whiteheads, and blackheads.',
      hd_pore:
        "AI algorithm detects visible pores and highlights them with AR overlays. Pore analysis shows the condition of user's skin for the best treatment plan.",
      hd_pore_forehead:
        'AI algorithm detects visible pores on the forehead, providing a severity score to help users recognize pore issues in this area.',
      hd_pore_nose:
        'AI algorithm identifies visible pores on the nose, showing their severity and helping users recognize the condition of pores on this common trouble area.',
      hd_pore_cheek:
        'AI algorithm analyzes visible pores on the cheeks, offering a severity score to help users evaluate the condition of pores in this region.',
      hd_dark_circle:
        'AI algorithm scans the under-eye area for dark circles. The dark circle area is clearly marked and users can see the severity of this condition.',
      hd_teartrough:
        'AI algorithm detects the tear trough area under the eyes and highlights the region, displaying the severity of the condition for user review.',
      skin_age:
        "Our innovative skin technology was developed with skincare experts and uses over 70,000 medical-grade images, across different skin types, ethnicities, gender, and age groups. Based on that knowledge and data, the AI algorithm is able to estimate the age of the user's skin.",
      skin_health:
        "Powered by AI deep learning technology, our algorithm gives a health score to the user's skin based on the scores of the multiple skin concerns it analyzes.",
      normal_non_sensitive:
        'Normal skin is a well-balanced skin type that is neither too oily nor too dry. It has a smooth and even texture with small pores, and a healthy complexion. People with normal skin do not typically experience excessive oiliness or dryness, and they rarely have blemishes or breakouts.',
      dry_non_sensitive:
        'Dry skin type is a skin condition characterized by a lack of moisture and oil in the skin, and it can be caused by a variety of factors, including genetics, aging, weather conditions, and certain medications.',
      oily_non_sensitive:
        "Oily skin is a skin type characterized by excess production of sebum, the natural oil produced by the skin's sebaceous glands. This can result in a shiny or greasy appearance, enlarged pores, and a tendency towards acne breakouts. People with an oily skin type should use oil-free or non-pore-clogging skincare products.",
      combination_non_sensitive:
        'Combination skin type is a skin condition characterized by having both oily and dry areas on the face. Typically, the T-zone (forehead, nose, and chin) is oily while the cheeks and other areas may be dry or normal.',
      normal_sensitive:
        'Sensitive skin is a skin type that is easily irritated by various external factors such as sun exposure, environmental pollutants, certain skincare products, and even stress. People with sensitive skin may experience symptoms such as redness, itching, dryness, flakiness, or a burning sensation when exposed to these triggers.',
      dry_sensitive:
        'Dry and sensitive skin type is characterized by a lack of natural oils and moisture in the skin. Dry skin tends to have smaller pores and can show signs of premature aging, such as fine lines and wrinkles. Sensitive skin is easily irritated by external factors, such as fragrance, alcohol, and certain ingredients in skincare products.',
      oily_sensitive:
        'Oily and sensitive skin is a skin type that is characterized by excess oil production and a tendency towards inflammation and irritation. Skin typically has a shiny or greasy appearance, enlarged pores, and a tendency towards acne and breakouts. At the same time, the skin is also sensitive and easily irritated by environmental factors.',
      combination_sensitive:
        'Combination and sensitive skin is a skin type that exhibits characteristics of both combination and sensitive skin. Combination skin is characterized by having both oily and dry areas, while sensitive skin is easily irritated by external factors.',
    },
    fr: {
      hd_spot:
        "L'algorithme de l'analyseur de peau identifie l’intensité de taches et exclut ce qui ne relève pas de la tache comme les grains de beauté, les poils ou autres.",
      hd_redness:
        "Les rougeurs ont des causes variées. L'algorithme en IA perçoit les symptômes les plus subtiles avant l'arrivée des premières irritations.",
      hd_moisture:
        "Un algorithme performant de Deep Learning détecte le niveau d'hydratation de la peau. Plusieurs signaux de déshydratation sont détectés.",
      hd_oiliness:
        'Notre algorithme en IA détecte 3 niveaux de brillances et les visualise par superposition grâce à la RA qui délimite les zones concernées.',
      hd_wrinkle:
        "L'IA identifie les différentes types de rides (des ridules aux rides profondes) et s'attarde sur les zones les plus fréquemment touchées.",
      hd_wrinkle_forehead:
        'L’algorithme d’IA détecte les ridules et les rides profondes sur le front et indique leur gravité afin d’aider les utilisatrices à reconnaître les zones nécessitant une attention particulière pour une peau plus lisse.',
      hd_wrinkle_glabellar:
        'L’IA détecte les rides entre les sourcils, évalue leur gravité et aide les utilisatrices à prendre des mesures pour les atténuer.',
      hd_wrinkle_crowfeet:
        'L’algorithme d’IA détecte les rides aux coins externes des yeux, en indiquant leur profondeur et leur gravité pour aider les utilisatrices à se concentrer sur cette zone de rides courante.',
      hd_wrinkle_periocular:
        'L’algorithme d’IA détecte les rides et ridules sous les yeux et fournit un score de gravité pour aider les utilisatrices à surveiller l’état de leur zone sous les yeux.',
      hd_wrinkle_nasolabial:
        'L’algorithme d’IA détecte les rides dans les sillons nasogéniens et fournit un score de sévérité pour aider les utilisatrices à comprendre la profondeur et la proéminence de ces rides.',
      hd_wrinkle_marionette:
        'L’algorithme d’IA détecte les rides dans les lignes de marionnettes et fournit un score de gravité pour aider les utilisatrices à évaluer la profondeur et la visibilité de ces rides.',
      hd_texture:
        'Notre algorithme en IA détecte les irrégularités de la peau et évalue à quel point celle-ci est lisse.',
      hd_eye_bag:
        "L'algorithme en IA analyse également les poches sous les yeux. La RA permet de délimiter la taille et le côté gonflé de la poche.",
      hd_firmness:
        "Notre algorithme en IA évalue l'affaissement de la peau au niveau des paupières supérieures, inférieures et autour du menton.",
      hd_droopy_upper_eyelid:
        "L'algorithme en IA examine le coin extérieur de la paupière supérieure afin d'identifier l'affaissement à ce niveau.",
      hd_droopy_lower_eyelid:
        "L'algorithme en IA examine le coin extérieur de la paupière inférieure afin d'identifier l'affaissement à ce niveau.",
      hd_radiance:
        "L'algorithme en IA évalue la clareté et la luminosité de la peau afin d'aider l'utilisateur à améliorer l'apparence de sa peau.",
      hd_acne:
        "Notre algorithme analyse la peau de visage à 180° pour identifier 3 types d'acné : l'acné inflammatoire, les points blancs et les points noirs.",
      hd_pore:
        "L'algorithme en IA détecte les pores et les montre en RA ce qui permet de proposer le meilleur traitement adapté à l'état de la peau.",
      hd_pore_forehead:
        'L’algorithme d’IA détecte les pores visibles sur le front et fournit un score de gravité pour aider les utilisatrices à reconnaître les problèmes de pores dans cette zone.',
      hd_pore_nose:
        'L’algorithme d’IA identifie les pores visibles sur le nez, en montrant leur gravité et en aidant les utilisatrices à reconnaître l’état des pores sur cette zone à problèmes courante.',
      hd_pore_cheek:
        'L’algorithme d’IA analyse les pores visibles sur les joues et propose un score de gravité pour aider les utilisatrices à évaluer l’état des pores dans cette région.',
      hd_dark_circle:
        "L'algorithme en IA identifie les cernes. La zone sombre est clairement représentée et l'utilisateur peut évaluer la sévérité des cernes.",
      hd_teartrough:
        'L’algorithme d’IA détecte la zone de la vallée des larmes sous les yeux et la met en évidence, affichant la gravité de l’état pour que l’utilisatrice puisse l’évaluer.',
      skin_age:
        "Notre technologie innovante a été développée avec l'aide d'experts de la peau. Elle utilise plus de 70 000 images évaluées médicalement et intégrant différents types de peau, de sexes et de tranches d'âge. En s'appuyant sur ces données, l'algorithme en IA est capable de déterminer un âge estimatif de la peau de l'utilisateur.",
      skin_health:
        "Grâce à la technologie de deep learning en IA, notre algorithme donne un score de santé pour la peau de l'utilisateur en s'appuyant sur le score des multiples problèmes de peau analysés.",
      normal_non_sensitive:
        "La peau normale est généralement considérée comme nécessitant peu d'entretien, mais nécessite tout de même des soins de base pour la maintenir hydratée et en bonne santé. Utilisez un nettoyant doux deux fois par jour et appliquez quotidiennement une crème hydratante légère.",
      dry_non_sensitive:
        "Les personnes ayant la peau sèche peuvent avoir besoin d'utiliser régulièrement des crèmes hydratantes pour éviter davantage de sécheresse. Utilisez un nettoyant doux et hydratant pour éviter d'ôter les huiles naturelles de votre peau.",
      oily_non_sensitive:
        "Recherchez un nettoyant formulé pour les peaux grasses et contenant des ingrédients comme l'acide salicylique ou le peroxyde de benzoyle, qui peuvent aider à contrôler la production de sébum. Utilisez également une crème hydratante légère sans huile.",
      combination_non_sensitive:
        'Le type de peau mixte peut nécessiter une routine de soin qui traite à la fois les zones grasses et sèches. Hydrater quotidiennement pour garder la peau hydratée et prévenir le dessèchement et la desquamation.',
      normal_sensitive:
        "Le type de peau sensible nécessite des soins et une attention supplémentaires pour éviter d'autres irritations ou dommages. Utilisez des produits doux et sans parfum et testez les nouveaux produits pour voir si vous avez des effets indésirables.",
      dry_sensitive:
        "Il est essentiel d'utiliser des soins doux et hydratants pour aider à apaiser et protéger les peaux sèches et sensibles. Appliquez quotidiennement une crème hydratante sur votre visage et votre corps, surtout après la douche ou le bain.",
      oily_sensitive:
        "Les personnes ayant la peau grasse et sensible doivent utiliser des produits de soin doux et éviter les ingrédients agressifs ou abrasifs qui peuvent augmenter l'inflammation ou déclencher des éruptions cutanées.",
      combination_sensitive:
        "Il est important de choisir des produits de soin doux, hypoallergéniques et formulés spécifiquement pour les peaux sensibles afin d'éviter toute irritation supplémentaire. Utilisez un nettoyant doux au pH équilibré et recherchez une crème hydratante légère.",
    },
    ja: {
      hd_spot:
        'AI アルゴリズムは、異なるレベルのシミを識別し、ほくろ、うぶ毛、または誤認など、シミではないものを除外します。',
      hd_redness:
        '肌が赤くなるのにはさまざまな原因があります。AI アルゴリズムは、症状が悪化する前に微妙な状態を検出できます。',
      hd_moisture:
        '高性能の AI ディープラーニング アルゴリズムによる分析で肌の水分レベルを検出します。さまざまな水分不足状態が分かります。',
      hd_oiliness:
        'AIアルゴリズムは油分を3つのレベルに分類し、AR オーバーレイで表示することで、ユーザーに注意エリアを分かり易く提示します。',
      hd_wrinkle:
        'AI は細いシワから深いシワまで、あらゆるシワを識別します。この技術は、シワが最も気になる顔の部分を中心に検出します。',
      hd_wrinkle_forehead:
        'AIのアルゴリズムが、ひたいの細い筋や深いしわを見つけて評価し、滑らかなお肌のために注意すべき部分を見つけるお手伝いをします。',
      hd_wrinkle_glabellar:
        'Aiが眉毛と眉毛の間のシワを見つけてその深さと程度を示し、それを軽減するお手入れができるようにします。',
      hd_wrinkle_crowfeet:
        'AIのアルゴリズムが目尻のシワを見つけ、その深さと程度を示し、シワができやすいこの部分への配慮を促します。',
      hd_wrinkle_periocular:
        'AIのアルゴリズムが目の下の細い筋や深いしわを見つけ、目の下の部分の状態をご自分で気をつけられるよう点数をつけます。',
      hd_wrinkle_nasolabial:
        'AIのアルゴリズムがほうれい線のシワを見つけ、その深さと目立ちやすやすさを認識できるように点数をつけます。',
      hd_wrinkle_marionette:
        'AIのアルゴリズムがマリオネットラインのシワを見つけ、その深さと目立ちやすさを評価できるように点数をつけます。',
      hd_texture:
        'AI アルゴリズムは、ユーザーの肌の凹凸を検出し、ユーザーの肌の全体的な滑らかさを評価します。',
      hd_eye_bag:
        'AI アルゴリズムは、目袋の状態を分析することができます。AR オーバーレイで、ユーザーの目袋の大きさとむくみ状態を示します。',
      hd_firmness:
        'AI アルゴリズムは、肌のハリを分析し、顎の両側のたるみ状態を識別します。',
      hd_droopy_upper_eyelid:
        'AI アルゴリズムは、上まぶたの目尻を調べ、片眼/両眼の周りのたるみ状態を識別します。',
      hd_droopy_lower_eyelid:
        'AI アルゴリズムは、下まぶたの目尻を調べ、片眼/両眼の周りのたるみ状態を識別します。',
      hd_radiance:
        'AI アルゴリズムは、全体的な肌の透明度、明るさ、変色を分析して、スコアで評価します。',
      hd_acne:
        'このアルゴリズムは、180度のフルフェイス分析を行い、炎症性吹き出物、白ニキビ、黒ずみという3種類のニキビを特定します。',
      hd_pore:
        'AI アルゴリズムは目立つ毛穴を検出し、AR オーバーレイでハイライトします。.毛穴分析は、ユーザーの肌の状態を示し、トリートメントプランに役立ちます。',
      hd_pore_forehead:
        'AIのアルゴリズムがひたいにある目立ちやすい毛穴を見つけ、このエリアの毛穴について認識できるように点数をつけます。',
      hd_pore_nose:
        'AIのアルゴリズムが鼻にある目立ちやすい毛穴を見つけ、問題が起きやすいこのエリアの毛穴について認識できるように点数をつけます。',
      hd_pore_cheek:
        'AIのアルゴリズムが頬にある目立ちやすい毛穴を見つけ、この範囲の毛穴について認識できるように点数をつけます。',
      hd_dark_circle:
        'AI アルゴリズムは、目の下のエリアをスキャンしてクマを検出します。クマは分かり易くマークが付けられるため、ユーザーは状態を明確に把握できます。',
      hd_teartrough:
        'AIのアルゴリズムが目の下のクマを見つけ、その部分をハイライトし、ユーザー評価用に今の状態の評価を表示します。',
      skin_age:
        'スキンケアの専門家とともに開発したこの肌技術は、さまざまな肌タイプ、民族、性別、年齢層にわたる、7万枚以上の医療用画像を使用しています。その知識とデータをもとに、AIアルゴリズムがユーザーの肌年齢を推定しています。',
      skin_health:
        'AIのディープラーニング技術を搭載し、アルゴリズムが分析した複数の肌悩みのスコアから、ユーザーの肌スコアを解析します。',
      normal_non_sensitive:
        'ノーマル肌は、オイリーすぎず、乾燥しすぎず、バランスの良い肌質です。毛穴が小さく、なめらかで均一な質感で、健康的な肌色になるのが特徴です。ノーマル肌の人は、通常、過剰な油分や乾燥を感じることはなく、シミや吹き出物ができることもほとんどありません。',
      dry_non_sensitive:
        '乾燥肌タイプは、肌の水分や油分が不足していることが特徴です。遺伝、加齢、天候、特定の薬など、さまざまな要因で引き起こされます。',
      oily_non_sensitive:
        'オイリー肌とは、肌の皮脂腺から分泌される皮脂の分泌が過剰である肌タイプのことです。テカリや脂っぽさが出たり、毛穴が大きくなったり、ニキビができやすくなったりします。オイリー肌タイプの人は、オイルフリーや毛穴を詰まらせないスキンケア用品を使うのがおすすめです。',
      combination_non_sensitive:
        '混合肌とは、顔に脂っぽい部分と乾燥した部分の両方がある肌状態のことです。一般的に、Tゾーン（額、鼻、あご）はオイリーで、頬などは乾燥またはノーマルであることが多いようです。',
      normal_sensitive:
        '敏感肌は、日焼け、環境汚染物質、特定のスキンケア製品、さらにはストレスなど、さまざまな外的要因によって刺激を受けやすい肌タイプです。敏感肌の人は、これらの刺激にさらされると、赤み、かゆみ、乾燥、かさつき、ヒリヒリ感などの症状が出ることがあります。',
      dry_sensitive:
        '乾燥肌・敏感肌タイプは、肌本来の油分や水分が不足していることが特徴です。乾燥した肌は毛穴が小さくなりがちで、小じわなどの初期老化サインを示すことがあります。敏感肌は、香料やアルコール、スキンケア製品に含まれる特定の成分など、外的要因によって刺激を受けやすい状態です。',
      oily_sensitive:
        'オイリー肌・敏感肌タイプは、過剰な皮脂分泌と炎症傾向が特徴です。一般的に、肌はテカリや脂っぽさを感じ、毛穴が大きくなり、ニキビや吹き出物ができやすい傾向にあります。環境要因によって刺激を受けやすい敏感肌でもあります。',
      combination_sensitive:
        '混合肌と敏感肌の両方の特徴を示す肌タイプのことです。混合肌は、脂っぽい部分と乾燥した部分の両方があるのが特徴で、敏感肌は外的要因で刺激を受けやすいのが特徴です。',
    },
    ko: {
      hd_spot:
        'AI 알고리즘이 다양한 잡티를 식별하며, 점이나 수염, 기타 잡티가 아닌 것을 잡티로 잘못 판독하지 않도록 합니다.',
      hd_redness:
        '피부 홍조는 다양한 이유로 발생할 수 있습니다. 당사의 AI 알고리즘은 피부 문제가 시작되기 전 발생하는 미묘한 증상까지도 감지합니다.',
      hd_moisture:
        '정교한 AI 딥러닝 알고리즘이 피부 수분기를 분석하고 감지합니다. 피부 건조와 관련된 다양한 지표를 인식하여 피부 타입 진단을 도출합니다.',
      hd_oiliness:
        'AI 알고리즘이 피부의 유분기를 측정하여 AR을 통해 피부 고민을 시각화하고 피부 타입 진단을 도출합니다.',
      hd_wrinkle:
        'AI가 잔주름부터 깊은 주름까지 다양한 유형의 주름을 식별합니다. 해당 기술은 주름이 일반적으로 많이 나타나는 부위에 더욱 집중합니다.',
      hd_wrinkle_forehead:
        'AI 알고리즘이 이마의 잔주름과 깊은 주름을 감지하여 그 심각도를 사용자에게 표시합니다. 이를 통해 매끄러운 피부를 위해 집중 관리가 필요한 부위를 인지할 수 있도록 도와줍니다.',
      hd_wrinkle_glabellar:
        'AI가 미간 주름을 감지하여 심각도를 평가하고, 사용자에게 주름 개선을 위한 관리 방법을 제안합니다.',
      hd_wrinkle_crowfeet:
        'AI 알고리즘이 눈가 외곽의 주름을 감지하여 깊이와 심각도를 표시합니다. 이를 통해 사용자가 이 흔한 주름 부위에 집중하여 관리할 수 있도록 도와줍니다.',
      hd_wrinkle_periocular:
        'AI 알고리즘이 눈 밑의 잔주름과 주름을 감지하여 심각도 점수를 제공합니다. 이를 통해 사용자가 눈가 상태를 모니터링하고 적절히 관리할 수 있도록 돕습니다.',
      hd_wrinkle_nasolabial:
        'AI 알고리즘이 코입술주름을 감지하여 깊이와 두드러짐을 이해할 수 있도록 심각도 점수를 제공합니다. 이를 통해 사용자가 해당 부위를 효과적으로 관리할 수 있도록 돕습니다.',
      hd_wrinkle_marionette:
        'AI 알고리즘이 입옆팔자주름을 감지하여 깊이와 눈에 띄는 정도를 평가할 수 있도록 심각도 점수를 제공합니다. 이를 통해 사용자가 해당 부위를 보다 효과적으로 관리할 수 있도록 돕습니다.',
      hd_texture:
        'AI 알고리즘이 요철을 감지하고 피부의 매끄러운 정도를 전반적으로 평가하여 피부 타입을 진단합니다.',
      hd_eye_bag:
        '다크서클에 사용되는 알고리즘이 눈 밑 지방 상태도 분석합니다. AR 오버레이가 개인의 눈 밑 지방 상태의 크기와 붓기를 상세하게 묘사하여 표시합니다.',
      hd_firmness:
        'AI 알고리즘이 피부 탄력을 분석하고 턱 양쪽의 피부 처짐 정도를 확인합니다.',
      hd_droopy_upper_eyelid:
        'AI 알고리즘이 위 눈꺼풀의 바깥쪽 모서리를 분석하여 한쪽 또는 양쪽 눈의 눈꺼풀 주위에 처지는 정도를 식별합니다.',
      hd_droopy_lower_eyelid:
        'AI 알고리즘이 아랫눈꺼풀의 바깥쪽 모서리를 분석하여 한쪽 또는 양쪽 눈의 눈꺼풀 주위에 처지는 정도를 식별합니다.',
      hd_radiance:
        'AI 알고리즘이 전반적인 피부 투명도, 광채 및 변색을 분석하여 평가 점수를 제공합니다.',
      hd_acne:
        '해당 알고리즘은 얼굴 전체를 180도 분석하여 염증성 여드름, 화이트헤드, 블랙헤드와 같은 세 가지 여드름 타입을 식별합니다.',
      hd_pore:
        'AI 알고리즘이 피부 모공을 감지하고 AR 오버레이를 통해 모공을 강조합니다. 피부 상태를 시각화하여 효과적인 피부 타입 진단을 도출합니다.',
      hd_pore_forehead:
        'AI 알고리즘이 이마에서 눈에 띄는 모공을 감지하여 심각도 점수를 제공합니다. 이를 통해 사용자가 해당 부위의 모공 상태를 인지하고 관리할 수 있도록 돕습니다.',
      hd_pore_nose:
        'AI 알고리즘이 코에서 눈에 띄는 모공을 감지하여 심각도를 표시합니다. 이를 통해 사용자가 이 흔한 고민 부위의 모공 상태를 인식하고 관리할 수 있도록 돕습니다.',
      hd_pore_cheek:
        'AI 알고리즘이 볼에서 눈에 띄는 모공을 분석하여 심각도 점수를 제공합니다. 이를 통해 사용자가 이 부위의 모공 상태를 평가하고 적절한 관리를 할 수 있도록 돕습니다.',
      hd_dark_circle:
        'AI 알고리즘이 눈 아랫부분을 스캔하여 다크서클을 확인합니다. AR을 통해 피부 고민 부위가 명확하게 표시되어 상태의 심각도를 볼 수 있습니다.',
      hd_teartrough:
        'AI 알고리즘이 눈 밑의 눈물고랑 부위를 감지하고 해당 영역을 강조하여 사용자에게 상태의 심각도를 표시해 줍니다.',
      skin_age:
        '당사의 혁신적인 피부 기술은 스킨케어 전문가와 함께 개발되었으며 다양한 피부 타입, 인종, 성별 및 연령대에 걸쳐 70,000개 이상의 의료 등급 이미지를 사용합니다. 이러한 데이터를 기반으로 개발된 AI 알고리즘이 사용자의 피부 나이를 추정합니다.',
      skin_health:
        'AI 딥 러닝 기술을 기반으로 하는 당사의 알고리즘은 여러 피부 문제의 분석 점수를 토대로 사용자의 피부 건강 점수를 부여합니다.',
      normal_non_sensitive:
        '중성 피부는 너무 지성도 건성도 아닌 균형 잡힌 피부 타입입니다. 작은 모공으로 매끄럽고 균일한 피부결과 건강한 안색을 선사합니다. 중성 피부를 가진 사람들은 일반적으로 과도한 유분이나 건조함을 경험하지 않으며 잡티나 트러블이 거의 없습니다.',
      dry_non_sensitive:
        '건성 피부 타입은 피부에 수분과 유분이 부족한 것이 특징인 피부 상태로 유전, 노화, 기상 조건, 특정 약물 등 다양한 요인에 의해 발생할 수 있습니다.',
      oily_non_sensitive:
        '지성 피부는 피지의 과잉 생산을 특징으로 하는 피부 유형입니다. 이로 인해 번들거리고 유분이 많은 피부, 모공 확대, 여드름과 같은 경향이 생길 수 있습니다. 지성 피부 타입을 가진 사람은 유분이 없거나 모공을 막지 않는 스킨케어 제품을 사용해야 합니다.',
      combination_non_sensitive:
        '복합성 피부 타입은 얼굴에 지성 부위와 건성 부위가 동시에 나타나는 피부입니다. 일반적으로 T존(이마, 코, 턱)은 기름기가 많고 볼과 기타 부위는 건조하거나 중성일 수 있습니다.',
      normal_sensitive:
        '민감성 피부는 태양 노출, 환경 오염 물질, 특정 스킨 케어 제품, 심지어 스트레스와 같은 다양한 외부 요인에 쉽게 자극을 받는 피부 타입입니다. 민감한 피부를 가진 사람들은 이러한 유발 요인에 노출될 때 발적, 가려움증, 건조, 벗겨짐 또는 작열감과 같은 증상을 경험할 수 있습니다.',
      dry_sensitive:
        '건조하고 민감한 피부 타입은 피부에 유분과 수분이 부족한 것이 특징입니다. 건성 피부는 모공이 작은 경향이 있으며 잔주름 및 주름과 같은 조기 노화의 징후를 보일 수 있습니다. 민감한 피부는 향, 알코올과 같은 스킨케어 제품의 특정 성분 및 외부 요인에 쉽게 자극을 받습니다.',
      oily_sensitive:
        '지성 및 민감성 피부는 과도한 피지 생성과 염증 및 자극 경향이 특징인 피부 유형입니다. 피부는 일반적으로 윤기가 나거나 기름기가 많고 모공이 넓어지며 여드름과 트러블이 생기는 경향이 있습니다. 동시에 피부는 민감하고 환경적 요인에 의해 쉽게 자극을 받습니다.',
      combination_sensitive:
        '복합성 및 민감성 피부의 특성을 모두 나타내는 피부 타입입니다. 복합성 피부는 지성 부위와 건성 부위가 모두 있는 것이 특징이며, 민감성 피부는 외부 요인에 쉽게 자극을 받습니다.',
    },
    de: {
      hd_spot:
        'Der KI-Algorithmus identifiziert verschiedene Intensitäten dunkler Flecken und schließt Bereich ohne dunkle Flecken wie Muttermale, Gesichtsbehaarung oder andere falsche Werte effektiv aus.',
      hd_redness:
        'Rötungen der Haut können durch verschiedenste Faktoren hervorgerufen werden. Der KI-Algorithmus kann bereits leichte Symptome erkennen, bevor der Zustand zu Reizungen führt.',
      hd_moisture:
        'Ein raffinierter KI-Deep Learning Algorithmus analysiert und erkennt die Hydrierungsstufen der Haut. Es werden verschiedene Anzeichen der Dehydrierung der Haut erkannt.',
      hd_oiliness:
        'Der KI-Algorithmus kategorisiert die Fettigkeit der Haut in drei Stufen und zeigt die Ergebnisse anhand unserer intuitiven AR-Überlappungen auf, um den Nutzer:innen zu helfen, spezifische Hautbereiche zu erkennen, die mehr Aufmerksamkeit brauchen.',
      hd_wrinkle:
        'Der KI-Algorithmus identifiziert diverse Arten von Falten – von feinen Fältchen bis hin zu tiefen Falten. Die Technologie konzentriert sich auf Gesichtsbereiche, wo Falten am häufigsten auftreten.',
      hd_wrinkle_forehead:
        'Der KI-Algorithmus erkennt feine Linien und tiefe Falten auf der Stirn und zeigt deren Schweregrad an, um den Benutzern zu helfen, die Bereiche zu erkennen, die für eine glattere Haut Aufmerksamkeit benötigen.',
      hd_wrinkle_glabellar:
        'Die KI erkennt Falten zwischen den Augenbrauen, bewertet den Schweregrad und hilft den Benutzern, Schritte zur Reduzierung der Falten zu unternehmen.',
      hd_wrinkle_crowfeet:
        'Der KI-Algorithmus erkennt Falten an den äußeren Augenwinkeln und zeigt deren Tiefe und Schweregrad an, damit sich die Benutzer auf diese häufige Faltenzone konzentrieren können.',
      hd_wrinkle_periocular:
        'Der KI-Algorithmus erkennt die feinen Linien und Falten unter den Augen und gibt einen Schweregrad an, damit die Benutzer den Zustand ihrer Augenpartie überwachen können',
      hd_wrinkle_nasolabial:
        'Der KI-Algorithmus erkennt Falten in den Nasolabialfalten und gibt einen Schweregrad an, der dem Benutzer hilft, die Tiefe und Ausprägung dieser Falten zu verstehen.',
      hd_wrinkle_marionette:
        'Der KI-Algorithmus erkennt Falten in den Marionettenfalten und gibt einen Schweregrad an, der den Benutzern hilft, die Tiefe und Sichtbarkeit dieser Falten zu beurteilen.',
      hd_texture:
        'Der KI-Algorithmus für Textur erkennt Knötchen und Vertiefungen auf der Haut der Nutzerin/des Nutzers und stellt eine Gesamtbeurteilung der Hautglätte bereit.',
      hd_eye_bag:
        'Der KI-Algorithmus, den wir für Augenringe anwenden, kann auch Tränensäcke erkennen. AR-Überlappungen zeichnen die Größe und die Schwellung der Tränensäcke einer Person nach.',
      hd_firmness:
        'Der KI-Alogrithnus analysiert die Festigkeit der Haut und identifiziert, wie sehr die Haut bereits hängt.',
      hd_droopy_upper_eyelid:
        'Der KI-Algorithmus untersucht die äußere Ecke des oberen Augenlids und stellt fest, wie sehr die Haut darum herum an einem/beiden Auge/n hängt.',
      hd_droopy_lower_eyelid:
        'Der KI-Algorithmus untersucht die äußere Ecke des unteren Augenlids und stellt fest, wie sehr die Haut darum herum an einem/beiden Auge/n hängt.',
      hd_radiance:
        'Der KI-Algorithmus analysiert insgesamt die Klarheit der Haut, das Strahlen und den Farbverlust, um eine Beurteilung zu ermöglichen.',
      hd_acne:
        'DDer Algorithmus kann eine 180°-Vollgesichtsanalyse durchführen, um drei Arten von Akne zu entdecken: Entzündliche Akne, Pickel und Mitesser.',
      hd_pore:
        'Der KI-Algorithmus entdeckt sichtbare Poren und betont sie mit AR-Überlagerungen. Porenanalyse zeigt den Zustand der Haut einer Nutzerin/eines Nutzers für den besten Behandlungsplan.',
      hd_pore_forehead:
        'Der KI-Algorithmus erkennt sichtbare Poren auf der Stirn und gibt einen Schweregrad an, der den Benutzern hilft, Porenprobleme in diesem Bereich zu erkennen.',
      hd_pore_nose:
        'Der KI-Algorithmus identifiziert sichtbare Poren auf der Nase, zeigt ihren Schweregrad an und hilft den Benutzern, den Zustand der Poren an dieser häufigen Problemzone zu erkennen.',
      hd_pore_cheek:
        'Der KI-Algorithmus analysiert die sichtbaren Poren auf den Wangen und bietet einen Schweregrad-Score, der dem Benutzer hilft, den Zustand der Poren in diesem Bereich zu beurteilen.',
      hd_dark_circle:
        'Der KI Algorithmus scannt den Bereich unter den Augen nach Augenringen ab. Der Bereich wird klar markiert und Nutzer:innen können sehen, wie schlimm der Zustand ist.',
      hd_teartrough:
        'Der KI-Algorithmus erkennt den Bereich der Tränenrinne unter den Augen, hebt diesen Bereich hervor und zeigt den Schweregrad des Zustands zur Überprüfung durch den Benutzer an.',
      skin_age:
        'Unsere innovative Hauttechnologie wurde mit Hautpflegeexperten entwickelt und verwendet über 70.000 Bilder in medizinischer Qualität für verschiedene Hauttypen, Ethnien, Geschlechter und Altersgruppen. Basierend auf diesem Wissen und diesen Daten ist der KI-Algorithmus in der Lage, das Alter der Haut des Benutzers zu schätzen.',
      skin_health:
        'Angetrieben von KI-Deep-Learning Technologie gibt unser Algorithmus der Haut des Benutzers einen Gesundheits-Score welcher auf dem Score der verschiedenen, analysierten Hautprobleme basiert.',
      normal_non_sensitive:
        'Normale Haut ist ein ausgeglichener Hauttyp, der weder zu fettig noch zu trocken ist. Sie hat eine glatte und gleichmäßige Textur mit kleinen Poren und einen gesunden Teint. Menschen mit normaler Haut erleben normalerweise keine übermäßige Fettigkeit oder Trockenheit, und sie haben selten Hautunreinheiten.',
      dry_non_sensitive:
        'Ein trockener Hauttyp ist ein Hautzustand, der durch einen Mangel an Feuchtigkeit und Fett in der Haut gekennzeichnet ist und durch eine Vielzahl von Faktoren verursacht werden kann, darunter Genetik, Alter, Wetterbedingungen und bestimmte Medikamente.',
      oily_non_sensitive:
        'Fettige Haut ist ein Hauttyp, der durch eine übermäßige Produktion von Talg gekennzeichnet ist, dem natürlichen Fett, das von den Talgdrüsen der Haut produziert wird. Dies kann zu einem glänzenden oder fettigen Aussehen, vergrößerten Poren und einer Neigung zu Pickeln führen. Menschen mit einem fettigen Hauttyp sollten ölfreie oder nicht porenverstopfende Hautpflegeprodukte verwenden.',
      combination_non_sensitive:
        'Laut der Hautanalyse haben Sie einen Mischhauttyp. Der Mischhauttyp ist ein Hautzustand, der sowohl durch fettige als auch trockene Bereiche im Gesicht gekennzeichnet ist. Typischerweise ist die T-Zone (Stirn, Nase und Kinn) fettig, während die Wangen und andere Bereiche trocken oder normal sein können.',
      normal_sensitive:
        'Empfindliche Haut ist ein Hauttyp, der leicht durch verschiedene äußere Faktoren wie Sonneneinstrahlung, Umweltschadstoffe, bestimmte Hautpflegeprodukte und sogar Stress gereizt wird. Bei Menschen mit empfindlicher Haut können Symptome wie Rötung, Juckreiz, Trockenheit, Schuppenbildung oder ein brennendes Gefühl auftreten, wenn sie diesen Auslösern ausgesetzt sind.',
      dry_sensitive:
        'Der trockene und empfindliche Hauttyp ist durch einen Mangel an natürlichen Ölen und Feuchtigkeit in der Haut gekennzeichnet. Trockene Haut hat tendenziell kleinere Poren und kann Anzeichen vorzeitiger Hautalterung wie feine Linien und Fältchen aufweisen. Empfindliche Haut wird leicht durch äußere Faktoren wie Duftstoffe, Alkohol und bestimmte Inhaltsstoffe in Hautpflegeprodukten gereizt.',
      oily_sensitive:
        'Fettige und empfindliche Haut ist ein Hauttyp, der durch eine übermäßige Fettproduktion und eine Neigung zu Entzündungen und Irritationen gekennzeichnet ist. Die Haut hat typischerweise ein glänzendes oder fettiges Aussehen, vergrößerte Poren und eine Tendenz zu Pickeln. Gleichzeitig ist die Haut auch empfindlich und durch Umwelteinflüsse leicht reizbar.',
      combination_sensitive:
        'Eine empfindliche Mischhautist ein Hauttyp, der Eigenschaften sowohl von Mischhaut als auch von empfindlicher Haut aufweist. Mischhaut zeichnet sich dadurch aus, dass sie sowohl fettige als auch trockene Stellen aufweist, während empfindliche Haut leicht durch äußere Faktoren gereizt wird.',
    },
    es: {
      hd_spot:
        'El algoritmo de IA identifica diferentes niveles de manchas en la piel desde oscuras y excluye las zonas que no lo son, como los lunares de la piel, el vello facial u otras partes de la piel.',
      hd_redness:
        'El enrojecimiento de la piel puede ser causado por diversos factores. El algoritmo de IA puede detectar síntomas sutiles antes de que el enrojecimiento de la piel cause irritación.',
      hd_moisture:
        'Un sofisticado algoritmo de aprendizaje profundo de IA analiza y detecta los niveles de hidratación de la piel. Se reconocen varios indicadores de deshidratación de la piel.',
      hd_oiliness:
        'La piel grasa es identificada mediante el algoritmo de IA la cual clasifica la grasa de la piel en tres niveles y muestra los resultados mediante superposiciones de RA para ayudar a los usuarios a reconocer las zonas de la piel que requieren más atención.',
      hd_wrinkle:
        'La IA identifica varios tipos de arrugas, y los usuarios pueden ver arrugas online desde líneas finas hasta pliegues profundos. La tecnología se centra en las zonas del rostro donde las arrugas son más frecuentes.',
      hd_wrinkle_forehead:
        'El algoritmo de IA detecta las líneas finas y las arrugas profundas de la frente, mostrando su gravedad para ayudar a los usuarios a reconocer las zonas que necesitan atención para suavizar la piel.',
      hd_wrinkle_glabellar:
        'La IA detecta las arrugas entre las cejas, valorando la gravedad y ayudando a los usuarios a tomar medidas para reducir las líneas de expresión.',
      hd_wrinkle_crowfeet:
        'El algoritmo de IA detecta arrugas en el contorno exterior de los ojos, mostrando su profundidad y gravedad para ayudar a los usuarios a centrarse en esta zona donde habitualmente se producen arrugas.',
      hd_wrinkle_periocular:
        'El algoritmo de IA detecta líneas finas y arrugas debajo de los ojos, proporcionando una puntuación de gravedad para ayudar a los usuarios a supervisar el estado de la zona debajo de los ojos.',
      hd_wrinkle_nasolabial:
        'El algoritmo de IA detecta arrugas en los pliegues nasolabiales, proporcionando una puntuación de gravedad para ayudar a los usuarios a comprender la profundidad y la importancia de estas arrugas.',
      hd_wrinkle_marionette:
        'El algoritmo de IA detecta arrugas en las líneas de marioneta, proporcionando una puntuación de gravedad para ayudar a los usuarios a valorar la profundidad y la visibilidad de estas arrugas.',
      hd_texture:
        'El algoritmo de IA para identificar la textura de piel detecta protuberancias y abolladuras en la piel de los usuarios y les ofrece una evaluación general de la suavidad de su piel.',
      hd_eye_bag:
        'El algoritmo de IA para las ojeras también puede analizar el estado de las bolsas en los ojos. Las superposiciones de RA delinean el tamaño y la hinchazón del estado de las bolsas en los ojos del usuario.',
      hd_firmness:
        'El algoritmo de IA analiza la flacidez facial e identifica los niveles de flacidez de la piel en ambos lados del mentón.',
      hd_droopy_upper_eyelid:
        'El algoritmo de IA examina la esquina exterior del párpado superior e identifica los niveles de flacidez a su alrededor para uno o ambos ojos.',
      hd_droopy_lower_eyelid:
        'El algoritmo de IA examina la esquina exterior del párpado inferior e identifica los niveles de flacidez a su alrededor para uno o ambos ojos.',
      hd_radiance:
        'El algoritmo de IA analiza la claridad y la luminosidad general de la piel para proporcionar una puntuación de evaluación, ayudando al usuario a conseguir una piel luminosa.',
      hd_acne:
        'El diagnostico piel de 180 grados se aplica en toda la cara para identificar tres tipos de acné: acné inflamatorio, puntos blancos y puntos negros.',
      hd_pore:
        'El algoritmo de IA detecta los poros vde la piel isibles y los resalta con superposiciones de RA. El análisis de los poros de la piel muestra el estado de la piel del usuario para el mejor plan de tratamiento.',
      hd_pore_forehead:
        'El algoritmo de IA detecta poros visibles en la frente, proporcionando una puntuación de seguridad para ayudar a los usuarios a reconocer problemas de poros en esta zona.',
      hd_pore_nose:
        'El algoritmo de IA identifica poros visibles en la nariz, mostrando su gravedad y ayudando a los usuarios a reconocer el estado de los poros en esta zona que suele ser problemática.',
      hd_pore_cheek:
        'El algoritmo de IA analiza los poros visibles en las mejillas, ofreciendo una puntuación de gravedad para ayudar a los usuarios a evaluar el estado de los poros en esta zona.',
      hd_dark_circle:
        'Las ojeras son identificadas mediante el algoritmo de IA el cual escanea la zona de debajo de los ojos en busca de ojeras. La zona de las ojeras se marca claramente y los usuarios pueden ver la gravedad de esta condición.',
      hd_teartrough:
        'El algoritmo de IA detecta la zona del surco lagrimal debajo de los ojos y resalta la zona, mostrando la gravedad del estado para que lo vea el/la usuario/a.',
      skin_age:
        'Nuestra innovadora tecnología de la piel fue desarrollada con expertos en el cuidado de la piel y utiliza más de 70.000 imágenes de grado médico, a través de diferentes tipos de piel, etnias, género y grupos de edad. Basándose en esos conocimientos y datos, el algoritmo de IA es capaz de estimar la edad de la piel del usuario.',
      skin_health:
        'Angetrieben von KI-Deep-Learning Technologie gibt unser Algorithmus der Haut des Benutzers einen Gesundheits-Score welcher auf dem Score der verschiedenen, analysierten Hautprobleme basiert.',
      normal_non_sensitive:
        'La piel normal es un tipo de piel equilibrada que no es ni demasiado grasa ni demasiado seca. Tiene una textura suave y uniforme con poros pequeños y un cutis sano. Las personas con piel normal no suelen presentar excesiva grasa ni sequedad, y rara vez tienen imperfecciones o brotes.',
      dry_non_sensitive:
        'El tipo de piel seca es una afección cutánea caracterizada por la falta de hidratación y grasa en la piel, y puede estar causada por diversos factores, como la genética, el envejecimiento, las condiciones climáticas y ciertos medicamentos.',
      oily_non_sensitive:
        'La piel grasa se caracteriza por una producción excesiva de sebo, la grasa natural producida por las glándulas sebáceas de la piel. Esto puede provocar un aspecto brillante o graso, poros dilatados y tendencia a los brotes de acné. Las personas con un tipo de piel grasa deben utilizar productos para el cuidado de la piel sin grasa o que no obstruyan los poros.',
      combination_non_sensitive:
        'El tipo de piel mixta se caracteriza por tener zonas grasas y secas en el rostro. Normalmente, la zona T (frente, nariz y barbilla) es grasa, mientras que las mejillas y otras zonas pueden ser secas o normales.',
      normal_sensitive:
        'La piel sensible es un tipo de piel que se irrita fácilmente por diversos factores externos, como la exposición al sol, los contaminantes ambientales, determinados productos para el cuidado de la piel e incluso el estrés. Las personas con piel sensible pueden experimentar síntomas como enrojecimiento, picor, sequedad, descamación o sensación de quemazón cuando se exponen a estos factores desencadenantes.',
      dry_sensitive:
        'El tipo de piel seca y sensible se caracteriza por la falta de aceites naturales y humedad en la piel. La piel seca tiende a tener poros más pequeños y puede mostrar signos de envejecimiento prematuro, como líneas finas y arrugas. La piel sensible se irrita fácilmente por factores externos, como fragancias, alcohol y ciertos ingredientes de los productos de cuidado de la piel.',
      oily_sensitive:
        'La piel grasa y sensible es un tipo de piel que se caracteriza por un exceso de producción de grasa y una tendencia a la inflamación y la irritación. La piel suele tener un aspecto brillante o graso, poros dilatados y tendencia al acné y los brotes. Al mismo tiempo, la piel también es sensible y se irrita fácilmente por factores ambientales.',
      combination_sensitive:
        'La piel mixta y sensible es un tipo de piel que presenta características tanto de piel mixta como de piel sensible. La piel mixta se caracteriza por tener zonas grasas y secas, mientras que la piel sensible se irrita fácilmente por factores externos.',
    },
    it: {
      hd_spot:
        'L’algoritmo tramite AI indica in maniera precisa l’area delle macchie con una sovrapposizione visiva, e determina anche la densità e l’intensità delle macchie.',
      hd_redness:
        "L'AI rileva le aree arrossate, rilevando condizioni tra cui rosacea, dermatite e scottature. Determina anche la densità e la gravità degli arrossamenti.",
      hd_moisture:
        'L’AI rileva i diversi sintomi di disidratazione della pelle, tra cui linee sottili, rugosità, opacità e irritazione.',
      hd_oiliness:
        'Gli utenti possono vedere quali aree del loro viso hanno un’eccessiva secrezione di sebo.',
      hd_wrinkle:
        'L’AI riconosce il livello di gravità dei diversi tipi di rughe, comprese le linee della fronte, le zampe di gallina, le rughe di espressione, le rughe della marionetta e altre.',
      hd_wrinkle_forehead:
        "L'algoritmo AI rileva le rughe sottili e profonde sulla fronte, mostrandole chiaramente, per aiutare l'utente a riconoscere le aree che richiedono attenzione per migliorare il tono della pelle.",
      hd_wrinkle_glabellar:
        "L'AI rileva le rughe tra le sopracciglia, valutandone la gravità per aiutare l'utente ad adottare le misure per contrastarle.",
      hd_wrinkle_crowfeet:
        "L'algoritmo AI rileva le rughe agli angoli esterni degli occhi, mostrandone la profondità e gravità per aiutare l'utente a mettere a fuoco quest'area tipicamente soggetta alle rughe.",
      hd_wrinkle_periocular:
        "L'algoritmo AI rileva le rughe sottili e più profonde nell'area sotto gli occhi, valutandole in base a una scala che aiuta l'utente a monitorarne lo stato.",
      hd_wrinkle_nasolabial:
        "L'algoritmo AI rileva le rughe nell'area nasolabiale, valutandole in base a una scala che aiuta l'utente a comprenderne la profondità e l'estensione.",
      hd_wrinkle_marionette:
        "L'algoritmo AI rileva le rughe della marionetta, valutandole in base a una scala che aiuta l'utente a comprenderne la profondità e l'estensione.",
      hd_texture:
        "La diagnostica della pelle tramite AI è in grado di classificare diversi livelli di profondità della struttura della pelle e d'individuare superfici irregolari sulla pelle.",
      hd_eye_bag:
        'Rilevamento avanzato dei tre diversi tipi di occhiaie, compresi pigmentazione, vascolarizzazione e i tipi strutturali.',
      hd_firmness:
        'L’algoritmo AI analizza la compattezza della pelle e identifica i livelli di cedimento della pelle su entrambi i lati del mento.',
      hd_droopy_upper_eyelid:
        'L’algoritmo di AI esamina l’angolo esterno della palpebra superiore e identifica i livelli di rilassamento intorno a essa per uno/entrambi gli occhi.',
      hd_droopy_lower_eyelid:
        'L’algoritmo di AI esamina l’angolo esterno della palpebra inferiore e identifica i livelli di cedimento intorno a essa per uno/entrambi gli occhi.',
      hd_radiance:
        'L’algoritmo di AI analizza la trasparenza generale della pelle, la radiosità e lo scolorimento per fornire una valutazione',
      hd_acne:
        'Skin test viso a 180 gradi dei problemi di acne per identificarne diversi fattori e condizioni, tra cui iperpigmentazione post-infiammatoria (PIH), reazioni infiammatorie e punti neri.',
      hd_pore:
        'Pori visibili L’algoritmo di AI rileva i pori visibili e li evidenzia con sovrapposizioni di AR. L’analisi dei pori mostra la condizione della pelle dell’utilizzatore per il miglior piano di trattamento.',
      hd_pore_forehead:
        "L'algoritmo AI rileva i pori visibili sulla fronte, valutandoli in base a una scala che aiuta l'utente a comprendere la portata del problema nell'area.",
      hd_pore_nose:
        "L'algoritmo AI rileva i pori visibili sul naso, valutandoli in base a una scala che aiuta l'utente a comprendere la portata del problema, comune in quest'area.",
      hd_pore_cheek:
        "L'algoritmo AI analizza i pori visibili sulle guance, valutandoli in base a una scala che aiuta l'utente a comprendere la portata del problema nell'area.",
      hd_dark_circle:
        'Rilevamento avanzato dei tre diversi tipi di occhiaie, compresi pigmentazione, vascolarizzazione e i tipi strutturali.',
      hd_teartrough:
        "L'algoritmo AI rileva l'area del solco lacrimale e la illumina, in modo da evidenziare i problemi presenti, perché sia più semplice individuarli.",
      skin_age:
        "La nostra tecnologia pelle innovativa è stata sviluppata con esperti della cura della cute e visagisti, e sfrutta oltre 70.000 immagini di livello medico, per tutti i tipi di pele e carnagione, etnia, genere, e età. In base a questo set di dati, l'algoritmo AI è capace di stimare l'età dell'utente (e della sua pelle).",
      skin_health:
        "Forte della tecnologia di apprendimento profondo AI, il nostro algoritmo valuta la cute dell'utente e produce un punteggio di salute basato su tutte le problematiche della pelle che analizza.",
      normal_non_sensitive:
        'La pelle normale è bilanciata, né troppo grassa né troppo secca. Presenta una consistenza uniforme e liscia, con pori piccoli e carnagione sana. Le persone con pelle normale di solito non soffrono di oleosità né secchezza eccessive, e raramente presentano imperfezioni o sfoghi di acne.',
      dry_non_sensitive:
        'La pelle secca è caratterizzata da una mancanza di idratazione e sebo, causata da tanti fattori diversi, quali geni, invecchiamento, condizioni climatiche, e alcune medicine.',
      oily_non_sensitive:
        "In base al risultato dell'analisi pelle, la tua cute è di tipo grasso. La pelle grassa è caratterizzata da produzione in eccesso di sebo, l'olio naturale secreto dalle ghiangole sebacee della cute. Ciò può risultare in un aspetto oleoso o lucido, pori ingrossati, e una tendenza agli sfoghi di acne. Alle persone con pelle grassa si consiglia di utilizzare prodotti di cura della cute privi di olio e che non ostruiscano i pori.",
      combination_non_sensitive:
        'La pelle mista è caratterizzata dalla presenza di aree grasse in combinazione con aree secche sul volto. Di solito, la zona T (fronte, naso, mento) è grassa, mentre le guance e altre parti sono secche, o normali.',
      normal_sensitive:
        'La pelle sensibile è facilmente irritata da fattori esterni, quali esposizione al sole, inquinamento atmosferico, alcuni prodotti di cura della pelle, e persino dallo stress. Le persone con pelle sensibile possono soffrire di sintomi quali arrossamenti, prurito, secchezza, squamature, o sensazioni di bruciore quando esposte a questi fattori.',
      dry_sensitive:
        "In base al risultato dell'analisi della cute, la tua pelle è di tipo secco e sensibile. La pelle secca e sensibile è caratterizzata da una mancanza di sebo naturale e idratazione. La pelle secca tende ad avere pori rimpiccioliti, e a mostrare segni di invecchiamento precoce, quali linee fini e rughe. La pelle sensibile è facilmente irritata da fattori esterni, quali profumi, presenza di alcool e altri ingredienti comuni nei prodotti di cura della cute.",
      oily_sensitive:
        "La pelle grassa e sensibile è caratterizzata da produzione eccessiva di sebo, e da una tendenza all'infiammazione e irritazione. Appare di solito oleosa e lucida, con pori ingranditi e una tendenza agli sfoghi di acne. Allo stesso tempo, la pelle è però sensibile e irritata da fattori ambientali.",
      combination_sensitive:
        "In base al risultato dell'analisi della cute, la tua pelle è di tipo misto e sensibile. La pelle mista e sensibile mostra caratteristiche di entrambe le tipologie: aree grasse che si alternano ad aree secche, e irritabilità ai fattori esterni.",
    },
    'zh-Hant': {
      skin_age:
        '我們的創新 AI 肌膚分析是與皮膚保養專家一同開發，使用超過 7 萬張橫跨各種膚質、人種、性別及年齡的醫療等級照片所訓練出的 AI 演算法能推測出使用者的肌膚年齡。',
      skin_health:
        '以 AI 深度學習技術支援的肌膚偵測演算法能依據多重肌膚狀況分析出使用者肌膚健康程度。',
      hd_spot:
        'AI 演算法能智慧辨識不同程度的黑斑，並排除痣、臉部毛髮或其他誤判的非黑斑區域。',
      hd_wrinkle:
        'AI 引擎能識別不同類型的皺紋，從淺層細紋到深層皺紋。此技術著重在皺紋最常出現的臉部區域。',
      hd_wrinkle_forehead:
        'AI 演算法能檢測額頭上的細紋和深皺紋，顯示其嚴重程度，幫助使用者辨識需要關注的區域，讓皮膚比較光滑。',
      hd_wrinkle_glabellar:
        'AI 能檢測眉間紋，評估其嚴重程度，幫助使用者採取措施減少皺紋的出現。',
      hd_wrinkle_crowfeet:
        'AI 演算法能檢測眼角皺紋，顯示皺紋的深度與嚴重程度，幫助使用者關注這個常見皺紋區。',
      hd_wrinkle_periocular:
        'AI 演算法能檢測眼下的細紋和皺紋，提供嚴重程度評分，幫助使用者監控眼下皮膚狀況。',
      hd_wrinkle_nasolabial:
        'AI 演算法能檢測法令紋，提供嚴重程度評分，幫助使用者了解法令紋的深度和明顯程度。',
      hd_wrinkle_marionette:
        'AI 演算法能檢測木偶紋，提供嚴重程度評分，幫助使用者評估木偶紋的深度和可見度。',
      hd_texture:
        'AI 肌膚紋理演算法可檢測出用戶肌膚上的凹凸不平處，並提供對其肌膚平滑度的整體評估。',
      hd_dark_circle:
        'AI 演算法會檢測黑眼圈區域，有黑眼圈的區域會被清楚地標記，用戶也可以看到黑眼圈的嚴重程度。',
      hd_redness:
        '肌膚泛紅可能由多種因素引起，AI 演算法能夠檢測出早期泛紅徵兆，預防泛紅問題擴大。',
      hd_oiliness:
        'AI 演算法會將出油情況分為三個等級，並透過 AR 疊加顯示結果，幫助用戶辨識需要更多關注的肌膚區域。',
      hd_eye_bag:
        '黑眼圈的 AI 演算法也能分析眼袋狀況，透過 AR 疊加覆蓋並標示出用戶眼袋大小和浮腫情形。',
      hd_moisture:
        'AI 深度學習演算法能分析並檢測肌膚保濕程度，肌膚缺水的各種指標都能被偵測到。',
      hd_droopy_upper_eyelid:
        'AI 演算法能分析至上眼瞼外側，並辨識出單眼/雙眼周圍的眼瞼下垂程度。',
      hd_droopy_lower_eyelid:
        'AI 演算法能分析至下眼瞼外測，並辨識出單眼/雙眼周圍的眼瞼下垂程度。',
      hd_firmness: 'AI 演算法能分析肌膚緊緻度並檢測下巴兩側皮膚的下垂程度。',
      hd_radiance:
        'AI 演算法能分析整體肌膚的光澤和亮度，提供評估分數，幫助用戶改善膚況，更加容光煥發。',
      hd_acne:
        'AI 演算法能進行 180 度的全臉分析，辨別三種類型的面皰：發炎性青春痘、白頭粉刺和黑頭粉刺。',
      hd_pore:
        'AI 演算法能檢測出可見毛孔，並使用 AR 疊加顯示出它們的位置。毛孔分析將顯示用戶的膚況，以提供最佳治療方案。',
      hd_pore_forehead:
        'AI 演算法能檢測額頭上的粗大毛孔，提供嚴重程度評分，幫助使用者辨識這個區域的毛孔問題。',
      hd_pore_nose:
        'AI 演算法能識別鼻子上的粗大毛孔，顯示其嚴重程度，幫助使用者了解這個常見問題區的毛孔狀況。',
      hd_pore_cheek:
        'AI 演算法能分析臉頰上的粗大毛孔，提供嚴重程度評分，幫助使用者評估這個區域的毛孔狀況。',
      hd_teartrough:
        'AI 演算法能檢測眼下淚溝區，同時標出這個區域，顯示淚溝的嚴重程度供使用者參考。',
      normal_non_sensitive:
        '中性肌是一種既不油膩也不乾燥的膚質。皮膚質地光滑、毛孔細小、健康。中性肌的人通常不會出現皮膚緊繃或感到油膩感，而且很少出現瑕疵或痘痘。',
      dry_non_sensitive:
        '乾性肌的特徵是皮膚缺乏水分和油脂，可能由多種因素引起，包括基因、衰老、氣候條件和某些藥物。',
      oily_non_sensitive:
        '油性肌是一種以皮脂分泌過多為特徵的皮膚類型，會導致皮膚油光、易有油膩感，容易遇到毛孔粗大、粉刺等肌膚問題。油性肌膚的人應該使用無油或不堵塞毛孔的護膚品。',
      combination_non_sensitive:
        '混合肌的特徵是臉部同時出現油性和乾燥的區域，通常是 T 區域（額頭、鼻子和下巴）屬於油性肌膚，而臉頰和其他區域可能是乾燥或中性肌膚。',
      normal_sensitive:
        '敏感肌容易被各種外部因素刺激，例如陽光、環境污染物、某些護膚產品甚至是壓力；受刺激後，皮膚敏感者可能會出現紅腫、癢、乾燥、起屑或灼熱感等症狀。',
      dry_sensitive:
        '乾性敏感肌的特徵是皮膚缺乏天然油脂和水份。乾性肌膚看起來細緻，但撫摸時紋理感明顯，較容易出現細紋、皺紋等早期老化的跡象。敏感性皮膚容易受到外部因素的刺激，如香料、酒精和護膚產品中的部份成分。',
      oily_sensitive:
        '油性敏感肌的特徵是過度分泌油脂，並且容易發炎、受刺激。皮膚經常出油光、毛孔粗大，且容易長青春痘和粉刺。同時，皮膚也敏感、易受環境因素的刺激。',
      combination_sensitive:
        '混合敏感肌是同時表現出混合性和敏感性皮膚特徵的皮膚類型：包含臉部同時有油性和乾燥的區域，及易受外部因素的刺激。',
    },
    'zh-Hans': {
      hd_acne:
        'AI 算法可以做 180 度的全脸分析，识别三种类型的痤疮：炎症性痤疮、白头粉刺和黑头粉刺。',
      skin_age:
        '我们的创新 AI 肌肤分析是与皮肤保养专家一同开发，使用超过 7 万张横跨各种肤质、人种、性别及年龄的医疗等级照片所训练出的 AI 算法，能推测出用户的肌肤年龄。',
      skin_health:
        '以 AI 深度学习技术支持的肌肤检测算法，能依据多种肌肤状况分析出使用者肌肤健康程度。',
      hd_spot:
        'AI 算法可以识别不同程度的暗斑，并排除非暗斑区域，如皮肤痣、面部毛发或其他虚假数据。',
      hd_wrinkle:
        'AI 可以识别各种类型的皱纹，从细纹到深皱纹。该技术专注于识别面部最易出现皱纹的区域。',
      hd_wrinkle_forehead:
        '人工智能算法可检测额头的细纹和深层皱纹，并显示其严重程度，帮助用户了解需要护理的部位，从而让皮肤更光滑。',
      hd_wrinkle_glabellar:
        '人工智能可检测眉间纹，评估严重程度，帮助用户采取措施减少皱纹。',
      hd_wrinkle_crowfeet:
        '人工智能算法可检测外眼角的皱纹，显示其深度和严重程度，帮助用户关注这一常见皱纹区域。',
      hd_wrinkle_periocular:
        '人工智能算法可检测眼下的细纹和皱纹，提供严重程度评分，帮助用户监测眼下区域的状况',
      hd_wrinkle_nasolabial:
        '人工智能算法可检测法令纹，提供严重程度评分，帮助用户了解法令纹的深度和严重程度。',
      hd_wrinkle_marionette:
        '人工智能算法可检测木偶纹，并提供严重程度评分，帮助用户评估这些皱纹的深度和可见度。',
      hd_texture:
        'AI 算法检测用户皮肤上的凸起和凹陷，并为用户提供对其皮肤光滑度的整体评估。',
      hd_dark_circle:
        'AI 算法扫描眼下区域的黑眼圈。黑眼圈区域被清晰地标记出来，用户可以看到黑眼圈的严重程度。',
      hd_pore:
        'AI 算法可检测可见的毛孔，并通过 AR 叠加突出显示它们。毛孔分析显示用户的皮肤状况，以便制定最佳治疗方案。',
      hd_pore_forehead:
        '人工智能算法可检测额头上的可见毛孔，并给出严重程度评分，帮助用户了解该部位的毛孔问题。',
      hd_pore_nose:
        '人工智能算法可识别鼻子上的明显毛孔，显示其严重程度，帮助用户了解这一常见问题部位的毛孔状况。',
      hd_pore_cheek:
        '人工智能算法可分析脸颊上的可见毛孔，提供严重程度评分，帮助用户评估该区域的毛孔状况。',
      hd_radiance: 'AI 算法分析整体皮肤的清晰度、亮度和色斑，提供分数评估。',
      hd_droopy_upper_eyelid:
        'AI 算法可检查上眼皮的外眼角，并确定单/双眼的下垂程度。',
      hd_droopy_lower_eyelid:
        'AI 算法分析皮肤紧致度，并确定下眼睑两侧皮肤的下垂程度。',
      hd_firmness: 'AI 算法分析皮肤紧致度，并确定下巴两侧皮肤的下垂程度。',
      hd_eye_bag:
        '黑眼圈的 AI 算法也可分析眼袋状况。AR技术 叠加可确定眼袋状况的大小和浮肿程度。',
      hd_moisture:
        '采用先进的人工智能深度学习算法分析和检测皮肤的含水量，识别皮肤缺水的各种指标。',
      hd_oiliness:
        'AI 算法将出油情况分为三个等级，并使用 AR技术 叠加显示结果，帮助用户识别需要更多关注的皮肤区域。',
      hd_redness:
        '皮肤发红可能是由各种因素所起，AI 算法可以在病情开始造成刺激之前发现细微的症状。',
      hd_teartrough:
        '人工智能算法可检测眼下泪沟区域，并突出显示该区域，同时显示严重程度方便用户了解。',
      normal_non_sensitive:
        '中性肌肤通常没有紧绷感和油腻感，痘痘、黑头、白头等也相对少发。中心肌是一种水油平衡维持较好的肌肤，质地光滑、毛孔细小、肌肤健康。',
      dry_non_sensitive:
        '干性肌肤的特征是皮肤缺乏水分和油脂，可能由多种因素引起，包括基因、衰老、气候条件和某些药物。',
      oily_non_sensitive:
        '油性肌的特征是皮脂分泌过多，会导致肌肤油光、毛孔粗大、粉刺等肌肤问题。油性肌肤质在日常洁面及保养时，应尽量避免厚重的护肤品，尽量以清爽型产品为主。',
      combination_non_sensitive:
        '混合肌的特征是脸部同时出现油性和干燥的区域，通常是T区域（额头、鼻子和下巴）属于油性肌肤，而脸颊和其他区域可能是干燥或中性肌肤。',
      normal_sensitive:
        '敏感肌容易被各种外部因素刺激，例如阳光、环境污染物、某些嫩肤产品甚至是压力；受刺激后，皮肤敏感者可能会出现红肿、痒、干燥、起屑或灼热感等症状。',
      dry_sensitive:
        '干性敏感肌的特征是皮肤缺乏天然油脂和水份。干性肌肤看起来细致，但触摸时纹理感明显，较容易出现细纹、皱纹等早期老化的迹象。敏感性皮肤容易受到外部因素的刺激，如香料、酒精和护肤产品中的部分成分。',
      oily_sensitive:
        '油性敏感肌的特征是过度分泌油脂，并且容易发炎、受刺激。皮肤经常出油、毛孔粗大，且容易长青春痘和粉刺。同时，皮肤也比较敏感、易受环境因素的刺激。',
      combination_sensitive:
        '混合敏感肌会同时表现出混合性和敏感性的皮肤特征；在脸部同时有油性和干燥的区域，易收外部因素的刺激。',
    },
    pt: {
      skin_age:
        'Nossa inovadora tecnologia de pele foi desenvolvida com especialistas em cuidados com a pele e usa mais de 70.000 imagens de nível médico, em diferentes tipos de pele, etnias, gênero e faixas etárias. Com base nesse conhecimento e dados, o algoritmo de IA é capaz de estimar a idade da pele d@ usuári@.',
      skin_health:
        'Alimentado pela tecnologia de aprendizado profundo de IA, nosso algoritmo fornece uma pontuação de saúde para a pele d@ usuári@ com base nas pontuações das várias questões de pele que analisa.',
      hd_spot:
        'O algoritmo de IA identifica diferentes níveis de manchas escuras e exclui áreas essas manchas, como verrugas na pele, pêlos faciais ou outras leituras falsas.',
      hd_redness:
        'A vermelhidão da pele pode ser causada por uma variedade de fatores. O algoritmo de IA pode detectar sintomas sutis antes que a condição comece a causar irritação.',
      hd_moisture:
        'Um sofisticado algoritmo de aprendizado profundo de IA analisa e detecta os níveis de hidratação da pele. Vários indicadores de desidratação da pele podem ser reconhecidos.',
      hd_oiliness:
        'O algoritmo de IA categoriza a oleosidade em três níveis e mostra resultados usando sobreposições de RA para ajudar @s usuári@s a reconhecer áreas da pele que exigem mais atenção.',
      hd_wrinkle:
        'A IA identifica vários tipos de rugas, desde linhas finas até vincos profundos. A tecnologia se concentra nas áreas faciais onde as rugas são mais comuns.',
      hd_wrinkle_forehead:
        'O algoritmo de IA detecta linhas finas e rugas profundas na testa, mostrando sua gravidade ajudando os usuários a reconhecer as áreas que precisam de atenção para uma pele mais suave.',
      hd_wrinkle_glabellar:
        'IA detecta rugas entre as sobrancelhas, avaliando a gravidade e ajudando os usuários a tomar medidas para reduzir as linhas.',
      hd_wrinkle_crowfeet:
        'O algoritmo de IA detecta rugas nos cantos externos dos olhos, mostrando sua profundidade e gravidade ajudando os usuários a se concentrarem nessa zona comum de rugas.',
      hd_wrinkle_periocular:
        'O algoritmo de IA detecta as linhas finas e as rugas sob os olhos, fornecendo uma pontuação de gravidade ajudando os usuários a monitorar a condição da área sob os olhos',
      hd_wrinkle_nasolabial:
        'O algoritmo de IA detecta rugas nas dobras nasolabiais, fornecendo uma pontuação de gravidade ajudando os usuários a entender a profundidade e a proeminência dessas rugas.',
      hd_wrinkle_marionette:
        'O algoritmo de IA detecta rugas nas linhas de marionete, fornecendo uma pontuação de gravidade ajudando os usuários a avaliar a profundidade e a visibilidade dessas rugas.',
      hd_texture:
        'O algoritmo de IA para textura detecta inchaços e irregularidades na pele d@s usuári@s e oferece uma avaliação geral da suavidade da pele.',
      hd_eye_bag:
        'O algoritmo de IA para olheiras também pode analisar a condição de bolsa ocular. As sobreposições de AR delineiam o tamanho e o inchaço da condição da bolsa ocular d@ usuári@.',
      hd_firmness:
        'O algoritmo de IA analisa a firmeza da pele e identifica os níveis de flacidez da pele em ambos os lados do queixo.',
      hd_droopy_upper_eyelid:
        'O algoritmo de IA examina o canto externo da pálpebra superior e identifica os níveis de flacidez ao redor para um/ambos os olhos.',
      hd_droopy_lower_eyelid:
        'O algoritmo de IA examina o canto externo da pálpebra inferior e identifica os níveis de flacidez ao redor para um/ambos os olhos.',
      hd_radiance:
        'O algoritmo de IA analisa a clareza e a luminosidade geral da pele para fornecer uma pontuação de avaliação, ajudando \n@ usuári@ a melhorar a aparência da pele.',
      hd_acne:
        'O algoritmo pode fazer uma análise facial completa de 180 graus para identificar três tipos de acne: acne inflamatória, espinhas e cravos.',
      hd_pore:
        'Algoritmo de IA detecta poros visíveis e os destaca com sobreposições RA. A análise de poros mostra a condição da pele d@ usuári@ para um plano de tratamento adequado.',
      hd_pore_forehead:
        'O algoritmo de IA detecta poros visíveis na testa, fornecendo uma pontuação de gravidade ajudando os usuários a reconhecer problemas de poros nessa área.',
      hd_pore_nose:
        'O algoritmo de IA identifica os poros visíveis no nariz, mostrando sua gravidade e ajudando os usuários a reconhecer a condição dos poros nessa área comum de problemas.',
      hd_pore_cheek:
        'O algoritmo de IA analisa os poros visíveis nas bochechas, oferecendo uma pontuação de gravidade ajudando os usuários a avaliar a condição dos poros nessa região.',
      hd_dark_circle:
        'O algoritmo de IA verifica a área sob os olhos em busca de olheiras. A área do círculo escuro está claramente marcada e @s usuári@s podem ver a gravidade dessa condição.',
      hd_teartrough:
        'O algoritmo de IA detecta a área do canal lacrimal sob os olhos e destaca a região, exibindo a gravidade da condição para análise do usuário.',
      normal_non_sensitive:
        'A pele normal é um tipo de pele bem equilibrada que não é nem muito oleosa nem muito seca. Tem uma textura suave e uniforme com poros pequenos e uma pele saudável. Pessoas com pele normal normalmente não apresentam oleosidade excessiva ou ressecamento e raramente apresentam manchas ou erupções cutâneas.',
      dry_non_sensitive:
        'O tipo de pele seca é uma condição da pele caracterizada pela falta de umidade e óleo na pele e pode ser causada por uma variedade de fatores, incluindo genética, envelhecimento, condições climáticas e alguns medicamentos.',
      oily_non_sensitive:
        'A pele oleosa é um tipo de pele caracterizado pelo excesso de produção de sebo, o óleo natural produzido pelas glândulas sebáceas da pele. Isso pode resultar em uma aparência brilhante ou oleosa, poros dilatados e tendência a acne. Pessoas com tipo de pele oleosa devem usar produtos de cuidados com a pele sem óleo e/ou que não obstruam os poros.',
      combination_non_sensitive:
        'O tipo de pele mista é uma condição da pele caracterizada por ter áreas oleosas e secas no rosto. Normalmente, a zona T (testa, nariz e queixo) é oleosa, enquanto as bochechas e outras áreas podem ser secas ou normais.',
      normal_sensitive:
        'A pele sensível é um tipo de pele facilmente irritada por vários fatores externos, como exposição ao sol, poluentes ambientais, certos produtos para a pele e até estresse. Pessoas com pele sensível podem apresentar sintomas como vermelhidão, coceira, ressecamento, descamação ou sensação de queimação quando expostas a esses gatilhos.',
      dry_sensitive:
        'O tipo de pele seca e sensível é caracterizado pela falta de óleos naturais e umidade na pele. A pele seca tende a ter poros menores e pode apresentar sinais de envelhecimento prematuro, como linhas finas e rugas. A pele sensível é facilmente irritada por fatores externos, como fragrância, álcool e certos ingredientes em produtos para a pele.',
      oily_sensitive:
        'A pele oleosa e sensível é um tipo de pele que se caracteriza pelo excesso de produção de óleo e tendência à inflamação e irritação. A pele normalmente tem uma aparência brilhante ou oleosa, poros dilatados e tendência a acne e erupções cutâneas. Ao mesmo tempo, a pele também é sensível e facilmente irritada por fatores ambientais.',
      combination_sensitive:
        'A pele mista e sensível é um tipo de pele que apresenta características de pele mista e sensível. A pele mista é caracterizada por ter áreas oleosas e secas, enquanto a pele sensível é facilmente irritada por fatores externos.',
    },
    ar: {
      skin_age:
        'طورت تقنيتنا المبتكرة للبشرة مع خبراء العناية بالبشرة وتستخدم أكثر من 70.000 صورة طبية لمختلف أنواع البشرة والأعراق والأجناس والفئات العمرية. بناءً على تلك المعرفة والبيانات ، فإن خوارزمية الذكاء الاصطناعي في التطبيق قادرة على تقدير عمر بشرة المستخدمة.',
      skin_health:
        'مدعومًا بتقنية التعلم العميق بالذكاء الاصطناعي حيث تمنح الخوارزمية درجة صحية لجلد المستخدمة بناءً على درجة مشاكل البشرة المتعددة التي يحللها.',
      hd_spot:
        'تحدد خوارزمية الذكاء الاصطناعي في التطبيق المستويات المختلفة من البقع الداكنة وتستبعد المناطق غير المعنية مثل شامة الجلد أو شعر الوجه أو أي قراءات خاطئة أخرى.',
      hd_wrinkle:
        'يحدد الذكاء الاصطناعي أنواعًا مختلفة من التجاعيد ، بداية من الخطوط الدقيقة إلى التجاعيد العميقة. تركز التقنية على مناطق الوجه حيث تكون التجاعيد أكثر انتشارًا.',
      hd_wrinkle_forehead:
        'تكتشف خوارزمية الذكاء الاصطناعي الخطوط الدقيقة والتجاعيد العميقة على الجبهة، وتظهر شدتها لمساعدة المستخدمين على التعرف على المناطق التي تحتاج إلى الاهتمام للحصول على بشرة أكثر نعومة.',
      hd_wrinkle_glabellar:
        'يكتشف الذكاء الاصطناعي التجاعيد بين الحاجبين، ويقيم شدتها ويساعد المستخدمين على اتخاذ خطوات نحو تقليل الخطوط.',
      hd_wrinkle_crowfeet:
        'تكتشف خوارزمية الذكاء الاصطناعي التجاعيد في الزوايا الخارجية للعينين، وتظهر عمقها وشدتها لمساعدة المستخدمين على التركيز على منطقة التجاعيد الشائعة هذه.',
      hd_wrinkle_periocular:
        'تكتشف خوارزمية الذكاء الاصطناعي الخطوط الدقيقة والتجاعيد أسفل العينين، وتوفر درجة شدة لمساعدة المستخدمين على مراقبة حالة منطقة أسفل العين',
      hd_wrinkle_nasolabial:
        'تكتشف خوارزمية الذكاء الاصطناعي التجاعيد في طيات الأنف الشفوية، وتوفر درجة شدة لمساعدة المستخدمين على فهم عمق وبروز هذه التجاعيد.',
      hd_wrinkle_marionette:
        'تكتشف خوارزمية الذكاء الاصطناعي التجاعيد في خطوط الدمى، وتوفر درجة شدة لمساعدة المستخدمين على تقييم عمق ومدى وضوح هذه التجاعيد.',
      hd_texture:
        'تكتشف خوارزمية الذكاء الاصطناعي الخاصة بالملمس النتوءات والخدوش على بشرة المستخدمين وتقدم للمستخدمين تقييمًا شاملاً لنعومة بشرتهم.',
      hd_eye_bag:
        'يمكن لخوارزمية الذكاء الاصطناعي للدوائر المظلمة أيضًا تحليل حالة الأكياس المنتفخة تحت العين. يحدد التطبيق طبقة حجم وانتفاخ حالة الأكياس المنتفخة تحت العين.',
      hd_firmness:
        'تحلل خوارزمية الذكاء الاصطناعي متانة الجلد وتحدد مستويات ترهل الجلد على جانبي الذقن.',
      hd_droopy_upper_eyelid:
        'تفحص خوارزمية الذكاء الاصطناعي الزاوية الخارجية للجفن العلوي وتحديد مستويات الترهل حوله لعين واحدة / كلتا العينين.',
      hd_droopy_lower_eyelid:
        'تفحص خوارزمية الذكاء الاصطناعي الزاوية الخارجية للجفن السفلي وتحديد مستويات الترهل حوله لعين واحدة / كلتا العينين.',
      hd_radiance:
        'تحلل خوارزمية الذكاء الاصطناعي وضوح البشرة وإشراقها بشكل عام لتقدم درجة تقييم، مما يساعد المستخدم على تحسين مظهر البشرة المتلألأ.',
      hd_acne:
        'تستطيع الخوارزمية إجراء تحليل كامل للوجه 180 درجة بغرض تحديد ثلاثة أنواع من حب الشباب: حب الشباب الالتهابي ، والرؤوس البيضاء ، والرؤوس السوداء.',
      hd_pore:
        'تكتشف خوارزمية الذكاء الاصطناعي المسام المرئية وتبرزها بشكل طبقات بواسطة الواقع المعزز. يوضح تحليل المسام حالة بشرة المستخدمة للحصول على أفضل خطة علاج.',
      hd_pore_forehead:
        'تكتشف خوارزمية الذكاء الاصطناعي المسام المرئية على الجبهة، وتوفر درجة شدة لمساعدة المستخدمين على التعرف على مشاكل المسام في هذه المنطقة.',
      hd_pore_nose:
        'تعمل خوارزمية الذكاء الاصطناعي على تحديد المسام المرئية على الأنف، مما يوضح شدتها ويساعد المستخدمين على التعرف على حالة المسام في منطقة المشاكل الشائعة هذه.',
      hd_pore_cheek:
        'تقوم خوارزمية الذكاء الاصطناعي بتحليل المسام المرئية على الخدين، وتوفر درجة شدة لمساعدة المستخدمين على تقييم حالة المسام في هذه المنطقة.',
      hd_dark_circle:
        'تقوم خوارزمية الذكاء الاصطناعي بمسح منطقة أسفل العين بحثًا عن الهالات المظلمة. تم تحديد منطقة الدائرة المظلمة بوضوح ويمكن للمستخدمين رؤية مدى خطورة هذه الحالة.',
      hd_redness:
        'قد يحدث احمرار الجلد بسبب مجموعة متنوعة من العوامل. يمكن لخوارزمية الذكاء الاصطناعي في التطبيق اكتشاف الأعراض الدقيقة قبل بدء حدوث سبب التهيج.',
      hd_moisture:
        'تحلل خوارزمية التعلم العميق المتطورة في التطبيق وتكتشف مستويات ترطيب البشرة. حيث تتعرف على مؤشرات مختلفة لجفاف الجلد.',
      hd_oiliness:
        'تصنف خوارزمية الذكاء الاصطناعي البشرة الدهنية إلى ثلاثة مستويات وتظهر النتائج باستخدام تراكبات الواقع المعزز لمساعدة المستخدمين على التعرف على مناطق البشرة التي تتطلب مزيدًا من الاهتمام.',
      hd_teartrough:
        'تكتشف خوارزمية الذكاء الاصطناعي منطقة مجرى الدموع تحت العينين وتسلط الضوء على المنطقة، وتعرض مدى شدة الحالة لمراجعة المستخدم.',
      normal_non_sensitive:
        'Normal skin is a well-balanced skin type that is neither too oily nor too dry. It has a smooth and even texture with small pores, and a healthy complexion. People with normal skin do not typically experience excessive oiliness or dryness, and they rarely have blemishes or breakouts.',
      dry_non_sensitive:
        'Dry skin type is a skin condition characterized by a lack of moisture and oil in the skin, and it can be caused by a variety of factors, including genetics, aging, weather conditions, and certain medications.',
      oily_non_sensitive:
        "Oily skin is a skin type characterized by excess production of sebum, the natural oil produced by the skin's sebaceous glands. This can result in a shiny or greasy appearance, enlarged pores, and a tendency towards acne breakouts. People with an oily skin type should use oil-free or non-pore-clogging skincare products.",
      combination_non_sensitive:
        'Combination skin type is a skin condition characterized by having both oily and dry areas on the face. Typically, the T-zone (forehead, nose, and chin) is oily while the cheeks and other areas may be dry or normal.',
      normal_sensitive:
        'Sensitive skin is a skin type that is easily irritated by various external factors such as sun exposure, environmental pollutants, certain skincare products, and even stress. People with sensitive skin may experience symptoms such as redness, itching, dryness, flakiness, or a burning sensation when exposed to these triggers.',
      dry_sensitive:
        'Dry and sensitive skin type is characterized by a lack of natural oils and moisture in the skin. Dry skin tends to have smaller pores and can show signs of premature aging, such as fine lines and wrinkles. Sensitive skin is easily irritated by external factors, such as fragrance, alcohol, and certain ingredients in skincare products.',
      oily_sensitive:
        'Oily and sensitive skin is a skin type that is characterized by excess oil production and a tendency towards inflammation and irritation. Skin typically has a shiny or greasy appearance, enlarged pores, and a tendency towards acne and breakouts. At the same time, the skin is also sensitive and easily irritated by environmental factors.',
      combination_sensitive:
        'Combination and sensitive skin is a skin type that exhibits characteristics of both combination and sensitive skin. Combination skin is characterized by having both oily and dry areas, while sensitive skin is easily irritated by external factors.',
    },
  },
  summaryContent: {
    enu: {
      good:
        "Hello there, skincare expert! Your skin looks amazing based on the AI analysis. It's evident that you have a great skincare routine that's working for you. Keep up the excellent work in maintaining your skin's moisture and hydration levels.\n" +
        'Check out your complete skin analysis below. ',
      average:
        "You're already on the path to great skin. Based on the skin analysis, a little extra care could help you achieve that. Consider adding a moisturizer to your routine to smooth the rough patches. \n" +
        '\n' +
        'Check out your complete skin analysis below for more details and areas to focus on.',
      notGood:
        "We all have those days when our skin just doesn't seem to be as radiant as we'd like. Your AI skin analysis indicates that your skin could benefit from some extra TLC to hydrate, soothe, and calm it, so you can get back to glowing in no time.\n" +
        '\n' +
        'Check out your complete skin analysis below for more details and areas to focus on.',
    },
    fra: {
      good:
        "\"Bonjour à vous, l'experte beauté ! D'après l'analyse de votre peau par IA, votre peau est éclatante. Vous avez clairement une routine de soins de la peau saine et équilibrée, et cela se voit. Continuez votre bon travail en maintenant l'humidité et l'hydratation pour garder votre peau souple et lisse. \n" +
        ' \n' +
        ' Découvrez l\'analyse complète de votre peau ci-dessous."',
      average:
        "\"Vous êtes bien partie pour avoir une peau éclatante ! D'après l'analyse de la santé de votre peau par IA, votre peau est saine, mais vous obtiendriez le teint éclatant de vos rêves si vous lui apportiez un peu plus de soin. Essayez d'ajouter une crème hydratante à votre routine pour hydrater et adoucir les zones rugueuses. Et pensez à utiliser un masque exfoliant hebdomadaire pour éliminer toute desquamation sèche et aider à obtenir un éclat éclatant. \n" +
        ' \n' +
        ' Consultez votre analyse cutanée complète ci-dessous pour plus de détails et les domaines sur lesquels vous concentrer."',
      notGood:
        "\"Nous sommes toutes passées par là : parfois, notre peau n'est tout simplement pas aussi lumineuse que nous le souhaiterions à cause des boutons, des rougeurs ou d'une sécheresse. Pas de panique ! Un teint éclatant est toujours à portée de main. D'après l'analyse de votre peau par IA, votre peau a besoin de soins supplémentaires pour hydrater, votre peau a besoin d'être chouchoutée pour hydrater, calmer et apaiser votre teint afin que vous puissiez retrouver votre éclat en un rien de temps. \n" +
        ' \n' +
        ' Consultez votre analyse cutanée complète ci-dessous pour plus de détails et les domaines sur lesquels vous concentrer."',
    },
    jpn: {
      good: '',
      average: '',
      notGood: '',
    },
    kor: {
      good:
        '"피부관리 전문가를 만나세요! AI 피부 건강 분석에 따라 당신의 피부는 빛이 나고 있습니다. 건강하고 균형 잡힌 피부관리 비법을 사용하고 있으며, 효과를 톡톡히 보고 있습니다. 계속해서 보습과 수분을 유지해 탄력 있고 매끄러운 피부를 유지하세요. \n' +
        ' \n' +
        ' 아래에서 전체 피부 분석을 확인해 보십시오."',
      average:
        '"곧 피부의 광채를 경험하실 수 있을 겁니다. AI 피부 건강 분석에 따라 당신의 피부는 건강한 상태입니다. 하지만 약간의 TLC를 더하면 꿈꾸던 빛나는 광채를 경험할 수 있습니다. 피부관리 루틴에 피부를 소중히 가꿔주는 모이스처라이저를 추가해 수분을 공급해 주세요. 그리고 거친 부분을 부드럽게 가꿔주세요. 각질을 제거하고 빛나는 광채를 위해 잊지 말고 매주 각질제거 마스크를 주기적으로 이용해 주세요. \n' +
        ' \n' +
        ' 아래의 전체 피부 분석에서 자세한 내용을 살펴보고 중점 관리해야 할 부위를 확인하세요."',
      notGood:
        '"여드름, 홍조, 건조함을 해결하기 위해 애쓰지만 때로는 원하는 만큼 피부 광채를 얻지 못할 수 있습니다. 초조해 하지 마세요! 여전히 빛나는 광채를 얻을 수 있습니다. AI 피부 건강 보고서에 따르면 당신의 피부는 보습, 진정, 수딩이 필요합니다. 적극적인 관리를 통해 곧 빛나는 피부를 되찾을 수 있을 겁니다. \n' +
        ' \n' +
        ' 아래의 전체 피부 분석에서 자세한 내용을 살펴보고 중점 관리해야 할 부위를 확인하세요."',
    },
    deu: {
      good:
        '"Hallo, du Hautpflegeexperte! Basierend auf deiner KI-Hautanalyse strahlt deine Haut. Du betreibst eindeutig eine gesunde Hautpflege und sie funktioniert. Mach so weiter und halte deine Haut feucht und hydriert, damit diese prall und glatt bleibt. \n' +
        ' \n' +
        ' Schau dir nachstehend deine komplette Hautanalyse an."',
      average:
        '"Du bist auf dem besten Weg zu strahlender Haut! Basierend auf deiner KI-Hautgesundheitsanalyse ist deine Haut gesund – allerdings kannst du mit noch ein wenig mehr Pflege den strahlendsten, traumhaftesten Teint erreichen. Versuche es einmal mit einer pflegenden Feuchte bei deiner täglichen Routine, um trockene Stellen noch mehr zu hydrieren. Und vergiss nicht eine zusätzliche wöchentliche Peeling-Maske, um trockene Hautschuppen zu entfernen und dein Gesicht strahlen zu lassen. \n' +
        ' \n' +
        ' Schau dir die nachstehende komplette Hautanalyse für weitere Informationen an und auf welche Partien du dich konzentrieren solltest."',
      notGood:
        '"Wir kennen das alle – manchmal sieht unsere Haut einfach nicht so strahlend aus, wie wir es uns wünschen und wir müssen mit Pickeln, Rötung oder trockener Haut kämpfen. Mach dir keine Sorgen! Eine strahlende Haut ist immer noch in erreichbarer Nähe. Basierend auf deiner KI-Hautanalyse benötigt deine Haut ein wenig mehr Aufmerksamkeit, um sie zu hydrieren, zu beruhigen und zu pflegen, damit du ganz rasch dein natürliches Strahlen wieder bekommst. \n' +
        ' \n' +
        ' Schau dir die nachstehende komplette Hautanalyse für weitere Informationen an und auf welche Partien du dich konzentrieren solltest."',
    },
    esp: {
      good:
        '"¡Hola, experta en la piel! Según el análisis de salud de la piel por IA, su piel está radiante. Está claro que tiene un cuidado de la piel saludable y bien equilibrado, y funciona. Siga trabajando así para mantener la humedad y la hidratación y conservar la piel elástica y suave. \n' +
        ' \n' +
        ' Consulte a continuación su análisis de piel completo."',
      average:
        '"¡Está en el buen camino para tener una piel radiante! Según el análisis de salud de la piel por IA, su piel está saludable. Sin embargo, con un poco más de cuidado podrá conseguir la tez radiante con la que sueña. Pruebe a añadir un humidificador facial a su rutina para ayudar en la hidratación y suavizar alguna zona áspera. Y no olvide cambiar a una mascarilla exfoliadora semanal para desprender las capas secas y ayudar a conseguir un brillo radiante. \n' +
        ' \n' +
        ' Consulte a continuación su análisis de piel completo para conocer más detalles y las zonas en las que debe centrarse."',
      notGood:
        '"A todos nos pasa: en ocasiones, la piel no tiene el aspecto tan luminoso que nos gustaría cuando batallamos con espinillas, enrojecimientos o sequedades. ¡No se preocupe! Sigue siendo posible conseguir un cutis radiante. Según el análisis de salud de la piel por IA, su piel necesita ciertos cuidados de belleza adicionales para hidratar, calmar y suavizar el cutis de modo que pueda recuperar su aspecto radiante rápidamente. \n' +
        ' \n' +
        ' Consulte a continuación su completo análisis de la piel para obtener más detalles y conocer las zonas en las que debe centrarse."',
    },
    ita: {
      good:
        "\"Sei professionista dello skincare! In base all'analisi AI della salute della pelle, la tua pelle è luminosa. È evidente che il tuo regime di cura della pelle è sano ed equilibrato e funziona. Continua a mantenere l'idratazione e l'elasticità della pelle. \n" +
        ' \n' +
        ' Scopri l\'analisi completa della pelle qui di seguito."',
      average:
        "\"Continua su questa strada e la tua pelle brillerà! In base all'analisi della salute della pelle di AI, la tua pelle è sana. Tuttavia, un po' di attenzione in più può aiutarti a ottenere la carnagione luminosa perfetta. Prova ad aggiungere alla tua routine una crema idratante per aiutare l'idratazione e lisciare alcune zone rugose. E non dimenticare di aggiungere a cadenza settimanale una maschera esfoliante per eliminare le screpolature e contribuire a ottenere una luminosità intensa. \n" +
        ' \n' +
        ' Per ulteriori dettagli e aree da migliorare, consulta l\'analisi completa della pelle qui sotto."',
      notGood:
        "\"Ci siamo passati tutti: a volte la nostra pelle non ha l'aspetto luminoso che vorremmo, e ci troviamo a combattere contro brufoli, arrossamenti o secchezza. Niente panico! L'incarnato luminoso è ancora a portata di mano. In base all'analisi AI della salute della pelle, la tua pelle ha bisogno di qualche coccola in più per idratare, calmare e lenire la carnagione, e tornare a uno splendore senza tempo. \n" +
        ' \n' +
        ' Per ulteriori dettagli e aree da migliorare, consulta l\'analisi completa della pelle qui sotto."',
    },
  },
  resultDetectionDescription: {
    enu: {
      age_spot: {
        notGood:
          'Keep your hands off your face during the day and be diligent with a gentle skincare routine including a gentle cleanser and acne spot treatment.',
        average:
          "Continue with twice-daily cleansing with your favorite mild cleanser and don't forget to moisturize.",
        good:
          'Hello gorgeous! Your skin is looking mighty fine. Keep up with your daily moisturizer and SPF.',
      },
      redness: {
        notGood:
          'Put down the exfoliants and pick up a moisturizer. Look for products with soothing ingredients like niacinamide, licorice root, aloe, caffeine, and cucumber which help to reduce redness.',
        average:
          'Looking to soothe some redness on the skin? Look for products with niacinamide to soothe inflammation, even skin tone, and helps strengthen skin.',
        good:
          'Keep doing what your doing! Your beautiful even skintone speaks for itself.',
      },
      moisture: {
        notGood:
          "You're skin is in need of added hydration so treat yourself to a dailly moisturizer with hyaluronic acid, and a rich overnight cream to restore moisture come morning.",
        average:
          'Pour yourself a glass of water and drink up! Then supplement with a daily moisturizer with hyaluronic acid, glycerin, or ceramides to help rehydrate and moisturize the skin.',
        good:
          'Hello beautiful hydrated skin! Keep up with the daily moisurizer and enjoy that dewy, suppleness.',
      },
      oiliness: {
        notGood:
          'Consider a skin toner with ingredients like alpha hydroxy acids to help regulate oil production and combat excessive oiliness. A charcoal mask also helps draw out impurities causing extra shine.',
        average:
          "Battling a little too much shine? Try a cleanser with Salicylic Acid that gently exfoliates to clear pores, but won't dry out your skin.",
        good:
          "Looks like you're shining in all the right places! Keep up the good work and glow away!",
      },
      wrinkle: {
        notGood:
          'Look for products with Hyaluronic Acid. This super-hydrator holds 1,000 times its weight in water helping to replenish skin moisture and restore a plump, smooth appearance.',
        average:
          'The sun wreaks havoc on your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
        good:
          "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
      },
      texture: {
        notGood:
          'Want to improve your skin texture? Use an exfoliant one to two times per week to gently buff away any dead skin cells and reveal a beautiful, glowy complexion.',
        average:
          "Give your skin's texture a boost with an antioxidant-rich Vitamin C serum to help repair and protect skin from the elements and give your face an instant healthy glow.",
        good:
          "Your skin is looking good so don't forget to slather on SPF to keep that beautiful face protected.",
      },
      eye_bag: {
        notGood:
          'Look for soothing and anti-inflammaory products with green tea or caffeine to help reduce puffiness under the senstive undereye area.',
        average:
          'Try a cold compress or tea bags to start--or end--the day to help to reduce under eye puffiness. Also look for products with cucumber or rose water to help hydrate and calm the area.',
        good:
          'Double down on your beauty sleep and keep up with that stress-free lifestyle! Your skin is looking gorgoues.',
      },
      firmness: {
        notGood:
          'In need of a skincare boost? Try a collagen-boosting mask to help to restore volume and firmness to your skin.',
        average:
          'A gentle massage of your face will help to lift and sculpt your skin, stimulating muscles that will improve your overall skin volume and appearance.',
        good: "You're looking as youthful and glowy as ever. Keep it up!",
      },
      droopy_upper_eyelid: {
        notGood:
          'Look for products with resveratrol which naturally help to slow cell aging and keep skin looking tigh and lifted.',
        average:
          'In need of a little lift? Place.two chilled cucumber slices over eyes for 10-20 minutes to naturally tighten skin and improve sagging.',
        good:
          'Hey there good looking! Tell us all your skincare secrets- your skin is looking good.',
      },
      droopy_lower_eyelid: {
        notGood:
          'Look for products with resveratrol which naturally help to slow cell aging and keep skin looking tigh and lifted.',
        average:
          'In need of a little lift? Place.two chilled cucumber slices over eyes for 10-20 minutes to naturally tighten skin and improve sagging.',
        good:
          'Hey there good looking! Tell us all your skincare secrets- your skin is looking good.',
      },
      radiance: {
        notGood:
          'Cleanse, exfoliate, hydrate, and protect to revive a gorgeous glow. Look for products with star brighteners like Vitamin C and Niacinamide (vitamin B3) which help to illuminate complexion.',
        average:
          'Clear your canvas with a gentle cleanser-morning and night- to wash away pore-clogging gunk and let your natural glow shine through.',
        good:
          "You're glowing and gorgeous! Keep up the good work and enjoy that beautiful radiance.",
      },
      acne: {
        notGood:
          "Hands off your face! Focus on keeping skin clean with a gentle cleanser and replenishing moisture with a lightweight moisturizer that won't clog pores. Don't forget to clean your makeup brushes too.",
        average:
          "Be gentle with your skin and keep it clean and hydrated. Hyrdation helps to re-balance skin's oil glands to control acne and improve healing.",
        good:
          "Keep your hands off your face and don't forget your daily SPF and moisturizer to keep your clear skin pampered and protected.",
      },
      pore: {
        notGood:
          'To help declog pores use a gentle cleanser twice daily and opt for non-comedogenic skin care and makeup products.',
        average:
          'Keep up with twice daily cleansing to help wash away dirt, sweat, and grime from the day which can otherwise settle into pores.',
        good:
          "Someone's mastered beautiful complexion! Keep up the great work.",
      },
      dark_circle_v2: {
        notGood:
          'It might be time to look for a retinoid to help stimulate collagen production and restore volume and firmness in the sensitive skin below your eyes. This will help to improve any undereye darkness.',
        average:
          'First take a deep breathe and feel the weight being lifted off your shoulders. Then dab an antioxidant-rich cream undereyes to help stimulate and brighten the area.',
        good:
          'Continue to get your beauty rest! Your skin is looking healthy and refreshed.',
      },
    },
    fra: {
      age_spot: {
        average:
          "Continuez votre routine avec un nettoyage 2 fois par jour avec votre nettoyant doux favori et n'oubliez pas l'hydratation.",
        good:
          'Votre peau est superbe. Continuez à utiliser votre hydratant et protection solaire.',
        notGood:
          "Ne touchez pas votre visage pendant la journée et soyez assidu dans votre routine visage incluant un nettoyant doux et un traitement de l'acné.",
      },
      redness: {
        average:
          'Vous cherchez à calmer des rougeurs? Appliquez des produits à base de niacinamide pour stopper les inflamations, unifier et renforcer votre peau.',
        good:
          'Continuez sur cette voie. Votre teint parfait en dit long sur votre routine.',
        notGood:
          "Arrêtez l'exfoliation et optez pour l'hydratation avec des produits aux ingrédients calmants comme le niacinamide, la réglisse, l'aloë, la caféine ou le concombre pour aider à réduire les rougeurs.",
      },
      moisture: {
        average:
          "Servez-vous un verre d'eau ! Prenez en complément avec un hydratant à base d'acide hyaluronique, de glycérine ou de céramides pour réhydrater votre peau.",
        good:
          "Quelle belle peau hydratée! Continuez avec l'hydratation quotidienne et apréciez cette douceur.",
        notGood:
          "Votre peau a besoin d'hydratation alors offrez-vous une dose quotidienne d'hydratation à base d'acide hyaluronique ainsi qu'une crème de nuit riche pour une peau hydratée au réveil.",
      },
      oiliness: {
        average:
          "Un peu trop de brillance? Essayez un nettoyant avec de l'acide salicylique qui exfolit en douceur, nettoie les pores sans assécher la peau.",
        good:
          'Vous êtes resplendissante là où il faut. Continuez à faire les bons gestes pour être lumineuse.',
        notGood:
          'Des ingrédients comme les acides alpha hydroxilés aident à réguler la production de sébum et à combattre les brillances.Un masque au charbon peut aussi retirer les impuretés.',
      },
      wrinkle: {
        average:
          "Le soleil fait des dégats sur votre peau et la protection solaire est votre défense n°1. Adoptez au minimum un SPF30 et renouvelez l'application fréquemment.",
        good:
          "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
        notGood:
          "Trouvez des produits avec de l'acide hyaluronique. Ce superbe hydratant retient plus de mille fois son poids en eau pour aider à hydrater votre peau et à retrouver une peau lisse et rebondie.",
      },
      texture: {
        average:
          'Donnez un coup de fouet à votre peau avec un serum anti-oxydant riche en vitames C qui aidera à la réparer et à la protéger des aggressions extérieures pour un teint lumineux et en bonne santé.',
        good:
          "Votre peau est magnifique alors n'oubliez pas votre protection solaire pour un visage toujours aussi protégé.",
        notGood:
          'Vous voulez améliorer la texture de votre peau? Utilisez un exfoliant une à deux fois par semaine pour retirer les peaux mortes et dévoiler une peau lumineuse.',
      },
      eye_bag: {
        average:
          "Essayez une compresse froide ou des sachets de thé pour réduire les poches sous les yeux. Appliquez des produits à base de concombre ou d'eau de rose pour hydrater et calmer cette zone.",
        good:
          'Le sommeil est important. Continuez avec cette vie sans stress. Votre peau est magnifique.',
        notGood:
          'Cherchez des produits doux et anti-inflammatoires avec du thé vert ou de la caféine pour aider à réduire le côté gonflé de la peau sensible qui se trouve sous les yeux.',
      },
      firmness: {
        average:
          "Un massage léger du visage aidera à raffermir et sculpter la peau, en stimulant les muscles qui améliorent le volume et l'apparence de la peau.",
        good:
          'Votre peau est plus jeune et lumineuse que jamais. Continuez comme ça!',
        notGood:
          "Votre peau a besoin d'un boost de soin ? Essayez un masque au collagène pour restorer son volume et sa fermeté.",
      },
      droopy_upper_eyelid: {
        average:
          "Besoin d'un petit lifting? Placez deux concombres froids sur vos yeux pendant 10 à 20 minutes pour raffermir votre peau et ralentir l'affaissement.",
        good: 'Dites-nous tous vos secrets pour cette peau resplendissante!',
        notGood:
          'Trouvez des produits contenant de resveratrol qui aide naturellement à ralentir le veillissement des cellules et à garder la peau ferme.',
      },
      droopy_lower_eyelid: {
        average:
          "Besoin d'un petit lifting? Placez deux concombres froids sur vos yeux pendant 10 à 20 minutes pour raffermir votre peau et ralentir l'affaissement.",
        good: 'Dites-nous tous vos secrets pour cette peau resplendissante!',
        notGood:
          'Trouvez des produits contenant de resveratrol qui aide naturellement à ralentir le veillissement des cellules et à garder la peau ferme.',
      },
      radiance: {
        average:
          "Prenez une grande inspiration et sentez le poids s'envoler de vos épaules. Puis appliquez une noisette de crème antioxidante sous vos yeux pour aider à illuminer cette zone.",
        good:
          'Continuez à vous reposer ! Votre peau est fraîche et en bonne santé.',
        notGood:
          'Il est temps de passer au rétinol pour vous aider à stimuler le collagène et restorer le volume et la fermeté de la peau sensible sous les yeux. Cela aidera à améliorer vos cernes.',
      },
      acne: {
        average:
          "Soyez doux avec votre peau et gardez la propre et hydratée. L'hydratation aide à ré-équilibrer la peau grasse et à contrôler l'acné tout en la soignant.",
        good:
          "Ne touchez pas votre visage et n'oubliez pas de protéger votre peau et de la garder hydratée pour une peau propre et protégée.",
        notGood:
          "Ne touchez pas votre visage! Concentrez-vous sur la façon de garder une peau propre et une hydratation fluide qui ne bouchera pas nos pores. N'oubliez pas de nettoyer vos pinceaux.",
      },
      pore: {
        average:
          'Continuez avec un nettoyage de la peau deux fois par jour pour aider à vous débarasser de la saleté, de la transpiration qui pourraient boucher vos pores.',
        good: 'Vous savez être maîtresse de votre teint. Continuez comme ça.',
        notGood:
          'Pour déboucher vos pores, utilisez un nettoyant doux deux fois par jour et optez pour des produits de soin et pour du maquillage non-comédogènes.',
      },
      dark_circle_v2: {
        average:
          "Prenez une grande inspiration et sentez le poids s'envoler de vos épaules. Puis appliquez une noisette de crème antioxidante sous vos yeux pour aider à illuminer cette zone.",
        good:
          'Continuez à vous reposer ! Votre peau est fraîche et en bonne santé.',
        notGood:
          'Il est temps de passer au rétinol pour vous aider à stimuler le collagène et restorer le volume et la fermeté de la peau sensible sous les yeux. Cela aidera à améliorer vos cernes.',
      },
    },
    jpn: {
      age_spot: {
        average:
          '1日2回、マイルドな洗顔料でクレンジングをし、保湿ケアも忘れずに行ってください。',
        good: '肌の状態は良好です。毎日の保湿と日焼け対策を続けてください。',
        notGood:
          '日中は顔に手を触れないようにし、肌に優しい洗顔料やニキビ用のスキンケアをこまめに行いましょう。',
      },
      redness: {
        average:
          '肌の赤みが気になります。ナイアシンアミドが配合された製品は、炎症を鎮め、肌の色を均一にし、肌の免疫を高める効果があります。',
        good:
          '肌の色合いは良好です。今のスキンケアを続けて、色合いを維持しましょう。',
        notGood:
          '角質除去剤の使用を控え、保湿効果の高いモイスチャライザーを使用してください。ナイアシンアミド、甘草根、アロエ、カフェイン、キュウリなど、鎮静効果のある成分が配合された製品をおすすめします。',
      },
      moisture: {
        average:
          'コップ1杯の水を飲んでください。ヒアルロン酸、グリセリン、セラミドなどを配合した保湿剤で、肌に水分と潤いを補いましょう。',
        good:
          '肌は潤っています。毎日の保湿を続けて、潤いのある肌をキープしてください。',
        notGood:
          'ヒアルロン酸入りの日中用モイスチャライザーと、保湿効果の高いナイトクリームを使用し、肌に潤いを与えましょう。',
      },
      oiliness: {
        average:
          '少しテカリが気になるようです。サリチル酸が配合された洗顔料は、毛穴の汚れをやさしく取り除き、肌の乾燥を防ぎます。',
        good: '適切な油分が保たれています。その状態をキープしてください。',
        notGood:
          'α-ヒドロキシ酸などの成分が含まれた化粧水は、皮脂の過剰分泌を防ぎます。また、炭入りのフェイスパックは、余分なテカリの原因となる不純物を取り除きます。',
      },
      wrinkle: {
        average:
          '太陽の紫外線は肌にダメージを与えます。SPF30以上の日焼け止めを選び、こまめに塗りなおしてください。',
        good:
          '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
        notGood:
          'ヒアルロン酸が配合された製品をおすすめします。ヒアルロン酸は1,000倍の水を保持し、角質層の水分量を高め、ふっくらとした滑らかな肌を取り戻します。',
      },
      texture: {
        average:
          '抗酸化作用のあるビタミンC美容液で肌のキメを整えてください。徐々に健康的な肌ツヤを与えます。',
        good:
          '肌の状態は良好です。美しい顔を守るために日焼け対策を忘れないでください。',
        notGood:
          '肌のキメが気になります。週に1～2回、角質ケア製品で古い角質をやさしく取り除き、美しく輝く肌を手に入れましょう。',
      },
      eye_bag: {
        average:
          '目の下のむくみを抑えるには、起床後と就寝前に冷湿布やティーバッグを使ってみましょう。また、目の下に潤いを与えて落ち着かせるために、キュウリやバラの水を使った製品もお勧めです。',
        good:
          '肌の状態は良好です。睡眠時間を増やして、ストレスのない生活を心がけてください。',
        notGood:
          '目の下のむくみを抑えるには、緑茶やカフェインが配合された鎮静・抗炎症作用のある製品を使用してください。',
      },
      firmness: {
        average:
          '顔を優しくマッサージすることで、肌をリフトアップします。また、筋肉を刺激することで、肌全体のボリュームをアップさせ、見た目の印象を良くします。',
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        notGood:
          'コラーゲンが配合されたフェイスパックでたるみを防ぎ、お肌に弾力とハリを与えましょう。',
      },
      droopy_upper_eyelid: {
        average:
          'リフトアップが必要です。冷やしたきゅうりの輪切り2枚を目の上に10～20分置くと、肌が自然に引き締まり、たるみが改善されます。',
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        notGood:
          'レスベラトロールが配合された製品は、細胞の老化を遅らせ、肌の弾力を改善する効果が期待されています。',
      },
      droopy_lower_eyelid: {
        average:
          'リフトアップが必要です。冷やしたきゅうりの輪切り2枚を目の上に10～20分置くと、肌が自然に引き締まり、たるみが改善されます。',
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        notGood:
          'レスベラトロールが配合された製品は、細胞の老化を遅らせ、肌の弾力を改善する効果が期待されています。',
      },
      radiance: {
        average:
          '抗酸化作用のあるクリームを目の下にのせることで刺激が与えられ、目の下を明るくします。',
        good:
          '肌は健康的でリフレッシュされた状態です。引き続き、美しさを保つために睡眠を十分にとってください。',
        notGood:
          '目の下の敏感な皮膚のコラーゲン生成を促進し、たるみや肌の弾力ケアに効果的なレチノイドを使用してみてください。目の下の暗さが改善されます。',
      },
      acne: {
        average:
          '肌を清潔に、保湿状態を保ってください。保湿は肌の油腺のバランスを整え、ニキビを抑制し、治癒力を高めます。',
        good:
          '肌は清潔です。その状態を保つために手で顔に触れず、毎日の保湿と日焼け対策を忘れないでください。',
        notGood:
          '手がなるべく顔に触れないようにしてください。肌に優しい洗顔料で清潔に保ち、毛穴を詰まらせない軽いテクスチャーの保湿剤で水分を補給しましょう。メイクブラシのお手入れも忘れずに。',
      },
      pore: {
        average:
          '1日2回のクレンジングで、毛穴に詰まった汚れや汗を洗い流してください。',
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        notGood:
          '1日2回、肌に優しい洗顔料で毛穴の汚れを落とし、ニキビになりにくいノンコメドジェニックのスキンケアや化粧品を選びましょう。',
      },
      dark_circle_v2: {
        average:
          '抗酸化作用のあるクリームを目の下にのせることで刺激が与えられ、目の下を明るくします。',
        good:
          '肌は健康的でリフレッシュされた状態です。引き続き、美しさを保つために睡眠を十分にとってください。',
        notGood:
          '目の下の敏感な皮膚のコラーゲン生成を促進し、たるみや肌の弾力ケアに効果的なレチノイドを使用してみてください。目の下の暗さが改善されます。',
      },
    },
    kor: {
      age_spot: {
        average:
          '선호하는 중성 클렌저로 하루 두 번 클렌징을 계속하시고, 보습을 잊지 마세요.',
        good:
          '멋지군요! 피부 상태가 아주 좋습니다. 매일매일 보습과 자외선차단제를 지금처럼 유지하세요.',
        notGood:
          '낮 동안에는 얼굴에 손을 대지 말고 순한 클렌저와 여드름 치료제를 포함해 순한 스킨케어 루틴을 부지런히 따르세요.',
      },
      redness: {
        average:
          '홍조를 완화시킬 수 있는 제품을 찾고 있나요? 염증을 완화하고 피부톤을 고르게 할 뿐 아니라 피부를 강화시켜주는 나이아신아미드가 함유된 제품을 고르세요.',
        good: '잘 하고 계십니다! 아름다운 피부톤이 결과를 직접 말해줍니다.',
        notGood:
          '엑스폴리언트는 내려놓고 모이스처라이저를 사용하세요. 홍조를 줄이는 데 도움이 되는 나이아신아미드, 감초, 알로에, 카페인, 오이 등 수딩 성분이 있는 제품을 고르세요.',
      },
      moisture: {
        average:
          '물 한 컵을 쭉 마시세요! 보습과 수분 공급에 효과적인 히알루론산, 글리세린 또는 세라마이드가 함유된 보습제를 매일매일 보충하세요.',
        good:
          '보습이 잘 된 피부군요! 매일매일 보습을 유지하고 촉촉하고 보들보들한 피부를 즐기세요.',
        notGood:
          '피부에 수분을 보충해야 합니다. 히알루론산이 함유된 데일리 모이스처라이저, 리치 오버나이트 크림을 바르면 아침에 촉촉한 피부를 느낄 수 있어요.',
      },
      oiliness: {
        average:
          '얼굴이 너무 번들거리나요? 각질을 부드럽게 제거해 모공을 깨끗하게 하되 피부를 건조하지 않게 해주는 살리실산이 함유된 클렌저를 사용해보세요.',
        good: '유분이 적당합니다! 꾸준히 관리해서 빛나는 피부를 유지하세요!',
        notGood:
          '유분을 조절해 지나친 번들거림을 막아주는 알파히드록시산과 같은 성분이 있는 스킨 토너를 고려하세요. 차콜 마스크도 과도한 번들거림을 생기게 하는 불순물을 제거하는 데 도움이 됩니다.',
      },
      wrinkle: {
        average:
          '햇빛은 피부를 크게 파괴시키며 제일의 방어책은 자외선차단제를 바르는 것입니다. SPF 지수가 30 이상인 제품을 고르고 자주 덧발라 주세요.',
        good:
          '대단하군요! 이제, 매끄럽고 아름다운 피부를 보호할 수 있도록 자외선차단제를 듬뿍 바르는 것을 잊지 마세요.',
        notGood:
          '히알루론산이 함유된 제품을 고르세요. 이 슈퍼하이드레이터는 1000배의 수분을 함유하고 있어 피부에 수분을 보충하고 볼륨과 매끄러운 피부결을 되찾게 해줍니다.',
      },
      texture: {
        average:
          '항산화제가 풍부한 비타민 C 세럼으로 피부결을 보완하여 피부 재생과 보호를 돕고 건강하고 밝은 피부안색으로 경험해 보세요.',
        good:
          '피부 상태가 좋습니다. 아름다운 얼굴을 계속해서 보호할 수 있도록 잊지말고 자외선차단제를 듬뿍 바르세요.',
        notGood:
          '피부결을 개선하고 싶으신가요? 일주일에 두 세번 정도 엑스폴리안츠를 사용해 죽은 피부 세포를 부드럽게 벗겨내고 아름답고 광채나는 안색을 발견해 보세요.',
      },
      eye_bag: {
        average:
          '하루의 시작이나 끝에 냉습포 또는 티백을 대고 있으면 눈의 붓기를 없애는 데 도움이 됩니다. 수분을 공급하고 진정 효과가 있는 오이 또는 로즈 워터가 함유된 제품을 고르세요.',
        good:
          '두 배로 충분한 수면을 취하고 스트레스 없는 라이프스타일을 유지하세요! 당신의 피부는 멋집니다.',
        notGood:
          '민감한 눈밑 부위의 붓기를 줄이는 데 효과적인 녹차 또는 카페인 성분이 함유된 수딩 및 항염증성 제품을 고르세요.',
      },
      firmness: {
        average:
          '얼굴을 부드럽게 마사지하면 처진 피부를 리프팅 & 리모델링하는 데 도움이 되며 근육을 자극해 전반적인 피부 볼륨과 외관을 개선해줍니다.',
        good: '피부가 여전히 탱탱하고 빛이 나네요. 계속 꾸준히 관리하세요!',
        notGood:
          '효과적인 피부관리 비법이 리프팅이 필요한가요? 콜라겐 부스트 마스크를 사용해 보세요. 볼륨과 탄력을 되찾는 데 도움이 됩니다.',
      },
      droopy_upper_eyelid: {
        average:
          '약간의 리프팅이 필요한가요? 오이 슬라이스 두 장을 눈 위에 10-20분 정도 놓아 두면 피부가 조여지고 쳐짐이 개선된 것을 느낄 수 있습니다.',
        good: '아름답군요! 피부관리 비법을 알려주세요.',
        notGood:
          '자연적으로 세포 노화 속도를 늦추고 피부의 탄력과 리프팅을 개선해주는 레스베라트롤이 함유된 제품을 고르세요.',
      },
      droopy_lower_eyelid: {
        average:
          '약간의 리프팅이 필요한가요? 오이 슬라이스 두 장을 눈 위에 10-20분 정도 놓아 두면 피부가 조여지고 쳐짐이 개선된 것을 느낄 수 있습니다.',
        good: '아름답군요! 피부관리 비법을 알려주세요.',
        notGood:
          '자연적으로 세포 노화 속도를 늦추고 피부의 탄력과 리프팅을 개선해주는 레스베라트롤이 함유된 제품을 고르세요.',
      },
      radiance: {
        average:
          '먼저 심호흡을 하고 어깨에서 짓눌린 무게가 사라지는 기분을 느껴보세요. 그런 다음 항산화제가 풍부한 크림을 눈 밑에 두드리듯이 발라 눈가를 자극하고 밝게 해주세요.',
        good: '충분한 휴식을 취하세요! 피부가 생기 있고 건강합니다.',
        notGood:
          '콜라겐 생성을 자극하고 눈밑의 민감한 피부 볼륨과 탄력을 되찾기 위해 레티노이드 제품을 찾기에 적당한 때입니다. 이러한 제품은 눈밑의 다크서클을 개선하는 데 도움이 됩니다.',
      },
      acne: {
        average:
          '피부에 순한 제품으로 피부를 깨끗하고 촉촉한 상태로 유지하세요. 보습은 피부의 유분 균형을 맞춰 여드름을 조절하고 치유를 개선해줍니다.',
        good:
          '얼굴에 손을 대지 말고 매일 자외선차단제와 보습제를 발라 깨끗한 피부를 유지하고 피부를 안전하게 보호해 주세요.',
        notGood:
          '얼굴에 손을 대지 마세요! 손한 클렌저와 리플레싱 모이스처라이저로 피부를 깨끗하게 유지하는 데 집중하세요. 모공을 막지 않게 가벼운 모이스처라이저를 사용하세요. 메이크업 브러시 세척도 잊지 마세요.',
      },
      pore: {
        average:
          '하루에 두 번 클렌징해서 모공을 막고 있을 수 있는 이물질, 땀, 피지 등을 제거하세요.',
        good: '피부안색이 아주 아름다워요! 계속 꾸준히 관리하세요.',
        notGood:
          '모공을 깨끗이 닦아내기 위해서는 하루에 두 번 순한 클렌저를 사용하고 논-코메도제닉 스킨케어 및 메이크업 제품을 고르세요.',
      },
      dark_circle_v2: {
        average:
          '먼저 심호흡을 하고 어깨에서 짓눌린 무게가 사라지는 기분을 느껴보세요. 그런 다음 항산화제가 풍부한 크림을 눈 밑에 두드리듯이 발라 눈가를 자극하고 밝게 해주세요.',
        good: '충분한 휴식을 취하세요! 피부가 생기 있고 건강합니다.',
        notGood:
          '콜라겐 생성을 자극하고 눈밑의 민감한 피부 볼륨과 탄력을 되찾기 위해 레티노이드 제품을 찾기에 적당한 때입니다. 이러한 제품은 눈밑의 다크서클을 개선하는 데 도움이 됩니다.',
      },
    },
    deu: {
      age_spot: {
        average:
          'Setze deine Pflege zweimal pro Tag mit deiner Lieblings-Reinigungslösung fort und vergiss nicht, die Haut feucht zu halten.',
        good:
          'Hallo Schönheit! Deine Haut sieht ausgezeichnet aus. Benutze auch weiterhin deinen tägliche Feuchtigkeitsspender und Sonnenschutz.',
        notGood:
          'Berühre dein Gesicht tagsüber nicht mit deinen Händen und verwende eine sanfte Pflegeroutine mit einem sanften Reinigungsprodukt und einer Akne-Pflegebehandlung.',
      },
      redness: {
        average:
          'Möchtest du Rötungen auf der Haut lindern? Achte auf Produkte mit Niacinamid, die Entzündungen lindern, den Hautton ausgleichen und die Haut stärken.',
        good:
          'Mach so weiter wie bisher! Dein wunderschöner Hautton spricht Bände.',
        notGood:
          'Leg das Peeling zur Seite und nimm eine Feuchtigkeitspflege zur Hand. Achte auf Produkte mit beruhigenden Inhaltsstoffen wie Niacinamid, Süßholzwurzel, Aloe, Koffein und Gurke, die helfen, Rötungen zu reduzieren.',
      },
      moisture: {
        average:
          'Gieß dir ein Glas Wasser ein und trink! Ergänze dann eine tägliche Feuchtigkeitscreme mit Hyaluronsäure, Glycerin oder Ceramiden, um die Haut zu rehydrieren und mit Feuchtigkeit zu versorgen.',
        good:
          'Hallo wunderschöne hydrierte Haut! Fahr mit dem täglichen Feuchtigkeitsspender fort und genieße deine pralle Haut.',
        notGood:
          "Deine Haut braucht zusätzliche Feuchtigkeit also gönn dir eine tägliche Feuchtigkeitscreme mit Hyaluronsäure , und eine reichhaltige Creme für die Nacht damit' am Morgen wieder mit Feuchtigkeit versorgt ist.",
      },
      oiliness: {
        average:
          'Bekommst du zuviel Sonnenschein ab? Versuch es mit einem Reiniger mit Salicylsäure, das sanft peelt, um die Poren zu reinigen, aber die Haut nicht austrocknet.',
        good:
          'Sieht so aus, als strahlst du an den richtigen Stellen! Mach weiter so und strahle schön!',
        notGood:
          'Hole dir einen Haut-Toner mit Bestandteilen wie Alpha-Hydroxidsäuren, die die Fettproduktion regulieren und übermäßig fettige Haut bekämpfen. Eine Kohlemaske entzieht auch die Unreinheiten, die besonders glänzen.',
      },
      wrinkle: {
        average:
          'Die Sonne verletzt deine Haut und Sonnenschutz ist deine beste Verteidigung. Verwende einen Sonnenschutzfaktor von mindestens 30 und trage diesen mehrmals täglich auf.',
        good:
          'Sieht gut aus! Vergiss jetzt nicht, den Sonnenschutz aufzutragen, um deine glatte, wunderschöne Haut zu schützen.',
        notGood:
          'Suche dir ein Produkt mit Hyaluronsäure. Dieser Superbefeuchter ist 1000 Mal so gut wie Wasser, stellt die Feuchtigkeit der Haut wieder her und führt zu einem prallen, glatten Erscheinungsbild.',
      },
      texture: {
        average:
          'Booste deine Hauttextur mit einem Antioxidant-angereicherten Vitamin-C-Serum, das die Haut repariert und sie vor Witterung schützt. Dies verleiht deinem Gesicht ein sofortiges gesundes Leuchten.',
        good:
          'Deine Haut sieht gut aus, also vergiss nicht, den Sonnenschutz großzügig aufzutragen, um dein schönes Gesicht zu schützen.',
        notGood:
          'Möchtest du deine Hauttextur verbessern? Verwende ein bis zwei Mal pro Woche ein Peeling, um abgestorbene Hautzellen sanft abzutragen und einen schönen, strahlenden Teint zu erhalten.',
      },
      eye_bag: {
        average:
          'Versuch es morgens und abends mit einer kalten Kompresse oder Teebeuteln, um die Tränensäcke unter den Augen zu reduzieren. Hole dir auch Produkte mit Gurken- oder Rosenwasser, um diesen Bereich zu hydrieren und zu beruhigen.',
        good:
          'Halte unbedingt deinen Schönheitsschlaf ein und behalte deinen stressfreien Lebensstil bei! Deine Haut sieht wunderschön aus.',
        notGood:
          'Suche nach beruhigenden und entzündungshemmenden Produkten mit grünem Tee oder Koffein, um Schwellungen unter der empfindlichen Augenpartie zu reduzieren.',
      },
      firmness: {
        average:
          'Eine sanfte Gesichtsmassage hilft, die Haut zu straffen und zu modellieren, und stimuliert die Muskeln, die das Volumen und das Aussehen der Haut insgesamt verbessern.',
        good:
          'Du siehst wie immer jugendlich und strahlend aus. Mach so weiter!',
        notGood:
          'Brauchst du einen Hautpflege-Booster? Versuche es mit einer Kollagen-Boosting-Maske, um deiner Haut Volumen und Festigkeit zu geben.',
      },
      droopy_upper_eyelid: {
        average:
          'Brauchst du einen kleinen Lift? Lege zwei gekühlte Gurkenscheiben für 10-20 Minuten auf die Augen, um die Haut auf natürliche Weise zu straffen und die Hauterschlaffung zu verbessern.',
        good:
          'Hallo, du Schönheit! Teile deine Hautpflegegeheimnisse mit uns – deine Haut sieht super aus.',
        notGood:
          'Achte auf Produkte mit Resveratrol, die auf natürliche Weise dazu beitragen, die Zellalterung zu verlangsamen und die Haut straff und geliftet aussehen zu lassen.',
      },
      droopy_lower_eyelid: {
        average:
          'Brauchst du einen kleinen Lift? Lege zwei gekühlte Gurkenscheiben für 10-20 Minuten auf die Augen, um die Haut auf natürliche Weise zu straffen und die Hauterschlaffung zu verbessern.',
        good:
          'Hallo, du Schönheit! Teile deine Hautpflegegeheimnisse mit uns – deine Haut sieht super aus.',
        notGood:
          'Achte auf Produkte mit Resveratrol, die auf natürliche Weise dazu beitragen, die Zellalterung zu verlangsamen und die Haut straff und geliftet aussehen zu lassen.',
      },
      radiance: {
        average:
          'Atme zunächst tief durch und fühl wie dir die Last von den Schultern fällt. Tupfe danach eine mit Antioxidant angereicherte Creme unter die Augen, um diesen Bereich zu stimulieren und strahlen zu lassen.',
        good:
          'Gönn dir auch weiterhin deinen Schönheitsschlaf! Deine Haut sieht gesund und erfrischt aus.',
        notGood:
          'Vielleicht wird es Zeit, ein Retinoid zu benutzen, um die Collagen-Produktion anzukurbeln und deiner empfindlichen Haut unter den Augen wieder Volumen und Straffheit zu geben. Dies hilft gegen jegliche dunkle Ringe unter den Augen.',
      },
      acne: {
        average:
          'Behandle deine Haut sanft und halte sie sauber und hydriert. Hydrieren hilft der Haut, die Fettdrüsen auszugleichen, um Akne zu kontrollieren und die Heilung zu fördern.',
        good:
          'Lass die Finger von deinem Gesicht und vergiss nicht deinen täglichen Sonnenschutz und deine Feuchtigkeitscreme, um deine klare Haut zu verwöhnen und zu schützen.',
        notGood:
          'Keine Hände ins Gesicht! Konzentriere dich mit einem sanfter Reiniger auf saubere und führe deiner Haut mit einer leichten Feuchtigkeitscreme Feuchtigkeit zu, die die Poren nicht verstopft. Vergiss auch nicht, deine Makeup-Pinsel zu reinigen.',
      },
      pore: {
        average:
          'Setze deine Reinigung zweimal täglich fort, um Schmutz, Schweiß und Rückstände vom Tag abzuwaschen, die sich sonst in den Poren festsetzen könnten.',
        good: 'Ein meisterhafter wunderschöner Teint! Mach genau so weiter.',
        notGood:
          'Um die Poren zu verkleinern, verwende zweimal täglich ein sanftes Reinigungsmittel und entscheide dich für nicht komedogene Hautpflege- und Makeup-Produkte.',
      },
      dark_circle_v2: {
        average:
          'Atme zunächst tief durch und fühl wie dir die Last von den Schultern fällt. Tupfe danach eine mit Antioxidant angereicherte Creme unter die Augen, um diesen Bereich zu stimulieren und strahlen zu lassen.',
        good:
          'Gönn dir auch weiterhin deinen Schönheitsschlaf! Deine Haut sieht gesund und erfrischt aus.',
        notGood:
          'Vielleicht wird es Zeit, ein Retinoid zu benutzen, um die Collagen-Produktion anzukurbeln und deiner empfindlichen Haut unter den Augen wieder Volumen und Straffheit zu geben. Dies hilft gegen jegliche dunkle Ringe unter den Augen.',
      },
    },
    esp: {
      age_spot: {
        average:
          'Continúe limpiándose dos veces al día con su limpiador suave preferido y no olvide la hidratación.',
        good:
          '¡Hola, guapa! Su piel tiene un aspecto fenomenal. Continúe con su hidratante y protector solar a diario.',
        notGood:
          'No se lleve las manos a la cara durante el día y sea diligente con una suave rutina de cuidado de la piel que incluya un limpiador suave y un tratamiento antiacné.',
      },
      redness: {
        average:
          '¿Busca cómo calmar algunas rojeces de la piel? Busque productos con niacinamida para calmar la inflamación, homogeneizar el tono de la piel y ayudar a fortalecer la piel.',
        good:
          '¡Continúe haciendo lo que hace! Su tono de piel, hermoso y uniforme, habla por sí solo.',
        notGood:
          'Deje los exfoliantes y tome un hidratante. Busque productos con ingredientes calmantes tales como niacinamida, raíz de regaliz, aloe, cafeína y pepino, que ayudan a reducir el enrojecimiento.',
      },
      moisture: {
        average:
          '¡Sírvase un vaso de agua y beba! Luego complemente con una crema hidratante diaria con ácido hialurónico, glicerina o ceramidas para ayudar rehidratar e hidratar la piel.',
        good:
          '¡Hola, hermosa piel hidratada! Continúe con la crema hidratante diaria y disfrute de esa flexibilidad.',
        notGood:
          'Su piel necesita más hidratación, así que regálese una crema hidratante diaria con ácido hialurónico y una crema de noche enriquecida, para restaurar la humedad por la mañana.',
      },
      oiliness: {
        average:
          '¿Batallando con un libero exceso de brillo? Prueba un limpiador con ácido salicílico que exfolie suavemente para limpiarse los poros, pero que no seque la piel.',
        good:
          '¡Parece que brilla en todas las zonas correctas! ¡Siga con el buen trabajo y continúe resplandeciente!',
        notGood:
          'Considere un tónico para la piel con ingredientes como alfa hidroxiácidos para ayudar a regular la producción de grasa y combatir el exceso de grasa. Una máscara de carbón también ayuda a eliminar las impurezas, consiguiendo un brillo extra.',
      },
      wrinkle: {
        average:
          'El sol causa estragos en la piel, y el protector solar es su defensa número uno. Busque una fórmula con un factor de al menos 30 y repita la aplicación a menudo.',
        good:
          '¡Tiene buen aspecto! No olvide usar protector solar para mantener protegida esa piel tan suave y hermosa.',
        notGood:
          'Busque productos con ácido hialurónico. Este superhidratante conserva 1000 veces su peso en agua, ayudando a hidratar la piel y restaurar un aspecto esponjoso y suave.',
      },
      texture: {
        average:
          'Déle un impulso a la textura de la piel con un suero de Vitamina C rico en antioxidantes para ayudar reparar y proteger la piel de los elementos, y déle a su rostro un brillo saludable instantáneo.',
        good:
          'Su piel tiene buen aspecto, por lo que no debe olvidar echarse protector solar para mantener protegida esa hermosa cara.',
        notGood:
          '¿Desea mejorar la textura de la piel? Use un exfoliante una o dos veces a la semana para eliminar con suavidad las células muertas de la piel y presentar un tez hermosa y resplandeciente.',
      },
      eye_bag: {
        average:
          'Pruebe una compresa o bolsitas de té frías para comenzar o terminar el día para ayudar a reducir la hinchazón debajo de los ojos. Busque también productos con pepino o agua de rosas para ayudar a hidratar y calmar la zona.',
        good:
          '¡Redoble su sueño reparador y siga en la cima con ese estilo de vida libre de estrés! Su piel tiene un aspecto magnífico.',
        notGood:
          'Busque relajantes y productos antiinflamatorios con té verde o cafeína para ayudar a reducir la hinchazón en la sensible zona debajo de los ojos.',
      },
      firmness: {
        average:
          'Un suave masaje en el rostro ayudará a levantar y esculpir la piel, estimulando los músculos que mejoran el volumen general de la piel y su aspecto.',
        good:
          'Tiene un aspecto tan joven y resplandeciente como siempre. ¡Siga así!',
        notGood:
          '¿Necesita un impulso para el cuidado de la piel? Prueba una mascarilla potenciadora de colágeno para ayudar a restaurar el volumen y firmeza de la piel.',
      },
      droopy_upper_eyelid: {
        average:
          '¿Necesitas un pequeño empujón? Coloque dos rodajas de pepino frías sobre los ojos durante 10-20 minutos para tensar la piel de forma natural y mejorar la flacidez.',
        good:
          '¡Hola, tiene buen aspecto! Cuéntenos todos sus secretos para el cuidado de la piel: su piel luce espléndida.',
        notGood:
          'Busque productos con resveratrol, que ayuda de forma natural a retrasar el envejecimiento celular y a mantener la piel apretada y elevada.',
      },
      droopy_lower_eyelid: {
        average:
          '¿Necesitas un pequeño empujón? Coloque dos rodajas de pepino frías sobre los ojos durante 10-20 minutos para tensar la piel de forma natural y mejorar la flacidez.',
        good:
          '¡Hola, tiene buen aspecto! Cuéntenos todos sus secretos para el cuidado de la piel: su piel luce espléndida.',
        notGood:
          'Busque productos con resveratrol, que ayuda de forma natural a retrasar el envejecimiento celular y a mantener la piel apretada y elevada.',
      },
      radiance: {
        average:
          'En primer lugar, respire hondo y sienta cómo se libera el peso de los hombros. Luego aplique un crema rica en antioxidantes debajo de los ojos para ayuda a estimular e iluminar la zona.',
        good:
          '¡Continúe descansando su belleza! Su piel luce saludable y renovada.',
        notGood:
          'Podría ser el momento de buscar un retinoide para ayudar estimular la producción de colágeno y restaurar el volumen y la firmeza en la piel sensible debajo de los ojos. Esto ayudará a mejorar cualquier zona oscura debajo de los ojos.',
      },
      acne: {
        average:
          'Sea amable con su piel y manténgala limpia e hidratada. La hidratación ayuda a reequilibrar las glándulas sebáceas de la piel para controlar el acné y mejorar la cicatrización.',
        good:
          'No se lleve las manos a la cara y no se olvide de su protector solar e hidratante a diario para mantener su clara piel mimada y protegida.',
        notGood:
          '¡No se lleve las manos a la cara! Concéntrese en mantener la piel limpia con un limpiador suave y reponer la hidratación con un humectante libero que no obstruya los poros. No olvide limpiar también los pinceles de maquillaje.',
      },
      pore: {
        average:
          'Continúe con la limpieza dos veces al día para ayudar eliminar la suciedad y el sudor de cada día que, de lo contrario, puede asentarse en los poros.',
        good:
          '¡Alguien conoce el modo de mantener una tez hermosa! Continúe con el buen trabajo.',
        notGood:
          'Para ayudar a eliminar las obstrucciones de los poros, use un limpiador suave dos veces al día y opte por productos de cuidado y maquillaje no comedogénicos.',
      },
      dark_circle_v2: {
        average:
          'En primer lugar, respire hondo y sienta cómo se libera el peso de los hombros. Luego aplique un crema rica en antioxidantes debajo de los ojos para ayuda a estimular e iluminar la zona.',
        good:
          '¡Continúe descansando su belleza! Su piel luce saludable y renovada.',
        notGood:
          'Podría ser el momento de buscar un retinoide para ayudar estimular la producción de colágeno y restaurar el volumen y la firmeza en la piel sensible debajo de los ojos. Esto ayudará a mejorar cualquier zona oscura debajo de los ojos.',
      },
    },
    ita: {
      age_spot: {
        average:
          'Continua a detergere due volte al giorno con il tuo detergente delicato preferito e non dimenticare di idratare.',
        good:
          "Ciao bellezza! La tua pelle sembra abbastanza buona. Continua a usare la tua crema idratante quotidiana e l'SPF.",
        notGood:
          'Tieni le mani lontane dal viso durante il giorno e adotta una routine di cura della pelle delicata, che comprenda un detergente delicato e un trattamento per le macchie di acne.',
      },
      redness: {
        average:
          'Vorresti lenire i rossori della pelle? Prova prodotti con niacinamide, che lenisce le infiammazioni, uniforma il tono della pelle e aiuta a rafforzarla.',
        good: 'Continua così! La tua carnagione bella e uniforme parla da sé.',
        notGood:
          "Metti da parte gli esfolianti e usa una crema idratante. Prova prodotti con ingredienti lenitivi come la niacinamide, la radice di liquirizia, l'aloe, la caffeina e il cetriolo che aiutano a ridurre il rossore.",
      },
      moisture: {
        average:
          "Versati un bicchiere d'acqua e bevi! Quindi integra con una crema idratante quotidiana a base di acido ialuronico, glicerina o ceramidi per aiutare a reidratare e idratare la pelle.",
        good:
          "Ciao bella pelle idratata! Continua a usare l'idratante quotidiano e goditi la morbidezza della rugiada.",
        notGood:
          "La tua pelle ha bisogno di una maggiore idratazione: concediti una crema idratante quotidiana con acido ialuronico e una ricca crema per la notte per ripristinare l'idratazione al mattino.",
      },
      oiliness: {
        average:
          "Stai lottando contro un po' di lucentezza in più? Prova un detergente con acido salicilico che esfolia delicatamente per liberare i pori, ma non secca la pelle.",
        good:
          'Sembra che tu stia brillando in tutti i punti giusti! Continua a migliorare e a brillare!',
        notGood:
          "Considera un tonico per la pelle con ingredienti come gli alfa-idrossiacidi per aiutare a regolare la produzione di olio e combattere l'eccessiva oleosità. Una maschera al carbone aiuta anche a eliminare le impurità che causano una maggiore lucentezza.",
      },
      wrinkle: {
        average:
          "Il sole rovina la pelle e l'SPF è la difesa numero uno. Cerca una formula con almeno SPF 30 o superiore e riapplicala spesso.",
        good:
          "Sembra buono! Non dimenticare di applicare l'SPF per proteggere la pelle liscia e bella.",
        notGood:
          "Cerca prodotti con acido ialuronico. Questo super-idratante trattiene 1.000 volte il suo peso in acqua, aiutando a reintegrare l'idratazione della pelle e a restituirle un aspetto turgido e levigato.",
      },
      texture: {
        average:
          "Migliora la texture della tua pelle con un siero alla vitamina C, ricco di antiossidanti, che aiuta a riparare e proteggere la pelle dagli agenti atmosferici e dona al viso un'immediata luminosità.",
        good:
          "La tua pelle ha un bell'aspetto, quindi non dimenticare di applicare l'SPF per proteggere il tuo bel viso.",
        notGood:
          'Vuoi migliorare la texture della pelle? Usa un esfoliante una o due volte alla settimana per eliminare delicatamente le cellule morte e ottenere una carnagione bella e luminosa.',
      },
      eye_bag: {
        average:
          "Prova a fare un impacco freddo o una bustina di tè all'inizio o alla fine della giornata per ridurre le borse sotto gli occhi. Scegli anche prodotti con cetriolo o acqua di rose per idratare e calmare la zona.",
        good:
          'Fai il pieno di sonno di bellezza e continua a seguire uno stile di vita privo di stress! La tua pelle è splendida.',
        notGood:
          "Prova prodotti lenitivi e antinfiammatori con tè verde o caffeina per ridurre il gonfiore sotto l'area sensibile degli occhi.",
      },
      firmness: {
        average:
          "Un massaggio delicato del viso aiuterà a sollevare e scolpire la pelle, stimolando i muscoli che miglioreranno il volume e l'aspetto generale della pelle.",
        good:
          'Il tuo aspetto è più giovane e luminoso che mai. Mantienilo così!',
        notGood:
          'Hai bisogno di una spinta per la tua pelle? Prova una maschera che rafforza il collagene per aiutare a ripristinare il volume e la compattezza della pelle.',
      },
      droopy_upper_eyelid: {
        average:
          'Hai bisogno di un piccolo lifting? Posiziona due fette di cetriolo fredde sugli occhi per 10-20 minuti per rassodare naturalmente la pelle e ridurre il rilassamento.',
        good:
          "Ehi, bellezza! Svelaci tutti i tuoi segreti per la cura della pelle: la tua ha un bell'aspetto.",
        notGood:
          "Prova prodotti con resveratrolo, che aiuta naturalmente a rallentare l'invecchiamento cellulare e a mantenere la pelle alta e liftata.",
      },
      droopy_lower_eyelid: {
        average:
          'Hai bisogno di un piccolo lifting? Posiziona due fette di cetriolo fredde sugli occhi per 10-20 minuti per rassodare naturalmente la pelle e ridurre il rilassamento.',
        good:
          "Ehi, bellezza! Svelaci tutti i tuoi segreti per la cura della pelle: la tua ha un bell'aspetto.",
        notGood:
          "Prova prodotti con resveratrolo, che aiuta naturalmente a rallentare l'invecchiamento cellulare e a mantenere la pelle alta e liftata.",
      },
      radiance: {
        average:
          'Per prima cosa fai un respiro profondo e senti il peso che ti viene tolto dalle spalle. Quindi applica una crema ricca di antiossidanti sotto gli occhi per aiutare a stimolare e illuminare la zona.',
        good:
          'Continua il tuo beauty relax! La pelle ha un aspetto sano e rinnovato.',
        notGood:
          'Potrebbe essere il caso di cercare un retinoide che aiuti a stimolare la produzione di collagene e a ripristinare il volume e la compattezza della pelle sensibile sotto gli occhi. Questo aiuterà a ridurre la parte scura sotto gli occhi.',
      },
      acne: {
        average:
          "Tratta con delicatezza la tua pelle e mantienila pulita e idratata. Hyrdation aiuta a riequilibrare le ghiandole oleifere della pelle per controllare l'acne e migliorare la guarigione.",
        good:
          "Tieni le mani lontane dal viso e non dimenticare l'SPF e la crema idratante quotidiana per mantenere la pelle chiara rilassata e protetta.",
        notGood:
          'Giù le mani dal viso! Concentrati sulla pulizia della pelle con un detergente delicato e sulla reidratazione con una crema idratante leggera che non ostruisca i pori. Non dimenticate di pulire anche i pennelli da trucco.',
      },
      pore: {
        average:
          'Continua a fare la pulizia due volte al giorno per aiutare a lavare via lo sporco, il sudore e la sporcizia della giornata che altrimenti potrebbero depositarsi nei pori.',
        good:
          'Qualcuno è riuscito a ottenere una bella carnagione! Continua a migliorare.',
        notGood:
          'Per aiutare a liberare i pori, usa un detergente delicato due volte al giorno e opta per prodotti per il trucco e la cura della pelle non comedogenici.',
      },
      dark_circle_v2: {
        average:
          'Per prima cosa fai un respiro profondo e senti il peso che ti viene tolto dalle spalle. Quindi applica una crema ricca di antiossidanti sotto gli occhi per aiutare a stimolare e illuminare la zona.',
        good:
          'Continua il tuo beauty relax! La pelle ha un aspetto sano e rinnovato.',
        notGood:
          'Potrebbe essere il caso di cercare un retinoide che aiuti a stimolare la produzione di collagene e a ripristinare il volume e la compattezza della pelle sensibile sotto gli occhi. Questo aiuterà a ridurre la parte scura sotto gli occhi.',
      },
    },
  },
  HdResultDetectionDescription: {
    enu: {
      hd_spot: {
        fair:
          'Keep your hands off your face during the day and be diligent with a gentle skincare routine including a gentle cleanser and acne spot treatment.',
        average:
          "Continue with twice-daily cleansing with your favorite mild cleanser and don't forget to moisturize.",
        good:
          'Hello gorgeous! Your skin is looking mighty fine. Keep up with your daily moisturizer and SPF.',
      },
      hd_redness: {
        fair:
          'Put down the exfoliants and pick up a moisturizer. Look for products with soothing ingredients like niacinamide, licorice root, aloe, caffeine, and cucumber which help to reduce redness.',
        average:
          'Looking to soothe some redness on the skin? Look for products with niacinamide to soothe inflammation, even skin tone, and helps strengthen skin.',
        good:
          'Keep doing what your doing! Your beautiful even skintone speaks for itself.',
      },
      hd_moisture: {
        fair:
          'Add a daily moisturizer and overnight cream to your skincare routine to restore and rejuvenate your skin. This will help replenish and nourish your skin for a fresh, revitalized look in the morning.',
        average:
          "Pour yourself a glass of water and drink up! You can support your skin's health by using a daily moisturizer to help keep your skin feeling soft and supple.",
        good:
          'Hello beautiful hydrated skin! Keep up with the daily moisurizer and enjoy that dewy, suppleness.',
      },
      hd_oiliness: {
        fair:
          "If you're looking to regulate oil production and combat shine, consider using a skin toner that contains gentle exfoliating ingredients. These can help keep your pores clear and prevent excess oil buildup.",
        average:
          "Battling a little too much shine? Try a cleanser with Salicylic Acid that gently exfoliates to clear pores, but won't dry out your skin.",
        good:
          "Looks like you're shining in all the right places! Keep up the good work and glow away!",
      },
      hd_wrinkle: {
        fair:
          "Seek out moisturizers with potent hydrating ingredients that can help restore and improve your skin's moisture levels for a smoother and more youthful-looking complexion.",
        average:
          'Sun exposure can cause significant damage to your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
        good:
          "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
      },
      hd_wrinkle_forehead: {
        fair:
          "Seek out moisturizers with potent hydrating ingredients that can help restore and improve your skin's moisture levels for a smoother and more youthful-looking complexion.",
        average:
          'Sun exposure can cause significant damage to your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
        good:
          "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
      },
      hd_wrinkle_glabellar: {
        fair:
          "Seek out moisturizers with potent hydrating ingredients that can help restore and improve your skin's moisture levels for a smoother and more youthful-looking complexion.",
        average:
          'Sun exposure can cause significant damage to your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
        good:
          "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
      },
      hd_wrinkle_periocular: {
        fair:
          "Seek out moisturizers with potent hydrating ingredients that can help restore and improve your skin's moisture levels for a smoother and more youthful-looking complexion.",
        average:
          'Sun exposure can cause significant damage to your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
        good:
          "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
      },
      hd_wrinkle_crowfeet: {
        fair:
          "Seek out moisturizers with potent hydrating ingredients that can help restore and improve your skin's moisture levels for a smoother and more youthful-looking complexion.",
        average:
          'Sun exposure can cause significant damage to your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
        good:
          "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
      },
      hd_wrinkle_nasolabial: {
        fair:
          "Seek out moisturizers with potent hydrating ingredients that can help restore and improve your skin's moisture levels for a smoother and more youthful-looking complexion.",
        average:
          'Sun exposure can cause significant damage to your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
        good:
          "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
      },
      hd_wrinkle_marionette: {
        fair:
          "Seek out moisturizers with potent hydrating ingredients that can help restore and improve your skin's moisture levels for a smoother and more youthful-looking complexion.",
        average:
          'Sun exposure can cause significant damage to your skin and SPF is your number one defense. Look for a formula with at least SPF 30 or higher and reapply often.',
        good:
          "Looking good! Now, don't forget to slather on the SPF to keep that smooth, beautiful skin protected.",
      },
      hd_texture: {
        fair:
          "Want to enhance your skin's texture? Consider using a gentle product designed to remove dead skin cells one to two times per week to help reveal a more radiant and glowing complexion.",
        average:
          "Improve your skin's texture by using products that contain nutrients known to benefit the skin. These can help enhance the overall health and appearance of your skin, giving it a revitalized and healthy glow.",
        good:
          "Your skin is looking good so don't forget to slather on SPF to keep that beautiful face protected.",
      },
      hd_dark_circle: {
        fair:
          'It might be time to look for ways to stimulate collagen production and restore volume and firmness in the sensitive skin below your eyes. This will help to improve any undereye darkness.',
        average:
          'First take a deep breathe and feel the weight being lifted off your shoulders. Then dab an antioxidant-rich cream undereyes to help stimulate and brighten the area.',
        good:
          'Continue to get your beauty rest! Your skin is looking healthy and refreshed.',
      },
      hd_eye_bag: {
        fair:
          'Look for soothing and anti-inflammaory products with green tea or caffeine to help reduce puffiness under the senstive undereye area.',
        average:
          'Try a cold compress or tea bags to start--or end--the day to help to reduce under eye puffiness. Also look for products with cucumber or rose water to help hydrate and calm the area.',
        good:
          'Double down on your beauty sleep and keep up with that stress-free lifestyle! Your skin is looking gorgoues.',
      },
      hd_firmness: {
        fair:
          'In need of a skincare boost? Try a collagen-boosting mask to help to restore volume and firmness to your skin.',
        average:
          'A gentle massage of your face will help to lift and sculpt your skin, stimulating muscles that will improve your overall skin volume and appearance.',
        good: "You're looking as youthful and glowy as ever. Keep it up!",
      },
      hd_droopy_upper_eyelid: {
        fair:
          'Look for products with resveratrol which naturally help to slow cell aging and keep skin looking tigh and lifted.',
        average:
          'In need of a little lift? Place.two chilled cucumber slices over eyes for 10-20 minutes to naturally tighten skin and improve sagging.',
        good:
          'Hey there good looking! Tell us all your skincare secrets- your skin is looking good.',
      },
      hd_droopy_lower_eyelid: {
        fair:
          'Look for products with resveratrol which naturally help to slow cell aging and keep skin looking tigh and lifted.',
        average:
          'In need of a little lift? Place.two chilled cucumber slices over eyes for 10-20 minutes to naturally tighten skin and improve sagging.',
        good:
          'Hey there good looking! Tell us all your skincare secrets- your skin is looking good.',
      },
      hd_radiance: {
        fair:
          "Revive your skin's natural glow by following a simple daily routine that includes cleansing, moisturizing, and protecting your skin.",
        average:
          'Give your skin a fresh start by using a gentle cleanser morning and night to remove any impurities that may have accumulated throughout the day.',
        good:
          "You're glowing and gorgeous! Keep up the good work and enjoy that beautiful radiance.",
      },
      hd_acne: {
        fair:
          "Hands off your face! Focus on keeping skin clean with a gentle cleanser and replenishing moisture with a lightweight moisturizer that won't clog pores. Don't forget to clean your makeup brushes too.",
        average:
          "Be gentle with your skin and keep it clean and hydrated. Hyrdation helps to re-balance skin's oil glands to control acne and improve healing.",
        good:
          "Keep your hands off your face and don't forget your daily SPF and moisturizer to keep your clear skin pampered and protected.",
      },
      hd_pore: {
        fair:
          "To help unclog pores, use a gentle cleanser twice daily and opt for skin care and makeup products that won't clog pores",
        average:
          'Keep up with twice daily cleansing to help wash away dirt, sweat, and grime from the day which can otherwise settle into pores.',
        good:
          "Someone's mastered beautiful complexion! Keep up the great work.",
      },
      hd_pore_forehead: {
        fair:
          "To help unclog pores, use a gentle cleanser twice daily and opt for skin care and makeup products that won't clog pores",
        average:
          'Keep up with twice daily cleansing to help wash away dirt, sweat, and grime from the day which can otherwise settle into pores.',
        good:
          "Someone's mastered beautiful complexion! Keep up the great work.",
      },
      hd_pore_nose: {
        fair:
          "To help unclog pores, use a gentle cleanser twice daily and opt for skin care and makeup products that won't clog pores",
        average:
          'Keep up with twice daily cleansing to help wash away dirt, sweat, and grime from the day which can otherwise settle into pores.',
        good:
          "Someone's mastered beautiful complexion! Keep up the great work.",
      },
      hd_pore_cheek: {
        fair:
          "To help unclog pores, use a gentle cleanser twice daily and opt for skin care and makeup products that won't clog pores",
        average:
          'Keep up with twice daily cleansing to help wash away dirt, sweat, and grime from the day which can otherwise settle into pores.',
        good:
          "Someone's mastered beautiful complexion! Keep up the great work.",
      },
      hd_teartrough: {
        fair:
          'Time to address those tired under-eyes! Look for products with peptides or retinol to help stimulate collagen production and restore volume in the tear troughs, giving you a more rejuvenated appearance.',
        average:
          'Feeling a bit tired? Try a hydrating eye cream with ingredients like hyaluronic acid or cucumber extract to plump up the tear trough area and reduce any signs of fatigue.',
        good:
          'You’re looking bright-eyed and well-rested! Keep up your daily skincare routine to maintain that refreshed appearance.',
      },
      skin_health: {
        fair:
          "We've all been there: sometimes our skin just isn't looking as luminous as we'd like as we battle pimples, redness, or dryness. Don't fret! Glowing complexion is still within reach. Based on your AI skin health analysis, you're skin in need of some extra pampering to hydrate, calm, and soothe complexion so you can get back to glowing in no time. Check out your complete skin analysis below for more details and areas to focus on.",
        average:
          "You're on your way to glowing skin! Based on your AI skin health analysis, you're skin is healthy, however a little extra TLC can help you achieve the glowing complexion of your dreams. Try adding a pampering moisturizer to your routine to help hydrate and smooth some area of roughness. And don't forget to rotate in a weekly exfoliating mask to slough away any dry flakiness and help achieve glowy radiance. Check out your complete skin analysis below for more details and areas to focus on. ",
        good:
          "Hey there skincare expert! Based on your AI skin health analysis, you're skin is glowing. You clearly have a healthy, balanced skincare regimen and it's working. Keep up the good work maintaining moisture and hydration to keep your skin supple and smooth. Check out your complete skin analysis below. ",
      },
    },
    fra: {
      hd_spot: {
        average:
          "Continuez votre routine avec un nettoyage 2 fois par jour avec votre nettoyant doux favori et n'oubliez pas l'hydratation.",
        good:
          'Votre peau est superbe. Continuez à utiliser votre hydratant et protection solaire.',
        fair:
          "Ne touchez pas votre visage pendant la journée et soyez assidu dans votre routine visage incluant un nettoyant doux et un traitement de l'acné.",
      },
      hd_redness: {
        average:
          'Vous cherchez à calmer des rougeurs? Appliquez des produits à base de niacinamide pour stopper les inflamations, unifier et renforcer votre peau.',
        good:
          'Continuez sur cette voie. Votre teint parfait en dit long sur votre routine.',
        fair:
          "Arrêtez l'exfoliation et optez pour l'hydratation avec des produits aux ingrédients calmants comme le niacinamide, la réglisse, l'aloë, la caféine ou le concombre pour aider à réduire les rougeurs.",
      },
      hd_moisture: {
        average:
          "Versez-vous un verre d'eau et buvez ! Vous pouvez favoriser la santé de votre peau en utilisant un hydratant quotidien pour aider à garder votre peau douce et souple.",
        good:
          "Quelle belle peau hydratée! Continuez avec l'hydratation quotidienne et apréciez cette douceur.",
        fair:
          'Ajoutez un hydratant quotidien et une crème de nuit à votre routine de soins de la peau pour restaurer et rajeunir votre peau. Cela aidera à reconstituer et à nourrir votre peau pour un look frais et revitalisé le matin.',
      },
      hd_oiliness: {
        average:
          "Un peu trop de brillance? Essayez un nettoyant avec de l'acide salicylique qui exfolit en douceur, nettoie les pores sans assécher la peau.",
        good:
          'Vous êtes resplendissante là où il faut. Continuez à faire les bons gestes pour être lumineuse.',
        fair:
          "Si vous cherchez à réguler la production de sébum et à lutter contre la brillance, pensez à utiliser un toner pour la peau contenant des ingrédients exfoliants doux. Ceux-ci peuvent aider à garder vos pores dégagés et à prévenir l'accumulation excessive d'huile.",
      },
      hd_wrinkle: {
        average:
          "L'exposition au soleil peut causer des dommages importants à votre peau. Aussi, le FPS est votre première ligne de défense. Choisissez une formule avec un FPS de 30 ou plus et renouvelez souvent l'application.",
        good:
          "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
        fair:
          "Recherchez des hydratants contenant de puissants ingrédients hydratants qui peuvent aider à restaurer et à améliorer les niveaux d'hydratation de votre peau pour un teint plus lisse et d'apparence plus jeune.",
      },
      hd_wrinkle_forehead: {
        average:
          "L'exposition au soleil peut causer des dommages importants à votre peau. Aussi, le FPS est votre première ligne de défense. Choisissez une formule avec un FPS de 30 ou plus et renouvelez souvent l'application.",
        good:
          "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
        fair:
          "Recherchez des hydratants contenant de puissants ingrédients hydratants qui peuvent aider à restaurer et à améliorer les niveaux d'hydratation de votre peau pour un teint plus lisse et d'apparence plus jeune.",
      },
      hd_wrinkle_glabellar: {
        average:
          "L'exposition au soleil peut causer des dommages importants à votre peau. Aussi, le FPS est votre première ligne de défense. Choisissez une formule avec un FPS de 30 ou plus et renouvelez souvent l'application.",
        good:
          "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
        fair:
          "Recherchez des hydratants contenant de puissants ingrédients hydratants qui peuvent aider à restaurer et à améliorer les niveaux d'hydratation de votre peau pour un teint plus lisse et d'apparence plus jeune.",
      },
      hd_wrinkle_periocular: {
        average:
          "L'exposition au soleil peut causer des dommages importants à votre peau. Aussi, le FPS est votre première ligne de défense. Choisissez une formule avec un FPS de 30 ou plus et renouvelez souvent l'application.",
        good:
          "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
        fair:
          "Recherchez des hydratants contenant de puissants ingrédients hydratants qui peuvent aider à restaurer et à améliorer les niveaux d'hydratation de votre peau pour un teint plus lisse et d'apparence plus jeune.",
      },
      hd_wrinkle_crowfeet: {
        average:
          "L'exposition au soleil peut causer des dommages importants à votre peau. Aussi, le FPS est votre première ligne de défense. Choisissez une formule avec un FPS de 30 ou plus et renouvelez souvent l'application.",
        good:
          "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
        fair:
          "Recherchez des hydratants contenant de puissants ingrédients hydratants qui peuvent aider à restaurer et à améliorer les niveaux d'hydratation de votre peau pour un teint plus lisse et d'apparence plus jeune.",
      },
      hd_wrinkle_nasolabial: {
        average:
          "L'exposition au soleil peut causer des dommages importants à votre peau. Aussi, le FPS est votre première ligne de défense. Choisissez une formule avec un FPS de 30 ou plus et renouvelez souvent l'application.",
        good:
          "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
        fair:
          "Recherchez des hydratants contenant de puissants ingrédients hydratants qui peuvent aider à restaurer et à améliorer les niveaux d'hydratation de votre peau pour un teint plus lisse et d'apparence plus jeune.",
      },
      hd_wrinkle_marionette: {
        average:
          "L'exposition au soleil peut causer des dommages importants à votre peau. Aussi, le FPS est votre première ligne de défense. Choisissez une formule avec un FPS de 30 ou plus et renouvelez souvent l'application.",
        good:
          "Votre visage est au top! N'oubliez pas votre protection solaire pour garder cette peau lisse bien protégée.",
        fair:
          "Recherchez des hydratants contenant de puissants ingrédients hydratants qui peuvent aider à restaurer et à améliorer les niveaux d'hydratation de votre peau pour un teint plus lisse et d'apparence plus jeune.",
      },
      hd_texture: {
        average:
          "Améliorez la texture de votre peau en utilisant des produits qui contiennent des nutriments connus pour être bénéfiques pour la peau. Ceux-ci peuvent aider à améliorer la santé globale et l'apparence de votre peau, en lui donnant un éclat revitalisé et sain.",
        good:
          "Votre peau est magnifique alors n'oubliez pas votre protection solaire pour un visage toujours aussi protégé.",
        fair:
          "Vous souhaitez sublimer le grain de votre peau ? Envisagez d'utiliser un produit doux conçu pour éliminer les cellules mortes de la peau une à deux fois par semaine pour aider à révéler un teint plus brillant et éclatant.",
      },
      hd_dark_circle: {
        average:
          "Prenez une grande inspiration et sentez le poids s'envoler de vos épaules. Puis appliquez une noisette de crème antioxidante sous vos yeux pour aider à illuminer cette zone.",
        good:
          'Continuez à vous reposer ! Votre peau est fraîche et en bonne santé.',
        fair:
          'Il est peut-être temps de chercher des moyens de stimuler la production de collagène et de redonner du volume et de la fermeté à la peau sensible sous vos yeux. Vous allez ainsi réduire les zones sombres sous les yeux.',
      },
      hd_eye_bag: {
        average:
          "Essayez une compresse froide ou des sachets de thé pour réduire les poches sous les yeux. Appliquez des produits à base de concombre ou d'eau de rose pour hydrater et calmer cette zone.",
        good:
          'Le sommeil est important. Continuez avec cette vie sans stress. Votre peau est magnifique.',
        fair:
          'Cherchez des produits doux et anti-inflammatoires avec du thé vert ou de la caféine pour aider à réduire le côté gonflé de la peau sensible qui se trouve sous les yeux.',
      },
      hd_firmness: {
        average:
          "Un massage léger du visage aidera à raffermir et sculpter la peau, en stimulant les muscles qui améliorent le volume et l'apparence de la peau.",
        good:
          'Votre peau est plus jeune et lumineuse que jamais. Continuez comme ça!',
        fair:
          "Votre peau a besoin d'un boost de soin ? Essayez un masque au collagène pour restorer son volume et sa fermeté.",
      },
      hd_droopy_upper_eyelid: {
        average:
          "Besoin d'un petit lifting? Placez deux concombres froids sur vos yeux pendant 10 à 20 minutes pour raffermir votre peau et ralentir l'affaissement.",
        good: 'Dites-nous tous vos secrets pour cette peau resplendissante!',
        fair:
          'Trouvez des produits contenant de resveratrol qui aide naturellement à ralentir le veillissement des cellules et à garder la peau ferme.',
      },
      hd_droopy_lower_eyelid: {
        average:
          "Besoin d'un petit lifting? Placez deux concombres froids sur vos yeux pendant 10 à 20 minutes pour raffermir votre peau et ralentir l'affaissement.",
        good: 'Dites-nous tous vos secrets pour cette peau resplendissante!',
        fair:
          'Trouvez des produits contenant de resveratrol qui aide naturellement à ralentir le veillissement des cellules et à garder la peau ferme.',
      },
      hd_radiance: {
        average:
          'Faites peau neuve au sens propre en utilisant un nettoyant doux matin et soir pour éliminer les impuretés qui se sont accumulées tout au long de la journée.',
        good:
          'Continuez à vous reposer ! Votre peau est fraîche et en bonne santé.',
        fair:
          "Ravivez l'éclat naturel de votre peau en suivant une routine quotidienne simple qui comprend le nettoyage, l'hydratation et la protection de votre peau.",
      },
      hd_acne: {
        average:
          "Soyez doux avec votre peau et gardez la propre et hydratée. L'hydratation aide à ré-équilibrer la peau grasse et à contrôler l'acné tout en la soignant.",
        good:
          "Ne touchez pas votre visage et n'oubliez pas de protéger votre peau et de la garder hydratée pour une peau propre et protégée.",
        fair:
          "Ne touchez pas votre visage! Concentrez-vous sur la façon de garder une peau propre et une hydratation fluide qui ne bouchera pas nos pores. N'oubliez pas de nettoyer vos pinceaux.",
      },
      hd_pore: {
        average:
          'Continuez avec un nettoyage de la peau deux fois par jour pour aider à vous débarasser de la saleté, de la transpiration qui pourraient boucher vos pores.',
        good: 'Vous savez être maîtresse de votre teint. Continuez comme ça.',
        fair:
          "Pour aider à désobstruer les pores, utilisez un nettoyant doux deux fois par jour et optez pour des produits de soins de la peau et de maquillage qui n'obstruent pas les pores.",
      },
      hd_pore_forehead: {
        average:
          'Continuez avec un nettoyage de la peau deux fois par jour pour aider à vous débarasser de la saleté, de la transpiration qui pourraient boucher vos pores.',
        good: 'Vous savez être maîtresse de votre teint. Continuez comme ça.',
        fair:
          "Pour aider à désobstruer les pores, utilisez un nettoyant doux deux fois par jour et optez pour des produits de soins de la peau et de maquillage qui n'obstruent pas les pores.",
      },
      hd_pore_nose: {
        average:
          'Continuez avec un nettoyage de la peau deux fois par jour pour aider à vous débarasser de la saleté, de la transpiration qui pourraient boucher vos pores.',
        good: 'Vous savez être maîtresse de votre teint. Continuez comme ça.',
        fair:
          "Pour aider à désobstruer les pores, utilisez un nettoyant doux deux fois par jour et optez pour des produits de soins de la peau et de maquillage qui n'obstruent pas les pores.",
      },
      hd_pore_cheek: {
        average:
          'Continuez avec un nettoyage de la peau deux fois par jour pour aider à vous débarasser de la saleté, de la transpiration qui pourraient boucher vos pores.',
        good: 'Vous savez être maîtresse de votre teint. Continuez comme ça.',
        fair:
          "Pour aider à désobstruer les pores, utilisez un nettoyant doux deux fois par jour et optez pour des produits de soins de la peau et de maquillage qui n'obstruent pas les pores.",
      },
      hd_teartrough: {
        average:
          'Vous vous sentez un peu fatiguée ? Essayez une crème hydratante pour les yeux contenant des ingrédients tels que de l’acide hyaluronique ou de l’extrait de concombre pour repulper la zone de la vallée des larmes et réduire les signes de fatigue.',
        good:
          'Vous avez l’air d’avoir les yeux brillants et d’être bien reposée ! Maintenez votre routine quotidienne de soins de la peau pour conserver cette apparence rafraîchie.',
        fair:
          'Il est temps de s’occuper de ces yeux fatigués ! Recherchez des produits contenant des peptides ou du rétinol pour stimuler la production de collagène et restaurer le volume de la vallée des larmes, vous donnant ainsi une apparence plus rajeunie.',
      },
      skin_health: {
        average: '',
        good: '',
        fair: '',
      },
    },
    jpn: {
      hd_spot: {
        average:
          '1日2回、マイルドな洗顔料でクレンジングをし、保湿ケアも忘れずに行ってください。',
        good: '肌の状態は良好です。毎日の保湿と日焼け対策を続けてください。',
        fair:
          '日中は顔に手を触れないようにし、肌に優しい洗顔料やニキビ用のスキンケアをこまめに行いましょう。',
      },
      hd_redness: {
        average:
          '肌の赤みが気になります。ナイアシンアミドが配合された製品は、炎症を鎮め、肌の色を均一にし、肌の免疫を高める効果があります。',
        good:
          'ツヤのある肌です。今のスキンケアを続けて、その状態をキープしてください。',
        fair:
          '角質除去剤の使用を控え、保湿効果の高いモイスチャライザーを使用してください。ナイアシンアミド、甘草根、アロエ、カフェイン、キュウリなど、鎮静効果のある成分が配合された製品をおすすめします。',
      },
      hd_moisture: {
        average:
          'コップ 1 杯の水を飲んでください。毎日の保湿ケアで肌の健康を守り、肌に水分と潤いを補いましょう。',
        good:
          '肌は潤っています。毎日の保湿を続けて、潤いのある肌をキープしてください。',
        fair:
          '毎日のスキンケアに、乳液とナイトケア クリームをプラスして、若々しい肌を取り戻しましょう。肌に栄養を補給し、朝からフレッシュで活力のある肌に導きます。',
      },
      hd_oiliness: {
        average:
          '少しテカリが気になるようです。サリチル酸が配合された洗顔料は、毛穴の汚れをやさしく取り除き、肌の乾燥を防ぎます。',
        good: '適切な油分が保たれています。その状態をキープしてください。',
        fair:
          '皮脂の分泌を抑える、角質ケア成分が配合された化粧水をおすすめします。毛穴の汚れをやさしく取り除き、余分な皮脂の蓄積を防ぎます。',
      },
      hd_wrinkle: {
        average:
          '太陽の紫外線は肌にダメージを与えます。SPF 30 以上の日焼け止めを選び、こまめに塗りなおしてください。',
        good:
          '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
        fair:
          '保湿成分配合の化粧水や乳液をおすすめします。角質層の水分量を高め、より滑らかで若々しい肌を取り戻しましょう。',
      },
      hd_wrinkle_forehead: {
        average:
          '太陽の紫外線は肌にダメージを与えます。SPF 30 以上の日焼け止めを選び、こまめに塗りなおしてください。',
        good:
          '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
        fair:
          '保湿成分配合の化粧水や乳液をおすすめします。角質層の水分量を高め、より滑らかで若々しい肌を取り戻しましょう。',
      },
      hd_wrinkle_glabellar: {
        average:
          '太陽の紫外線は肌にダメージを与えます。SPF 30 以上の日焼け止めを選び、こまめに塗りなおしてください。',
        good:
          '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
        fair:
          '保湿成分配合の化粧水や乳液をおすすめします。角質層の水分量を高め、より滑らかで若々しい肌を取り戻しましょう。',
      },
      hd_wrinkle_periocular: {
        average:
          '太陽の紫外線は肌にダメージを与えます。SPF 30 以上の日焼け止めを選び、こまめに塗りなおしてください。',
        good:
          '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
        fair:
          '保湿成分配合の化粧水や乳液をおすすめします。角質層の水分量を高め、より滑らかで若々しい肌を取り戻しましょう。',
      },
      hd_wrinkle_crowfeet: {
        average:
          '太陽の紫外線は肌にダメージを与えます。SPF 30 以上の日焼け止めを選び、こまめに塗りなおしてください。',
        good:
          '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
        fair:
          '保湿成分配合の化粧水や乳液をおすすめします。角質層の水分量を高め、より滑らかで若々しい肌を取り戻しましょう。',
      },
      hd_wrinkle_nasolabial: {
        average:
          '太陽の紫外線は肌にダメージを与えます。SPF 30 以上の日焼け止めを選び、こまめに塗りなおしてください。',
        good:
          '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
        fair:
          '保湿成分配合の化粧水や乳液をおすすめします。角質層の水分量を高め、より滑らかで若々しい肌を取り戻しましょう。',
      },
      hd_wrinkle_marionette: {
        average:
          '太陽の紫外線は肌にダメージを与えます。SPF 30 以上の日焼け止めを選び、こまめに塗りなおしてください。',
        good:
          '肌の状態は良好です。日焼け止めをしっかり塗って、なめらかで美しい肌をキープしてください。',
        fair:
          '保湿成分配合の化粧水や乳液をおすすめします。角質層の水分量を高め、より滑らかで若々しい肌を取り戻しましょう。',
      },
      hd_texture: {
        average:
          '肌に良い栄養素が配合された製品を使って、肌のキメを整えてください。徐々に健康的な肌ツヤを与えます。',
        good:
          '肌の状態は良好です。美しい顔を守るために日焼け対策を忘れないでください。',
        fair:
          '肌のキメが気になります。週に 1～2 回、角質ケア製品で古い角質をやさしく取り除き、美しく輝く肌を手に入れましょう。',
      },
      hd_dark_circle: {
        average:
          '抗酸化作用のあるクリームを目の下にのせることで刺激が与えられ、目の下を明るくします。',
        good:
          '肌は健康的でリフレッシュされた状態です。引き続き、美しさを保つために睡眠を十分にとってください。',
        fair:
          '目の下の敏感な皮膚のコラーゲン生成を促進し、たるみや肌の弾力ケアに効果的な製品をお試しください。目の下の暗さが改善されます。',
      },
      hd_eye_bag: {
        average:
          '目の下のむくみを抑えるには、起床後と就寝前に冷湿布やティーバッグを使ってみましょう。また、目の下に潤いを与えて落ち着かせるために、キュウリやバラの水を使った製品もお勧めです。',
        good:
          '肌の状態は良好です。睡眠時間を増やして、ストレスのない生活を心がけてください。',
        fair:
          '目の下のむくみを抑えるには、緑茶やカフェインが配合された鎮静・抗炎症作用のある製品を使用してください。',
      },
      hd_firmness: {
        average:
          '顔を優しくマッサージすることで、肌をリフトアップします。また、筋肉を刺激することで、肌全体のボリュームをアップさせ、見た目の印象を良くします。',
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        fair:
          'コラーゲンが配合されたフェイスパックでたるみを防ぎ、お肌に弾力とハリを与えましょう。',
      },
      hd_droopy_upper_eyelid: {
        average:
          'リフトアップが必要です。冷やしたきゅうりの輪切り2枚を目の上に10～20分置くと、肌が自然に引き締まり、たるみが改善されます。',
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        fair:
          'レスベラトロールが配合された製品は、細胞の老化を遅らせ、肌の弾力を改善する効果が期待されています。',
      },
      hd_droopy_lower_eyelid: {
        average:
          'リフトアップが必要です。冷やしたきゅうりの輪切り2枚を目の上に10～20分置くと、肌が自然に引き締まり、たるみが改善されます。',
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        fair:
          'レスベラトロールが配合された製品は、細胞の老化を遅らせ、肌の弾力を改善する効果が期待されています。',
      },
      hd_radiance: {
        average:
          '朝晩、肌に優しい洗顔料を使って、毛穴の汚れを洗い流し、自然な輝きをキープしましょう。',
        good:
          'ツヤのある肌です。今のスキンケアを続けて、その状態をキープしてください。',
        fair:
          '洗顔、保湿、肌の保護など、毎日のお手入れで、肌本来の輝きを取り戻しましょう。',
      },
      hd_acne: {
        average:
          '肌を清潔に、保湿状態を保ってください。保湿は肌の油腺のバランスを整え、ニキビを抑制し、治癒力を高めます。',
        good:
          '肌は清潔です。その状態を保つために手で顔に触れず、毎日の保湿と日焼け対策を忘れないでください。',
        fair:
          '手がなるべく顔に触れないようにしてください。肌に優しい洗顔料で清潔に保ち、毛穴を詰まらせない軽いテクスチャーの保湿剤で水分を補給しましょう。メイクブラシのお手入れも忘れずに。',
      },
      hd_pore: {
        average:
          '1日2回のクレンジングで、毛穴に詰まった汚れや汗を洗い流してください。',
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        fair:
          '毛穴の詰まりを改善するには、1 日 2 回、肌にやさしい洗顔料を使い、毛穴詰まりの原因にならないスキンケアやメイク アイテムを選びましょう。',
      },
      hd_pore_forehead: {
        average:
          '1日2回のクレンジングで、毛穴に詰まった汚れや汗を洗い流してください。',
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        fair:
          '毛穴の詰まりを改善するには、1 日 2 回、肌にやさしい洗顔料を使い、毛穴詰まりの原因にならないスキンケアやメイク アイテムを選びましょう。',
      },
      hd_pore_nose: {
        average:
          '1日2回のクレンジングで、毛穴に詰まった汚れや汗を洗い流してください。',
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        fair:
          '毛穴の詰まりを改善するには、1 日 2 回、肌にやさしい洗顔料を使い、毛穴詰まりの原因にならないスキンケアやメイク アイテムを選びましょう。',
      },
      hd_pore_cheek: {
        average:
          '1日2回のクレンジングで、毛穴に詰まった汚れや汗を洗い流してください。',
        good:
          '肌の状態は良好です。今のスキンケアを続けて、その状態をキープしてください。',
        fair:
          '毛穴の詰まりを改善するには、1 日 2 回、肌にやさしい洗顔料を使い、毛穴詰まりの原因にならないスキンケアやメイク アイテムを選びましょう。',
      },
      hd_teartrough: {
        average:
          'お疲れですか？ヒアルロン酸やキュウリエキスなどの成分がはいったハイドレーション アイクリームをお試しいただき、目の下をふっくらとさせ、やつれた感じを薄めてはいかがですか。',
        good:
          '目がパッチリして、休養十分に見えます！毎日のスキンケア習慣を続け、さわやかな外観を保ってください。',
        fair:
          '目の下のやつれ感をお手入れしましょう！ペプチドやレチノール配合の製品で、コラーゲンの生成を促進し、目の下のボリュームを戻し、若返った印象を与えます。',
      },
      skin_health: {
        average: '',
        good: '',
        fair: '',
      },
    },
    kor: {
      hd_spot: {
        average:
          '선호하는 중성 클렌저로 하루 두 번 클렌징을 계속하시고, 보습을 잊지 마세요.',
        good:
          '멋지군요! 피부 상태가 아주 좋습니다. 매일매일 보습과 자외선차단제를 지금처럼 유지하세요.',
        fair:
          '낮 동안에는 얼굴에 손을 대지 말고 순한 클렌저와 여드름 치료제를 포함해 순한 스킨케어 루틴을 부지런히 따르세요.',
      },
      hd_redness: {
        average:
          '홍조를 완화시킬 수 있는 제품을 찾고 있나요? 염증을 완화하고 피부톤을 고르게 할 뿐 아니라 피부를 강화시켜주는 나이아신아미드가 함유된 제품을 고르세요.',
        good: '잘 하고 계십니다! 아름다운 피부톤이 결과를 직접 말해줍니다.',
        fair:
          '엑스폴리언트는 내려놓고 모이스처라이저를 사용하세요. 홍조를 줄이는 데 도움이 되는 나이아신아미드, 감초, 알로에, 카페인, 오이 등 수딩 성분이 있는 제품을 고르세요.',
      },
      hd_moisture: {
        average:
          '물 한 컵을 쭉 마시세요! 부드럽고 탄력 있는 피부를 유지할 수 있도록 데일리 모이스처라이저를 사용해 피부의 건강에 이바지할 수 있습니다.',
        good:
          '보습이 잘 된 피부군요! 매일매일 보습을 유지하고 촉촉하고 보들보들한 피부를 즐기세요.',
        fair:
          '스킨케어 루틴에 데일리 모이스터라이저와 오버나이트 크림을 더해 피부 복원과 재생에 신경쓰세요. 이렇게 하면 피부에 수분과 영향을 보충해 매일 아침 생기 있고 활력 있는 피부를 만나볼 수 있습니다.',
      },
      hd_oiliness: {
        average:
          '얼굴이 너무 번들거리나요? 각질을 부드럽게 제거해 모공을 깨끗하게 하되 피부를 건조하지 않게 해주는 살리실산이 함유된 클렌저를 사용해보세요.',
        good: '유분이 적당합니다! 꾸준히 관리해서 빛나는 피부를 유지하세요!',
        fair:
          '번들거림이나 얼굴의 기름기를 없애고 싶다면 순한 각질제거 성분을 함유한 피부 토너 사용을 고려해 보세요. 이러한 제품은 모공을 더 깨끗하게 하고 과도한 유분 축적을 방지하는 데 도움이 될 수 있습니다.',
      },
      hd_wrinkle: {
        average:
          '햇빛 노출은 피부를 크게 손상시킬 수 있고 SPF는 피부를 지키는 제1의 방어 수단입니다. SPF 지수가 30 이상인 제품을 고르고 자주 덧발라 주세요.',
        good:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
        fair:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
      },
      hd_wrinkle_forehead: {
        average:
          '햇빛 노출은 피부를 크게 손상시킬 수 있고 SPF는 피부를 지키는 제1의 방어 수단입니다. SPF 지수가 30 이상인 제품을 고르고 자주 덧발라 주세요.',
        good:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
        fair:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
      },
      hd_wrinkle_glabellar: {
        average:
          '햇빛 노출은 피부를 크게 손상시킬 수 있고 SPF는 피부를 지키는 제1의 방어 수단입니다. SPF 지수가 30 이상인 제품을 고르고 자주 덧발라 주세요.',
        good:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
        fair:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
      },
      hd_wrinkle_periocular: {
        average:
          '햇빛 노출은 피부를 크게 손상시킬 수 있고 SPF는 피부를 지키는 제1의 방어 수단입니다. SPF 지수가 30 이상인 제품을 고르고 자주 덧발라 주세요.',
        good:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
        fair:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
      },
      hd_wrinkle_crowfeet: {
        average:
          '햇빛 노출은 피부를 크게 손상시킬 수 있고 SPF는 피부를 지키는 제1의 방어 수단입니다. SPF 지수가 30 이상인 제품을 고르고 자주 덧발라 주세요.',
        good:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
        fair:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
      },
      hd_wrinkle_nasolabial: {
        average:
          '햇빛 노출은 피부를 크게 손상시킬 수 있고 SPF는 피부를 지키는 제1의 방어 수단입니다. SPF 지수가 30 이상인 제품을 고르고 자주 덧발라 주세요.',
        good:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
        fair:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
      },
      hd_wrinkle_marionette: {
        average:
          '햇빛 노출은 피부를 크게 손상시킬 수 있고 SPF는 피부를 지키는 제1의 방어 수단입니다. SPF 지수가 30 이상인 제품을 고르고 자주 덧발라 주세요.',
        good:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
        fair:
          '더욱 매끄러울 뿐 아니라 젊고 빛나는 광채를 위해 피부를 복원하고 피부의 수분 수준을 개선하는 데 도움이 되는 강력한 보습 성분을 함유한 모이스처라이저를 찾으세요.',
      },
      hd_texture: {
        average:
          '피부에 이로운 것으로 알려진 영양 성분을 함유한 제품을 사용하여 피부결을 개선하세요. 그러면 전반적인 피부 건강과 외관을 향상시켜 활력 있는 피부와 광채를 얻을 수 있습니다.',
        good:
          '피부 상태가 좋습니다. 아름다운 얼굴을 계속해서 보호할 수 있도록 잊지말고 자외선차단제를 듬뿍 바르세요.',
        fair:
          '피부결을 개선하고 싶으신가요? 밝고 빛나는 광채를 경험할 수 있도록 일주일에 1-2번 죽은 피부 세포를 제거하도록 고안된 부드러운 성분의 제품을 사용해 보세요.',
      },
      hd_dark_circle: {
        average:
          '먼저 심호흡을 하고 어깨에서 짓눌린 무게가 사라지는 기분을 느껴보세요. 그런 다음 항산화제가 풍부한 크림을 눈 밑에 두드리듯이 발라 눈가를 자극하고 밝게 해주세요.',
        good: '충분한 휴식을 취하세요! 피부가 생기 있고 건강합니다.',
        fair:
          '콜라겐 생성을 자극하고 눈밑의 민감한 피부 볼륨과 탄력을 되찾기 위한 방법을 찾기에 적당한 때입니다. 이러한 제품은 눈밑의 다크서클을 개선하는 데 도움이 됩니다.',
      },
      hd_eye_bag: {
        average:
          '하루의 시작이나 끝에 냉습포 또는 티백을 대고 있으면 눈의 붓기를 없애는 데 도움이 됩니다. 수분을 공급하고 진정 효과가 있는 오이 또는 로즈 워터가 함유된 제품을 고르세요.',
        good:
          '두 배로 충분한 수면을 취하고 스트레스 없는 라이프스타일을 유지하세요! 당신의 피부는 멋집니다.',
        fair:
          '민감한 눈밑 부위의 붓기를 줄이는 데 효과적인 녹차 또는 카페인 성분이 함유된 수딩 및 항염증성 제품을 고르세요.',
      },
      hd_firmness: {
        average:
          '얼굴을 부드럽게 마사지하면 처진 피부를 리프팅 & 리모델링하는 데 도움이 되며 근육을 자극해 전반적인 피부 볼륨과 외관을 개선해줍니다.',
        good: '피부가 여전히 탱탱하고 빛이 나네요. 계속 꾸준히 관리하세요!',
        fair:
          '효과적인 피부관리 비법이 리프팅이 필요한가요? 콜라겐 부스트 마스크를 사용해 보세요. 볼륨과 탄력을 되찾는 데 도움이 됩니다.',
      },
      hd_droopy_upper_eyelid: {
        average:
          '약간의 리프팅이 필요한가요? 오이 슬라이스 두 장을 눈 위에 10-20분 정도 놓아 두면 피부가 조여지고 쳐짐이 개선된 것을 느낄 수 있습니다.',
        good: '아름답군요! 피부관리 비법을 알려주세요.',
        fair:
          '자연적으로 세포 노화 속도를 늦추고 피부의 탄력과 리프팅을 개선해주는 레스베라트롤이 함유된 제품을 고르세요.',
      },
      hd_droopy_lower_eyelid: {
        average:
          '약간의 리프팅이 필요한가요? 오이 슬라이스 두 장을 눈 위에 10-20분 정도 놓아 두면 피부가 조여지고 쳐짐이 개선된 것을 느낄 수 있습니다.',
        good: '아름답군요! 피부관리 비법을 알려주세요.',
        fair:
          '자연적으로 세포 노화 속도를 늦추고 피부의 탄력과 리프팅을 개선해주는 레스베라트롤이 함유된 제품을 고르세요.',
      },
      hd_radiance: {
        average:
          '아침 저녁으로 부드러운 성분의 클렌저를 사용해 하루 종일 피부에 축적되었을 수 있는 불순물을 제거해 생기 있는 피부를 연출해 보세요.',
        good:
          '얼굴에 빛이 나는군요! 계속해서 꾸준히 관리하고 아름다운 피부안색을 즐기세요.',
        fair:
          '세안, 보습, 피부 보호를 포함한 간단한 데일리 루틴을 따라 피부의 자연스러운 광채가 다시 살아나게 해보세요.',
      },
      hd_acne: {
        average:
          '피부에 순한 제품으로 피부를 깨끗하고 촉촉한 상태로 유지하세요. 보습은 피부의 유분 균형을 맞춰 여드름을 조절하고 치유를 개선해줍니다.',
        good:
          '얼굴에 손을 대지 말고 매일 자외선차단제와 보습제를 발라 깨끗한 피부를 유지하고 피부를 안전하게 보호해 주세요.',
        fair:
          '얼굴에 손을 대지 마세요! 손한 클렌저와 리플레싱 모이스처라이저로 피부를 깨끗하게 유지하는 데 집중하세요. 모공을 막지 않게 가벼운 모이스처라이저를 사용하세요. 메이크업 브러시 세척도 잊지 마세요.',
      },
      hd_pore: {
        average:
          '하루에 두 번 클렌징해서 모공을 막고 있을 수 있는 이물질, 땀, 피지 등을 제거하세요.',
        good: '피부안색이 아주 아름다워요! 계속 꾸준히 관리하세요.',
        fair:
          '모공을 깨끗이 닦아내기 위해서는 하루에 두 번 순한 클렌저를 사용하고 스킨케어 및 메이크업 제품을 고르세요.',
      },
      hd_pore_forehead: {
        average:
          '하루에 두 번 클렌징해서 모공을 막고 있을 수 있는 이물질, 땀, 피지 등을 제거하세요.',
        good: '피부안색이 아주 아름다워요! 계속 꾸준히 관리하세요.',
        fair:
          '모공을 깨끗이 닦아내기 위해서는 하루에 두 번 순한 클렌저를 사용하고 스킨케어 및 메이크업 제품을 고르세요.',
      },
      hd_pore_nose: {
        average:
          '하루에 두 번 클렌징해서 모공을 막고 있을 수 있는 이물질, 땀, 피지 등을 제거하세요.',
        good: '피부안색이 아주 아름다워요! 계속 꾸준히 관리하세요.',
        fair:
          '모공을 깨끗이 닦아내기 위해서는 하루에 두 번 순한 클렌저를 사용하고 스킨케어 및 메이크업 제품을 고르세요.',
      },
      hd_pore_cheek: {
        average:
          '하루에 두 번 클렌징해서 모공을 막고 있을 수 있는 이물질, 땀, 피지 등을 제거하세요.',
        good: '피부안색이 아주 아름다워요! 계속 꾸준히 관리하세요.',
        fair:
          '모공을 깨끗이 닦아내기 위해서는 하루에 두 번 순한 클렌저를 사용하고 스킨케어 및 메이크업 제품을 고르세요.',
      },
      hd_teartrough: {
        average:
          '조금 피곤한 느낌이 드시나요? 히알루론산이나 오이 추출물 같은 성분이 들어간 수분감 있는 아이크림을 사용해 보세요. 눈 밑 부위를 탱탱하게 해주고 피로의 흔적을 줄이는 데 도움을 줄 거예요.',
        good:
          '밝고 생기 있어 보이시네요! 상쾌한 모습을 유지하려면 매일 스킨케어 루틴을 꾸준히 이어가세요.',
        fair:
          '피곤해 보이는 눈 밑을 관리할 시간이에요! 콜라겐 생성을 촉진하고 눈 밑 부위의 볼륨을 회복하는 데 도움이 되는 펩타이드나 레티놀 성분이 포함된 제품을 찾아보세요. 이를 통해 더 생기 있고 젊어진 모습을 얻을 수 있습니다.',
      },
      skin_health: {
        average: '',
        good: '',
        fair: '',
      },
    },
    deu: {
      hd_spot: {
        average:
          'Setze deine Pflege zweimal pro Tag mit deiner Lieblings-Reinigungslösung fort und vergiss nicht, die Haut feucht zu halten.',
        good:
          'Hallo Schönheit! Deine Haut sieht ausgezeichnet aus. Benutze auch weiterhin deinen tägliche Feuchtigkeitsspender und Sonnenschutz.',
        fair:
          'Berühre dein Gesicht tagsüber nicht mit deinen Händen und verwende eine sanfte Pflegeroutine mit einem sanften Reinigungsprodukt und einer Akne-Pflegebehandlung.',
      },
      hd_redness: {
        average:
          'Möchtest du Rötungen auf der Haut lindern? Achte auf Produkte mit Niacinamid, die Entzündungen lindern, den Hautton ausgleichen und die Haut stärken.',
        good:
          'Mach so weiter wie bisher! Dein wunderschöner Hautton spricht Bände.',
        fair:
          'Leg das Peeling zur Seite und nimm eine Feuchtigkeitspflege zur Hand. Achte auf Produkte mit beruhigenden Inhaltsstoffen wie Niacinamid, Süßholzwurzel, Aloe, Koffein und Gurke, die helfen, Rötungen zu reduzieren.',
      },
      hd_moisture: {
        average:
          'Gieß dir ein Glas Wasser ein und trink! Du kannst die Gesundheit deiner Haut unterstützen, indem du täglich Feuchtigkeit zuführst, um deine Haut weich und straff zu halten.',
        good:
          'Hallo wunderschöne hydrierte Haut! Fahr mit dem täglichen Feuchtigkeitsspender fort und genieße deine pralle Haut.',
        fair:
          'Füge deiner Hautpflegeroutine ein tägliches Feuchtigkeitsprodukt und eine Nachtcreme hinzu, um deine Haut wiederherzustellen und zu verjüngen. Hierdurch wird deine Haut wiederhergestellt und genährt, was morgens zu einem frischen, neu vitalisierten Erscheinungsbild führt.',
      },
      hd_oiliness: {
        average:
          'Bekommst du zuviel Sonnenschein ab? Versuch es mit einem Reiniger mit Salicylsäure, das sanft peelt, um die Poren zu reinigen, aber die Haut nicht austrocknet.',
        good:
          'Sieht so aus, als strahlst du an den richtigen Stellen! Mach weiter so und strahle schön!',
        fair:
          'Wenn du die Fettproduktion regulieren und gegen Glänzen ankämpfen möchtest, suche dir einen Haut-Toner, der leichte Peeling-Wirkstoffe besitzt. Mit diesen bleiben deine Poren klar und sie verhindern übermäßige Fettproduktion',
      },
      hd_wrinkle: {
        average:
          'Die Sonne kann deine Haut enorm schädigen und ein Sonnenschutzfaktor ist dagegen dein allerbester Schutz. Verwende einen Sonnenschutzfaktor von mindestens 30 und trage diesen mehrmals täglich auf.',
        good:
          'Sieht gut aus! Vergiss jetzt nicht, den Sonnenschutz aufzutragen, um deine glatte, wunderschöne Haut zu schützen.',
        fair:
          'Wähle Feuchtigkeitsprodukte mit potenten hydrierenden Wirkstoffe, die die Feuchtigkeitspegel deiner Haut wiederherstellen und noch verbessern können. Dies gibt dir einen glatteren und jünger wirkenden Teint.',
      },
      hd_wrinkle_forehead: {
        average:
          'Die Sonne kann deine Haut enorm schädigen und ein Sonnenschutzfaktor ist dagegen dein allerbester Schutz. Verwende einen Sonnenschutzfaktor von mindestens 30 und trage diesen mehrmals täglich auf.',
        good:
          'Sieht gut aus! Vergiss jetzt nicht, den Sonnenschutz aufzutragen, um deine glatte, wunderschöne Haut zu schützen.',
        fair:
          'Wähle Feuchtigkeitsprodukte mit potenten hydrierenden Wirkstoffe, die die Feuchtigkeitspegel deiner Haut wiederherstellen und noch verbessern können. Dies gibt dir einen glatteren und jünger wirkenden Teint.',
      },
      hd_wrinkle_glabellar: {
        average:
          'Die Sonne kann deine Haut enorm schädigen und ein Sonnenschutzfaktor ist dagegen dein allerbester Schutz. Verwende einen Sonnenschutzfaktor von mindestens 30 und trage diesen mehrmals täglich auf.',
        good:
          'Sieht gut aus! Vergiss jetzt nicht, den Sonnenschutz aufzutragen, um deine glatte, wunderschöne Haut zu schützen.',
        fair:
          'Wähle Feuchtigkeitsprodukte mit potenten hydrierenden Wirkstoffe, die die Feuchtigkeitspegel deiner Haut wiederherstellen und noch verbessern können. Dies gibt dir einen glatteren und jünger wirkenden Teint.',
      },
      hd_wrinkle_periocular: {
        average:
          'Die Sonne kann deine Haut enorm schädigen und ein Sonnenschutzfaktor ist dagegen dein allerbester Schutz. Verwende einen Sonnenschutzfaktor von mindestens 30 und trage diesen mehrmals täglich auf.',
        good:
          'Sieht gut aus! Vergiss jetzt nicht, den Sonnenschutz aufzutragen, um deine glatte, wunderschöne Haut zu schützen.',
        fair:
          'Wähle Feuchtigkeitsprodukte mit potenten hydrierenden Wirkstoffe, die die Feuchtigkeitspegel deiner Haut wiederherstellen und noch verbessern können. Dies gibt dir einen glatteren und jünger wirkenden Teint.',
      },
      hd_wrinkle_crowfeet: {
        average:
          'Die Sonne kann deine Haut enorm schädigen und ein Sonnenschutzfaktor ist dagegen dein allerbester Schutz. Verwende einen Sonnenschutzfaktor von mindestens 30 und trage diesen mehrmals täglich auf.',
        good:
          'Sieht gut aus! Vergiss jetzt nicht, den Sonnenschutz aufzutragen, um deine glatte, wunderschöne Haut zu schützen.',
        fair:
          'Wähle Feuchtigkeitsprodukte mit potenten hydrierenden Wirkstoffe, die die Feuchtigkeitspegel deiner Haut wiederherstellen und noch verbessern können. Dies gibt dir einen glatteren und jünger wirkenden Teint.',
      },
      hd_wrinkle_nasolabial: {
        average:
          'Die Sonne kann deine Haut enorm schädigen und ein Sonnenschutzfaktor ist dagegen dein allerbester Schutz. Verwende einen Sonnenschutzfaktor von mindestens 30 und trage diesen mehrmals täglich auf.',
        good:
          'Sieht gut aus! Vergiss jetzt nicht, den Sonnenschutz aufzutragen, um deine glatte, wunderschöne Haut zu schützen.',
        fair:
          'Wähle Feuchtigkeitsprodukte mit potenten hydrierenden Wirkstoffe, die die Feuchtigkeitspegel deiner Haut wiederherstellen und noch verbessern können. Dies gibt dir einen glatteren und jünger wirkenden Teint.',
      },
      hd_wrinkle_marionette: {
        average:
          'Die Sonne kann deine Haut enorm schädigen und ein Sonnenschutzfaktor ist dagegen dein allerbester Schutz. Verwende einen Sonnenschutzfaktor von mindestens 30 und trage diesen mehrmals täglich auf.',
        good:
          'Sieht gut aus! Vergiss jetzt nicht, den Sonnenschutz aufzutragen, um deine glatte, wunderschöne Haut zu schützen.',
        fair:
          'Wähle Feuchtigkeitsprodukte mit potenten hydrierenden Wirkstoffe, die die Feuchtigkeitspegel deiner Haut wiederherstellen und noch verbessern können. Dies gibt dir einen glatteren und jünger wirkenden Teint.',
      },
      hd_texture: {
        average:
          'Verbessere die Textur deiner Haut, indem du Produkte verwendest, die Nährstoffe enthalten, die deiner Haut zugute kommen. Dies kann insgesamt die Gesundheit und das Erscheinungsbild deiner Haut verbessert und ihr ein vitales und gesundes Strahlen verleihen.',
        good:
          'Deine Haut sieht gut aus, also vergiss nicht, den Sonnenschutz großzügig aufzutragen, um dein schönes Gesicht zu schützen.',
        fair:
          'Möchtest du deine Hauttextur verschönern? Ziehe die Verwendung eines sanft pflegenden Produkts in Betracht, das ein- bis zweimal pro Woche tote Hautzellen entfernt und so einen strahlenderen Teint zum Vorschein kommen lässt.',
      },
      hd_dark_circle: {
        average:
          'Atme zunächst tief durch und fühl wie dir die Last von den Schultern fällt. Tupfe danach eine mit Antioxidant angereicherte Creme unter die Augen, um diesen Bereich zu stimulieren und strahlen zu lassen.',
        good:
          'Gönn dir auch weiterhin deinen Schönheitsschlaf! Deine Haut sieht gesund und erfrischt aus.',
        fair:
          'Vielleicht wird es Zeit, Methoden zu finden, um die Collagen-Produktion anzukurbeln und deiner empfindlichen Haut unter den Augen wieder Volumen und Straffheit zu geben. Dies hilft gegen jegliche dunkle Ringe unter den Augen.',
      },
      hd_eye_bag: {
        average:
          'Versuch es morgens und abends mit einer kalten Kompresse oder Teebeuteln, um die Tränensäcke unter den Augen zu reduzieren. Hole dir auch Produkte mit Gurken- oder Rosenwasser, um diesen Bereich zu hydrieren und zu beruhigen.',
        good:
          'Halte unbedingt deinen Schönheitsschlaf ein und behalte deinen stressfreien Lebensstil bei! Deine Haut sieht wunderschön aus.',
        fair:
          'Suche nach beruhigenden und entzündungshemmenden Produkten mit grünem Tee oder Koffein, um Schwellungen unter der empfindlichen Augenpartie zu reduzieren.',
      },
      hd_firmness: {
        average:
          'Eine sanfte Gesichtsmassage hilft, die Haut zu straffen und zu modellieren, und stimuliert die Muskeln, die das Volumen und das Aussehen der Haut insgesamt verbessern.',
        good:
          'Du siehst wie immer jugendlich und strahlend aus. Mach so weiter!',
        fair:
          'Brauchst du einen Hautpflege-Booster? Versuche es mit einer Kollagen-Boosting-Maske, um deiner Haut Volumen und Festigkeit zu geben.',
      },
      hd_droopy_upper_eyelid: {
        average:
          'Brauchst du einen kleinen Lift? Lege zwei gekühlte Gurkenscheiben für 10-20 Minuten auf die Augen, um die Haut auf natürliche Weise zu straffen und die Hauterschlaffung zu verbessern.',
        good:
          'Hallo, du Schönheit! Teile deine Hautpflegegeheimnisse mit uns – deine Haut sieht super aus.',
        fair:
          'Achte auf Produkte mit Resveratrol, die auf natürliche Weise dazu beitragen, die Zellalterung zu verlangsamen und die Haut straff und geliftet aussehen zu lassen.',
      },
      hd_droopy_lower_eyelid: {
        average:
          'Brauchst du einen kleinen Lift? Lege zwei gekühlte Gurkenscheiben für 10-20 Minuten auf die Augen, um die Haut auf natürliche Weise zu straffen und die Hauterschlaffung zu verbessern.',
        good:
          'Hallo, du Schönheit! Teile deine Hautpflegegeheimnisse mit uns – deine Haut sieht super aus.',
        fair:
          'Achte auf Produkte mit Resveratrol, die auf natürliche Weise dazu beitragen, die Zellalterung zu verlangsamen und die Haut straff und geliftet aussehen zu lassen.',
      },
      hd_radiance: {
        average:
          'Gib deiner Haut einen frischen Start, indem du morgens und abends ein pflegendes Reinigungsmittel anwendest, um jegliche Unreinheiten zu entfernen, die sich über den Tag angesammelt haben.',
        good:
          'Gönn dir auch weiterhin deinen Schönheitsschlaf! Deine Haut sieht gesund und erfrischt aus.',
        fair:
          'Lass das natürliche Strahlen deiner Haut wieder auferleben, indem du eine einfache tägliche Routine anwendest, dass Reinigen, Feuchtespende und Hautschutz umfasst.',
      },
      hd_acne: {
        average:
          'Behandle deine Haut sanft und halte sie sauber und hydriert. Hydrieren hilft der Haut, die Fettdrüsen auszugleichen, um Akne zu kontrollieren und die Heilung zu fördern.',
        good:
          'Lass die Finger von deinem Gesicht und vergiss nicht deinen täglichen Sonnenschutz und deine Feuchtigkeitscreme, um deine klare Haut zu verwöhnen und zu schützen.',
        fair:
          'Keine Hände ins Gesicht! Konzentriere dich mit einem sanfter Reiniger auf saubere und führe deiner Haut mit einer leichten Feuchtigkeitscreme Feuchtigkeit zu, die die Poren nicht verstopft. Vergiss auch nicht, deine Makeup-Pinsel zu reinigen.',
      },
      hd_pore: {
        average:
          'Setze deine Reinigung zweimal täglich fort, um Schmutz, Schweiß und Rückstände vom Tag abzuwaschen, die sich sonst in den Poren festsetzen könnten.',
        good: 'Ein meisterhafter wunderschöner Teint! Mach genau so weiter.',
        fair:
          'Um die Poren zu reinigen, , verwende zweimal täglich ein sanftes Reinigungsmittel und entscheide dich für und Makeup-Produkte, die die Poren nicht verstopfen.',
      },
      hd_pore_forehead: {
        average:
          'Setze deine Reinigung zweimal täglich fort, um Schmutz, Schweiß und Rückstände vom Tag abzuwaschen, die sich sonst in den Poren festsetzen könnten.',
        good: 'Ein meisterhafter wunderschöner Teint! Mach genau so weiter.',
        fair:
          'Um die Poren zu reinigen, , verwende zweimal täglich ein sanftes Reinigungsmittel und entscheide dich für und Makeup-Produkte, die die Poren nicht verstopfen.',
      },
      hd_pore_nose: {
        average:
          'Setze deine Reinigung zweimal täglich fort, um Schmutz, Schweiß und Rückstände vom Tag abzuwaschen, die sich sonst in den Poren festsetzen könnten.',
        good: 'Ein meisterhafter wunderschöner Teint! Mach genau so weiter.',
        fair:
          'Um die Poren zu reinigen, , verwende zweimal täglich ein sanftes Reinigungsmittel und entscheide dich für und Makeup-Produkte, die die Poren nicht verstopfen.',
      },
      hd_pore_cheek: {
        average:
          'Setze deine Reinigung zweimal täglich fort, um Schmutz, Schweiß und Rückstände vom Tag abzuwaschen, die sich sonst in den Poren festsetzen könnten.',
        good: 'Ein meisterhafter wunderschöner Teint! Mach genau so weiter.',
        fair:
          'Um die Poren zu reinigen, , verwende zweimal täglich ein sanftes Reinigungsmittel und entscheide dich für und Makeup-Produkte, die die Poren nicht verstopfen.',
      },
      hd_teartrough: {
        average:
          'Fühlst du dich ein wenig müde? Versuche es mit einer feuchtigkeitsspendenden Augencreme mit Inhaltsstoffen wie Hyaluronsäure oder Gurkenextrakt, um die Augenpartie aufzupolstern und Anzeichen von Müdigkeit zu reduzieren.',
        good:
          'Du siehst strahlend und ausgeruht aus! Setze deine tägliche Hautpflegeroutine fort, um ein erfrischtes Aussehen zu erhalten.',
        fair:
          'Zeit, sich um die müden Augenpartien zu kümmern! Achte auf Produkte mit Peptiden oder Retinol, um die Kollagenproduktion anzuregen und das Volumen der Tränenrinnen wiederherzustellen, was dir ein verjüngtes Aussehen verleiht.',
      },
      skin_health: {
        average: '',
        good: '',
        fair: '',
      },
    },
    esp: {
      hd_spot: {
        average:
          'Continúe limpiándose dos veces al día con su limpiador suave preferido y no olvide la hidratación.',
        good:
          '¡Hola, guapa! Su piel tiene un aspecto fenomenal. Continúe con su hidratante y protector solar a diario.',
        fair:
          'No se lleve las manos a la cara durante el día y sea diligente con una suave rutina de cuidado de la piel que incluya un limpiador suave y un tratamiento antiacné.',
      },
      hd_redness: {
        average:
          '¿Busca cómo calmar algunas rojeces de la piel? Busque productos con niacinamida para calmar la inflamación, homogeneizar el tono de la piel y ayudar a fortalecer la piel.',
        good:
          '¡Continúe haciendo lo que hace! Su tono de piel, hermoso y uniforme, habla por sí solo.',
        fair:
          'Deje los exfoliantes y tome un hidratante. Busque productos con ingredientes calmantes tales como niacinamida, raíz de regaliz, aloe, cafeína y pepino, que ayudan a reducir el enrojecimiento.',
      },
      hd_moisture: {
        average:
          '¡Sírvase un vaso de agua y beba! También ayudará a la piel usando un hidratante diario para ayudar a mantener la piel suave y elástica.',
        good:
          '¡Hola, hermosa piel hidratada! Continúe con la crema hidratante diaria y disfrute de esa flexibilidad.',
        fair:
          'Añada un hidratante diario y crema nocturna a la rutina de cuidado de la piel para restaurar y rejuvenecer la piel. Esto ayudará a hidratar y nutrir la piel para tener un aspecto fresco y revitalizado por la mañana.',
      },
      hd_oiliness: {
        average:
          '¿Batallando con un libero exceso de brillo? Prueba un limpiador con ácido salicílico que exfolie suavemente para limpiarse los poros, pero que no seque la piel.',
        good:
          '¡Parece que brilla en todas las zonas correctas! ¡Siga con el buen trabajo y continúe resplandeciente!',
        fair:
          'Si desea regular la producción sebácea y combatir el exceso de brillo, considere usar un tónico para la piel que contenga ingredientes exfoliadores suaves. Pueden ayudar a mantener los poros despejados y a evitar la excesiva acumulación de grasa.',
      },
      hd_wrinkle: {
        average:
          'La exposición al sol puede causar daños significativos en la piel, y el protector solar es su defensa número uno. Busque una fórmula con un factor de al menos 30 y repita la aplicación a menudo.',
        good:
          '¡Tiene buen aspecto! No olvide usar protector solar para mantener protegida esa piel tan suave y hermosa.',
        fair:
          'Busque hidratantes con potentes ingredientes que ayuden a restaurar y a mejorar los niveles de humedad de la piel para conseguir un cutis más suave y juvenil.',
      },
      hd_wrinkle_forehead: {
        average:
          'La exposición al sol puede causar daños significativos en la piel, y el protector solar es su defensa número uno. Busque una fórmula con un factor de al menos 30 y repita la aplicación a menudo.',
        good:
          '¡Tiene buen aspecto! No olvide usar protector solar para mantener protegida esa piel tan suave y hermosa.',
        fair:
          'Busque hidratantes con potentes ingredientes que ayuden a restaurar y a mejorar los niveles de humedad de la piel para conseguir un cutis más suave y juvenil.',
      },
      hd_wrinkle_glabellar: {
        average:
          'La exposición al sol puede causar daños significativos en la piel, y el protector solar es su defensa número uno. Busque una fórmula con un factor de al menos 30 y repita la aplicación a menudo.',
        good:
          '¡Tiene buen aspecto! No olvide usar protector solar para mantener protegida esa piel tan suave y hermosa.',
        fair:
          'Busque hidratantes con potentes ingredientes que ayuden a restaurar y a mejorar los niveles de humedad de la piel para conseguir un cutis más suave y juvenil.',
      },
      hd_wrinkle_periocular: {
        average:
          'La exposición al sol puede causar daños significativos en la piel, y el protector solar es su defensa número uno. Busque una fórmula con un factor de al menos 30 y repita la aplicación a menudo.',
        good:
          '¡Tiene buen aspecto! No olvide usar protector solar para mantener protegida esa piel tan suave y hermosa.',
        fair:
          'Busque hidratantes con potentes ingredientes que ayuden a restaurar y a mejorar los niveles de humedad de la piel para conseguir un cutis más suave y juvenil.',
      },
      hd_wrinkle_crowfeet: {
        average:
          'La exposición al sol puede causar daños significativos en la piel, y el protector solar es su defensa número uno. Busque una fórmula con un factor de al menos 30 y repita la aplicación a menudo.',
        good:
          '¡Tiene buen aspecto! No olvide usar protector solar para mantener protegida esa piel tan suave y hermosa.',
        fair:
          'Busque hidratantes con potentes ingredientes que ayuden a restaurar y a mejorar los niveles de humedad de la piel para conseguir un cutis más suave y juvenil.',
      },
      hd_wrinkle_nasolabial: {
        average:
          'La exposición al sol puede causar daños significativos en la piel, y el protector solar es su defensa número uno. Busque una fórmula con un factor de al menos 30 y repita la aplicación a menudo.',
        good:
          '¡Tiene buen aspecto! No olvide usar protector solar para mantener protegida esa piel tan suave y hermosa.',
        fair:
          'Busque hidratantes con potentes ingredientes que ayuden a restaurar y a mejorar los niveles de humedad de la piel para conseguir un cutis más suave y juvenil.',
      },
      hd_wrinkle_marionette: {
        average:
          'La exposición al sol puede causar daños significativos en la piel, y el protector solar es su defensa número uno. Busque una fórmula con un factor de al menos 30 y repita la aplicación a menudo.',
        good:
          '¡Tiene buen aspecto! No olvide usar protector solar para mantener protegida esa piel tan suave y hermosa.',
        fair:
          'Busque hidratantes con potentes ingredientes que ayuden a restaurar y a mejorar los niveles de humedad de la piel para conseguir un cutis más suave y juvenil.',
      },
      hd_texture: {
        average:
          'Mejore la textura de la piel usando productos que contengan nutrientes conocidos por beneficiar la piel. Pueden ayudar a mejorar el estado de salud y el aspecto general de la piel, dándole un brillo revitalizado y saludable.',
        good:
          'Su piel tiene buen aspecto, por lo que no debe olvidar echarse protector solar para mantener protegida esa hermosa cara.',
        fair:
          '¿Desea mejorar la textura de la piel? Considere el uso de un producto suave diseñado para eliminar las células epiteliales muertas de una a dos veces por semana para ayudar a mostrar un cutis más radiante.',
      },
      hd_dark_circle: {
        average:
          'En primer lugar, respire hondo y sienta cómo se libera el peso de los hombros. Luego aplique un crema rica en antioxidantes debajo de los ojos para ayuda a estimular e iluminar la zona.',
        good:
          '¡Continúe descansando su belleza! Su piel luce saludable y renovada.',
        fair:
          'Podría ser el momento de buscar formas para estimular la producción de colágeno y restaurar el volumen y la firmeza en la piel sensible debajo de los ojos. Esto ayudará a mejorar cualquier zona oscura debajo de los ojos.',
      },
      hd_eye_bag: {
        average:
          'Pruebe una compresa o bolsitas de té frías para comenzar o terminar el día para ayudar a reducir la hinchazón debajo de los ojos. Busque también productos con pepino o agua de rosas para ayudar a hidratar y calmar la zona.',
        good:
          '¡Redoble su sueño reparador y siga en la cima con ese estilo de vida libre de estrés! Su piel tiene un aspecto magnífico.',
        fair:
          'Busque relajantes y productos antiinflamatorios con té verde o cafeína para ayudar a reducir la hinchazón en la sensible zona debajo de los ojos.',
      },
      hd_firmness: {
        average:
          'Un suave masaje en el rostro ayudará a levantar y esculpir la piel, estimulando los músculos que mejoran el volumen general de la piel y su aspecto.',
        good:
          'Tiene un aspecto tan joven y resplandeciente como siempre. ¡Siga así!',
        fair:
          '¿Necesita un impulso para el cuidado de la piel? Prueba una mascarilla potenciadora de colágeno para ayudar a restaurar el volumen y firmeza de la piel.',
      },
      hd_droopy_upper_eyelid: {
        average:
          '¿Necesitas un pequeño empujón? Coloque dos rodajas de pepino frías sobre los ojos durante 10-20 minutos para tensar la piel de forma natural y mejorar la flacidez.',
        good:
          '¡Hola, tiene buen aspecto! Cuéntenos todos sus secretos para el cuidado de la piel: su piel luce espléndida.',
        fair:
          'Busque productos con resveratrol, que ayuda de forma natural a retrasar el envejecimiento celular y a mantener la piel apretada y elevada.',
      },
      hd_droopy_lower_eyelid: {
        average:
          '¿Necesitas un pequeño empujón? Coloque dos rodajas de pepino frías sobre los ojos durante 10-20 minutos para tensar la piel de forma natural y mejorar la flacidez.',
        good:
          '¡Hola, tiene buen aspecto! Cuéntenos todos sus secretos para el cuidado de la piel: su piel luce espléndida.',
        fair:
          'Busque productos con resveratrol, que ayuda de forma natural a retrasar el envejecimiento celular y a mantener la piel apretada y elevada.',
      },
      hd_radiance: {
        average:
          'Empiece bien la mañana usando un limpiador suave mañana y noche para eliminar las impurezas que se hayan podido acumular a lo largo del día.',
        good:
          '¡Continúe descansando su belleza! Su piel luce saludable y renovada.',
        fair:
          'Reviva el brillo natural de la piel siguiendo una sencilla rutina diaria que incluya limpieza, hidratación y protección de la piel.',
      },
      hd_acne: {
        average:
          'Sea amable con su piel y manténgala limpia e hidratada. La hidratación ayuda a reequilibrar las glándulas sebáceas de la piel para controlar el acné y mejorar la cicatrización.',
        good:
          'No se lleve las manos a la cara y no se olvide de su protector solar e hidratante a diario para mantener su clara piel mimada y protegida.',
        fair:
          '¡No se lleve las manos a la cara! Concéntrese en mantener la piel limpia con un limpiador suave y reponer la hidratación con un humectante libero que no obstruya los poros. No olvide limpiar también los pinceles de maquillaje.',
      },
      hd_pore: {
        average:
          'Continúe con la limpieza dos veces al día para ayudar eliminar la suciedad y el sudor de cada día que, de lo contrario, puede asentarse en los poros.',
        good:
          '¡Alguien conoce el modo de mantener una tez hermosa! Continúe con el buen trabajo.',
        fair:
          'Para ayudar a eliminar la obstrucción de los poros, use un limpiador suave dos veces al día y opte por productos de cuidado y maquillaje que no obstruyan los poros.',
      },
      hd_pore_forehead: {
        average:
          'Continúe con la limpieza dos veces al día para ayudar eliminar la suciedad y el sudor de cada día que, de lo contrario, puede asentarse en los poros.',
        good:
          '¡Alguien conoce el modo de mantener una tez hermosa! Continúe con el buen trabajo.',
        fair:
          'Para ayudar a eliminar la obstrucción de los poros, use un limpiador suave dos veces al día y opte por productos de cuidado y maquillaje que no obstruyan los poros.',
      },
      hd_pore_nose: {
        average:
          'Continúe con la limpieza dos veces al día para ayudar eliminar la suciedad y el sudor de cada día que, de lo contrario, puede asentarse en los poros.',
        good:
          '¡Alguien conoce el modo de mantener una tez hermosa! Continúe con el buen trabajo.',
        fair:
          'Para ayudar a eliminar la obstrucción de los poros, use un limpiador suave dos veces al día y opte por productos de cuidado y maquillaje que no obstruyan los poros.',
      },
      hd_pore_cheek: {
        average:
          'Continúe con la limpieza dos veces al día para ayudar eliminar la suciedad y el sudor de cada día que, de lo contrario, puede asentarse en los poros.',
        good:
          '¡Alguien conoce el modo de mantener una tez hermosa! Continúe con el buen trabajo.',
        fair:
          'Para ayudar a eliminar la obstrucción de los poros, use un limpiador suave dos veces al día y opte por productos de cuidado y maquillaje que no obstruyan los poros.',
      },
      hd_teartrough: {
        average:
          '¿Siente un poco de cansancio? Pruebe una crema de ojos con ingredientes como el ácido hialurónico o el extracto de pepino para rellenar la zona del surco lagrimal y reducir cualquier signo de fatiga.',
        good:
          '¡Tiene una mirada luminosa y con aspecto de haber descansado! Siga con su rutina diaria de cuidado de la piel para conservar ese aspecto renovado.',
        fair:
          '¡Es hora de tratar esas ojeras de cansancio! Busca productos con péptidos o retinol para estimular la producción de colágeno y restaurar el volumen de los surcos lagrimales, dándote un aspecto rejuvenecido.',
      },
      skin_health: {
        average: '',
        good: '',
        fair: '',
      },
    },
    ita: {
      hd_spot: {
        average:
          'Continua a detergere due volte al giorno con il tuo detergente delicato preferito e non dimenticare di idratare.',
        good:
          "Ciao bellezza! La tua pelle sembra abbastanza buona. Continua a usare la tua crema idratante quotidiana e l'SPF.",
        fair:
          'Tieni le mani lontane dal viso durante il giorno e adotta una routine di cura della pelle delicata, che comprenda un detergente delicato e un trattamento per le macchie di acne.',
      },
      hd_redness: {
        average:
          'Vorresti lenire i rossori della pelle? Prova prodotti con niacinamide, che lenisce le infiammazioni, uniforma il tono della pelle e aiuta a rafforzarla.',
        good: 'Continua così! La tua carnagione bella e uniforme parla da sé.',
        fair:
          "Metti da parte gli esfolianti e usa una crema idratante. Prova prodotti con ingredienti lenitivi come la niacinamide, la radice di liquirizia, l'aloe, la caffeina e il cetriolo che aiutano a ridurre il rossore.",
      },
      hd_moisture: {
        average:
          "Versati un bicchiere d'acqua e bevi! Aiuta la salute della tua pelle usando un moisturizer quotidiano per per mantenere la sensibilità della pelle morbida ed elastica.",
        good:
          "Ciao bella pelle idratata! Continua a usare l'idratante quotidiano e goditi la morbidezza della rugiada.",
        fair:
          'Aggiungi un idratante giornaliero e una crema notturna alla tua routine di cura della pelle per ripristinare e ringiovanire la pelle. In questo modo, potrai rifornire e nutrire la tua pelle per un look fresco e rivitalizzato al mattino.',
      },
      hd_oiliness: {
        average:
          "Stai lottando contro un po' di lucentezza in più? Prova un detergente con acido salicilico che esfolia delicatamente per liberare i pori, ma non secca la pelle.",
        good:
          'Sembra che tu stia brillando in tutti i punti giusti! Continua a migliorare e a brillare!',
        fair:
          "Per regolare la produzione di olio e combattere la lucentezza, è consigliabile utilizzare un toner per la pelle contenente delicati ingredienti esfolianti. Questi possono contribuire a mantenere i pori liberi ed impediscono l'accumulazione eccessiva dell'olio.",
      },
      hd_wrinkle: {
        average:
          "L'esposizione al sole può causare danni significativi alla pelle: SPF è la tua difesa numero uno. Cerca una formula con almeno SPF 30 o superiore e applicala spesso.",
        good:
          "Sembra buono! Non dimenticare di applicare l'SPF per proteggere la pelle liscia e bella.",
        fair:
          'Valuta idratanti con potenti ingredienti idratanti che possono aiutare a ripristinare e migliorare i livelli di umidità della pelle per una carnagione più liscia e giovanile.',
      },
      hd_wrinkle_forehead: {
        average:
          "L'esposizione al sole può causare danni significativi alla pelle: SPF è la tua difesa numero uno. Cerca una formula con almeno SPF 30 o superiore e applicala spesso.",
        good:
          "Sembra buono! Non dimenticare di applicare l'SPF per proteggere la pelle liscia e bella.",
        fair:
          'Valuta idratanti con potenti ingredienti idratanti che possono aiutare a ripristinare e migliorare i livelli di umidità della pelle per una carnagione più liscia e giovanile.',
      },
      hd_wrinkle_glabellar: {
        average:
          "L'esposizione al sole può causare danni significativi alla pelle: SPF è la tua difesa numero uno. Cerca una formula con almeno SPF 30 o superiore e applicala spesso.",
        good:
          "Sembra buono! Non dimenticare di applicare l'SPF per proteggere la pelle liscia e bella.",
        fair:
          'Valuta idratanti con potenti ingredienti idratanti che possono aiutare a ripristinare e migliorare i livelli di umidità della pelle per una carnagione più liscia e giovanile.',
      },
      hd_wrinkle_periocular: {
        average:
          "L'esposizione al sole può causare danni significativi alla pelle: SPF è la tua difesa numero uno. Cerca una formula con almeno SPF 30 o superiore e applicala spesso.",
        good:
          "Sembra buono! Non dimenticare di applicare l'SPF per proteggere la pelle liscia e bella.",
        fair:
          'Valuta idratanti con potenti ingredienti idratanti che possono aiutare a ripristinare e migliorare i livelli di umidità della pelle per una carnagione più liscia e giovanile.',
      },
      hd_wrinkle_crowfeet: {
        average:
          "L'esposizione al sole può causare danni significativi alla pelle: SPF è la tua difesa numero uno. Cerca una formula con almeno SPF 30 o superiore e applicala spesso.",
        good:
          "Sembra buono! Non dimenticare di applicare l'SPF per proteggere la pelle liscia e bella.",
        fair:
          'Valuta idratanti con potenti ingredienti idratanti che possono aiutare a ripristinare e migliorare i livelli di umidità della pelle per una carnagione più liscia e giovanile.',
      },
      hd_wrinkle_nasolabial: {
        average:
          "L'esposizione al sole può causare danni significativi alla pelle: SPF è la tua difesa numero uno. Cerca una formula con almeno SPF 30 o superiore e applicala spesso.",
        good:
          "Sembra buono! Non dimenticare di applicare l'SPF per proteggere la pelle liscia e bella.",
        fair:
          'Valuta idratanti con potenti ingredienti idratanti che possono aiutare a ripristinare e migliorare i livelli di umidità della pelle per una carnagione più liscia e giovanile.',
      },
      hd_wrinkle_marionette: {
        average:
          "L'esposizione al sole può causare danni significativi alla pelle: SPF è la tua difesa numero uno. Cerca una formula con almeno SPF 30 o superiore e applicala spesso.",
        good:
          "Sembra buono! Non dimenticare di applicare l'SPF per proteggere la pelle liscia e bella.",
        fair:
          'Valuta idratanti con potenti ingredienti idratanti che possono aiutare a ripristinare e migliorare i livelli di umidità della pelle per una carnagione più liscia e giovanile.',
      },
      hd_texture: {
        average:
          "Migliora la struttura della tua pelle utilizzando prodotti che contengono sostanze nutritive note per beneficiare la pelle. Questi prodotti possono contribuire a migliorare la salute generale e l'aspetto della pelle fornendole una luminosità rivitalizzata e sana.",
        good:
          "La tua pelle ha un bell'aspetto, quindi non dimenticare di applicare l'SPF per proteggere il tuo bel viso.",
        fair:
          "Vuoi migliorare la texture della tua pelle? Considera l'uso di un prodotto delicato, pensato per rimuovere le cellule morte della pelle una o due volte alla settimana e aiutare a ottenere carnagione raggiante.",
      },
      hd_dark_circle: {
        average:
          'Per prima cosa fai un respiro profondo e senti il peso che ti viene tolto dalle spalle. Quindi applica una crema ricca di antiossidanti sotto gli occhi per aiutare a stimolare e illuminare la zona.',
        good:
          'Continua il tuo beauty relax! La pelle ha un aspetto sano e rinnovato.',
        fair:
          'Potrebbe essere arrivato il momento di trovare un modo per stimolare la produzione di collagene e ridare volume e fermezza alla pelle sensibile sotto gli occhi. In questo modo, combatti le occhiaie.',
      },
      hd_eye_bag: {
        average:
          "Prova a fare un impacco freddo o una bustina di tè all'inizio o alla fine della giornata per ridurre le borse sotto gli occhi. Scegli anche prodotti con cetriolo o acqua di rose per idratare e calmare la zona.",
        good:
          'Fai il pieno di sonno di bellezza e continua a seguire uno stile di vita privo di stress! La tua pelle è splendida.',
        fair:
          "Prova prodotti lenitivi e antinfiammatori con tè verde o caffeina per ridurre il gonfiore sotto l'area sensibile degli occhi.",
      },
      hd_firmness: {
        average:
          "Un massaggio delicato del viso aiuterà a sollevare e scolpire la pelle, stimolando i muscoli che miglioreranno il volume e l'aspetto generale della pelle.",
        good:
          'Il tuo aspetto è più giovane e luminoso che mai. Mantienilo così!',
        fair:
          'Hai bisogno di una spinta per la tua pelle? Prova una maschera che rafforza il collagene per aiutare a ripristinare il volume e la compattezza della pelle.',
      },
      hd_droopy_upper_eyelid: {
        average:
          'Hai bisogno di un piccolo lifting? Posiziona due fette di cetriolo fredde sugli occhi per 10-20 minuti per rassodare naturalmente la pelle e ridurre il rilassamento.',
        good:
          "Ehi, bellezza! Svelaci tutti i tuoi segreti per la cura della pelle: la tua ha un bell'aspetto.",
        fair:
          "Prova prodotti con resveratrolo, che aiuta naturalmente a rallentare l'invecchiamento cellulare e a mantenere la pelle alta e liftata.",
      },
      hd_droopy_lower_eyelid: {
        average:
          'Hai bisogno di un piccolo lifting? Posiziona due fette di cetriolo fredde sugli occhi per 10-20 minuti per rassodare naturalmente la pelle e ridurre il rilassamento.',
        good:
          "Ehi, bellezza! Svelaci tutti i tuoi segreti per la cura della pelle: la tua ha un bell'aspetto.",
        fair:
          "Prova prodotti con resveratrolo, che aiuta naturalmente a rallentare l'invecchiamento cellulare e a mantenere la pelle alta e liftata.",
      },
      hd_radiance: {
        average:
          'Abitua la pelle a un detergente delicato la mattina e la notte per rimuovere eventuali impurità accumulatesi durante il giorno.',
        good:
          'Sei raggiante, uno splendore! Continua così e goditi questi splendidi risultati.',
        fair:
          'Ravviva la luce naturale della tua pelle seguendo una semplice routine quotidiana che include pulizia, idratazione e protezione della pelle.',
      },
      hd_acne: {
        average:
          "Tratta con delicatezza la tua pelle e mantienila pulita e idratata. Hyrdation aiuta a riequilibrare le ghiandole oleifere della pelle per controllare l'acne e migliorare la guarigione.",
        good:
          "Tieni le mani lontane dal viso e non dimenticare l'SPF e la crema idratante quotidiana per mantenere la pelle chiara rilassata e protetta.",
        fair:
          'Giù le mani dal viso! Concentrati sulla pulizia della pelle con un detergente delicato e sulla reidratazione con una crema idratante leggera che non ostruisca i pori. Non dimenticate di pulire anche i pennelli da trucco.',
      },
      hd_pore: {
        average:
          'Continua a fare la pulizia due volte al giorno per aiutare a lavare via lo sporco, il sudore e la sporcizia della giornata che altrimenti potrebbero depositarsi nei pori.',
        good:
          'Qualcuno è riuscito a ottenere una bella carnagione! Continua a migliorare.',
        fair:
          'Per aiutare a liberare i pori, usa un detergente delicato due volte al giorno e dei prodotti per la cura della pelle e per il trucco che non ostruiscano i pori',
      },
      hd_pore_forehead: {
        average:
          'Continua a fare la pulizia due volte al giorno per aiutare a lavare via lo sporco, il sudore e la sporcizia della giornata che altrimenti potrebbero depositarsi nei pori.',
        good:
          'Qualcuno è riuscito a ottenere una bella carnagione! Continua a migliorare.',
        fair:
          'Per aiutare a liberare i pori, usa un detergente delicato due volte al giorno e dei prodotti per la cura della pelle e per il trucco che non ostruiscano i pori',
      },
      hd_pore_nose: {
        average:
          'Continua a fare la pulizia due volte al giorno per aiutare a lavare via lo sporco, il sudore e la sporcizia della giornata che altrimenti potrebbero depositarsi nei pori.',
        good:
          'Qualcuno è riuscito a ottenere una bella carnagione! Continua a migliorare.',
        fair:
          'Per aiutare a liberare i pori, usa un detergente delicato due volte al giorno e dei prodotti per la cura della pelle e per il trucco che non ostruiscano i pori',
      },
      hd_pore_cheek: {
        average:
          'Continua a fare la pulizia due volte al giorno per aiutare a lavare via lo sporco, il sudore e la sporcizia della giornata che altrimenti potrebbero depositarsi nei pori.',
        good:
          'Qualcuno è riuscito a ottenere una bella carnagione! Continua a migliorare.',
        fair:
          'Per aiutare a liberare i pori, usa un detergente delicato due volte al giorno e dei prodotti per la cura della pelle e per il trucco che non ostruiscano i pori',
      },
      hd_teartrough: {
        average:
          "Avverti un po' di stanchezza? Prova una crema idratante per il contorno occhi, con ingredienti come l'acido ialuronico o l'estratto di cetriolo, per rimpolpare l'area del solco lacrimale e ridurre eventuali segni di stanchezza.",
        good:
          'Hai un aspetto luminoso e riposato! Segui la tua routine di bellezza quotidiana per mantenere questo aspetto radioso.',
        fair:
          'È il momento di prenderti cura delle occhiaie! Cerca prodotti che contengano peptidi o retinolo che aiutano a stimolare la produzione di collagene e rivitalizzare il contorno occhi, per un aspetto più tonico e fresco.',
      },
      skin_health: {
        average: '',
        good: '',
        fair: '',
      },
    },
    cht: {
      hd_spot: {
        good:
          '膚色均勻沒有斑點與瑕疵，平時防曬很到位哦！除了日常基礎保養之外，可以嘗試抗氧化修復保養，挑選添加維他命A或Ｃ的修護成分持續優化膚質，讓膚色更透亮。',
        average:
          '隱藏的斑點蠢蠢欲動，再不即刻加強防曬保護，黑色素就要浮出肌膚表面啦！這時候要用美白精華再搭配能促進色素代謝的保養品。記得白天不要使用含光敏感成分的保養品，也要少吃光敏感性食物，以免加深色素沉澱。',
        fair:
          '已經有較為明顯的斑點，戶外需要高係數的防水型防曬；容易忽略的室內紫外線及3C產品的藍光，可以選用SPF10～15日常防曬；每天持續美白及修護保養，每週至少敷2次高效美白面膜、至少一次去角質護理。',
      },
      hd_wrinkle: {
        good:
          '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
        average:
          '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
        fair:
          '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
      },
      hd_wrinkle_forehead: {
        good:
          '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
        average:
          '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
        fair:
          '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
      },
      hd_wrinkle_glabellar: {
        good:
          '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
        average:
          '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
        fair:
          '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
      },
      hd_wrinkle_periocular: {
        good:
          '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
        average:
          '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
        fair:
          '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
      },
      hd_wrinkle_crowfeet: {
        good:
          '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
        average:
          '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
        fair:
          '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
      },
      hd_wrinkle_nasolabial: {
        good:
          '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
        average:
          '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
        fair:
          '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
      },
      hd_wrinkle_marionette: {
        good:
          '膚況堪稱年輕且充滿活力！做好預防初老保養即可，可以使用精華液、抗氧化保養品來預防自由基帶來的傷害，同時加強防曬隔離，避免光老化。',
        average:
          '假性皺紋可能找上你了，比如大笑時的眼周與嘴角的表情紋，還有兩頰小細紋，這些都是因為光老化所造成，除了持續的抗氧化保養外，記得加強防曬保護，減少紫外線和自由基損傷，同時還要補充適量的維生素和微量元素。',
        fair:
          '邁入熟齡肌，除了肌膚逐漸變薄且脆弱外，魚尾紋、法令紋及抬頭紋紛紛出現，輪廓也失去緊緻度，頸紋與雙下巴也來湊熱鬧。選用能發揮緊緻、提拉、撫紋功效的精華與乳霜並搭配適當醫美療程，還是能期待重現年輕光彩。',
      },
      hd_texture: {
        good:
          '是人人稱羨的水煮蛋肌！角質代謝良好，想必平時清潔步驟有徹底執行，看不見毛孔與細紋的現象要繼續保持下去。基礎保養外再進一步加入維持肌膚微生態平衡的產品，像是酵母原液等就很適合。',
        average:
          '膚質乍看還不錯，但近看毛孔還是有些黑頭白頭粉刺，可以嘗試每週一次的深層清潔護理，或是隔週一次的低濃度果酸煥膚，精華液、乳霜與定期的面膜調理也不能少，就能讓肌膚恢復應有的柔嫩細緻。',
        fair:
          '忙碌導致代謝循環速度低落，膚色也會黯沉少活力。老廢角質細胞堆疊造成毛孔阻塞。肌膚表面粗糙不平需要從肌底修護做起，徹底排除肌膚底層的老廢物質，記得每週至少一次深層清潔並搭配2～3次煥膚面膜。',
      },
      hd_dark_circle: {
        average:
          '長時間盯著手機和電腦會使眼壓變大且循環不良，黑眼圈和眼周細紋就會悄悄出現！每天早晚，在使用眼部保養品時輕輕地用指腹按壓眼周可舒緩疲勞，每週敷2次眼膜擇能幫助預防熊貓眼與眼周浮腫。',
        fair:
          '經常熬夜的你，使用手機和電腦的時間應該也蠻長的，絕對不能忽略眼周專屬保養產品，像是幫助循環的眼部精華及修護眼霜，敷眼膜的頻率也可提高到一週2～3次。用眼每小時要休息至少5分鐘，幫眼周按按摩。',
        good:
          '作息規律眼睛明亮的你，只需要維持基礎眼霜保養並偶爾敷敷眼膜即可。但夏天戶外陽光強烈要記得戴上太陽眼鏡，也能保護雙眼避免黑色素增生。',
      },
      hd_radiance: {
        good:
          '肌膚表面油水平衡超完美，可以均勻反射出光采。比起保養更重要的是清潔，洗臉的水溫記得不能比膚溫高，用洗面產品的泡沫溫和按摩肌膚持續至少一分鐘，讓清潔成分有效發揮作用再清洗即可。',
        average:
          '局部黯沉但困擾不大，除了清潔之外，可一週使用2～3次去角質產品加強老廢角質的排除，並選擇深度保濕產品讓肌膚充滿水分自然就能折射出健康光采。',
        fair:
          '膚色蠟黃黯沉如影隨行，看起來精神欠佳！面膜可以在短時間內給予肌膚養分補充，幫助淡化色素沉澱、均勻膚色，還能發揮立即提亮的效果。根據自己的膚質（中/混和/乾/敏感性）來選擇，才能達到最理想的效果。',
      },
      hd_oiliness: {
        average:
          '我相信你的控油還可以做得更好！目前T區（額頭、鼻及下巴）偏油，兩頰卻有可能偏乾幹，可選擇為混合性皮膚設計的控油產品，以及不會阻塞毛孔的保濕、防曬及粉底彩妝，恢復本身天然的油水平衡。',
        fair:
          '中東油田就是你！保養時可選擇適合油性及痘痘肌的無油配方，底妝以霧光且具皮脂調節作用的為佳。少碰甜食和高糖飲料，也不要熬夜讓心情放輕鬆。',
        good:
          '控油能力棒棒der！頂多春夏季偶爾在額頭鼻部及下巴有小小的出油現象，局部使用控油產品就可以。除了日常保養還可以嘗試更高效的深層清潔或煥膚精華和麵膜等產品。',
      },
      hd_eye_bag: {
        good:
          '只有臥蠶沒有眼袋！保持每天8小時睡眠並提高睡眠的品質，睡前不要喝太多水，平時不要給自己太大的心理壓力，平常選擇眼部專用精華液輕鬆保養即可。',
        average:
          '只有早上起來時眼袋較明顯，得注意改善眼周血液循環，工作念書的空檔多做眼部穴位按摩，可以預防眼袋的惡化。挑選附按摩端的眼部專用保養品，一邊塗抹眼霜時還能加強代謝循環。',
        fair:
          '不僅眼袋明顯，還伴隨了色素黯沉或陰影問題看起來十分老氣。但由於眼周肌膚薄且脆弱易引起刺激反應，選擇低敏型眼部保養品為佳，添加咖啡因成分的眼霜有助於排水，而胜肽等修護成分則能拉提鬆垮的線條。',
      },
      hd_moisture: {
        average:
          '保水度還有提升的空間哦！日常保養除了持續補水鎖水的精華液之外，可再加一道高保濕乳液預防水分流失。注意不要過度清潔，中午午休後、補妝前可以噴些保濕噴霧，並記得用面紙按掉多餘水分，每週敷2～3次面膜以提升肌膚保水度。',
        good:
          '你的肌膚水潤光滑，擁有健康的油水平衡又飽滿有彈性！日常的保濕產品要繼續使用，每週至少一次去角質護理並搭配抗氧化精華，能提供更適當的保護及防禦。',
        fair:
          '保水度明顯不夠，有可能出現乾紋或敏感等問題！先以精華類產品能深度補充水分，再以高保濕乳液或乳霜形成鎖水膜預防水分流失，且每天至少喝8杯水，不定時補充保濕噴霧，且每週至少敷3次保濕面膜。',
      },
      hd_droopy_upper_eyelid: {
        good:
          '20～35歲之間，通常是因為水腫出現的眼皮鬆弛下垂，透過具排水功能的眼部保養系列多半可以獲得改善，記得擦眼霜的時候不要過度拉扯，使用3C產品的時間也不要過長，用眼過度也會造成眼周肌肉的負擔。',
        average:
          '40歲之後出現的眼皮鬆弛下垂不外乎就是老化問題，但眼瞼鬆弛的程度與速度與體質及保養習慣有很大的關聯。改用較為滋潤的眼霜持續呵護之外，白天出門的防曬也別忘記眼周部位，以避免紫外線加速光老化速度。',
        fair:
          '眼角明顯鬆弛甚至改變眼型，用分子細小的胜肽類保養品，或添加左旋C及其他抗氧化成分的眼部產品，可以透過按摩達到眼皮提拉的效果，並促進眼周的微循環，進而消除眼皮浮腫與鬆弛。',
      },
      hd_droopy_lower_eyelid: {
        average:
          '眼尾的緊緻度稍嫌不足，塗抹眼部保養品時以水平方向擦拭且力道也要相當輕柔，周間可輔以較潤澤的美容油搭配拉提按摩幫助恢復線條的緊緻度。',
        fair:
          '出現了明顯的淚溝與紋路，代表眼周保養力度不足，飲食方面多攝取豐富維他命Ｃ含量的蔬果，有助於肌底組織更健康。選擇抗氧化效果強的胜肽成分眼霜或可刺激膠原增生的保養品更符合需求。',
        good:
          '沒有細紋也沒有淚溝的飽滿好膚質，選擇質地清爽的眼部精華或是凝露狀產品維持眼周肌膚的保水度，不熬夜也不要經常搓揉眼睛就能擁有電眼明眸。',
      },
      hd_firmness: {
        good:
          '整體輪廓緊緻有彈性，努力維持膠原蛋白在最佳狀態。同樣記得防曬避免膠原提早流失，日常則是多補充維他命C含量高的蔬果，保養重視保濕，擦保養品時可搭配輪廓線的拉提按摩。',
        average:
          '眼瞼下垂、臉頰或嘴角下垂，五官沒有之前立體了。由於人體的含水量超過60％，其中15％集中在肌膚，最重要的護膚守則之一救是每日都要飲用足夠的水，除了日常的保濕保養外，每周2~3次可交替使用保濕與拉提緊緻面膜。',
        fair:
          '連頸部肌膚都開始下垂或紋路增加（俗稱火雞脖子），再不努力就來不及了！優質睡眠，搭配睡前的紫外線修護調理，讓夜晚肌膚黃金修復期得以發揮最好的運作，也能適當使用喜愛的精油增加睡眠品質。',
      },
      hd_redness: {
        average:
          '兩頰微微泛紅看起來雖可愛，但是毛細血管長期擴張可能形成紅斑或血絲，所以，一旦出現泛紅現象就要及時鎮靜舒緩，曬太陽後一定要做好修復並補充大量水分，同時選擇物理性防曬產品為佳。',
        good:
          '肌膚很健壯！但隨著時間推移結構會越來越脆弱鬆散，漸漸失去防禦能力，天氣變化、污染、化學物質等都很容易影響，還是需要使用適合肌膚的保養品來建構天然防禦力，才能維持肌表的生態平衡。',
        fair:
          '偏向敏感性膚質！肌膚較薄且表皮屏障較弱，建議選用通過敏感測試的產品，並且不要過度清潔，保養步驟與成分都盡量單純，使用舒緩性的化妝水或乳液即可，若有微熱、搔癢和疹塊現象，就必須暫停使用保養品，尋求皮膚科醫師的診斷！',
      },
      hd_acne: {
        good:
          '幾乎看不見毛孔，讓人羨慕的光滑平整肌！做好每天的卸妝與清潔，並注意肌膚表面的油水平衡，但不要過度的清潔或是頻繁的使用吸油產品，以免肌膚過度分泌皮脂反而造成痘痘問題。',
        average:
          '出現痘痘蹤跡但沒有紅疹現象，那就是粉刺，粉刺型青春痘通常使用含A酸的保養品就可以達到不錯的控制效果。但初期使用Ａ酸可能會有刺激性，且當照射陽光刺激性會加劇，建議晚上使用即可，白天的防曬品也要選擇質地清爽的。',
        fair:
          '膿皰型青春痘，甚至還伴隨嚴重的紅腫，表示發炎感染已經到達真皮層，留下痘疤的機率相當高。口服及外用A酸並行是最有效，另外，像果酸、杏仁酸、杜鵑花酸這類成也可輔助使用，但嚴重面皰問題絕對建議請教專業皮膚科醫師一起解決！',
      },
      hd_pore: {
        fair:
          '除了痘疤還伴隨著老化型毛孔，尤其兩頰毛孔更為明顯，除了醫學美容之外，平日保養加強去角質等深層清潔，老化型毛孔則要更注意清潔之後的保濕，同時可使用含維他命A的保養品持續細緻粗大毛孔問題。',
        average:
          '油性肌膚出油過多與老廢角質堆積，固化的皮脂進而形成白頭與黑頭粉刺，毛囊內部因長期受到擠壓而顯得粗大。使用含適當濃度的酸類產品煥膚，發揮控油、代謝老化角質等作用便能改善毛孔粗大問題。',
        good:
          '膚質看起來很精緻幾乎零毛孔，記得持續做好保濕與防曬，避免油脂過度堆積。愛曬太陽又不防曬的人毛孔絕對會越來越粗大，因為紫外線會破壞肌底膠原蛋白，使皮膚老化鬆弛，因此，一年四季都要擦防曬。',
      },
      hd_pore_forehead: {
        fair:
          '除了痘疤還伴隨著老化型毛孔，尤其兩頰毛孔更為明顯，除了醫學美容之外，平日保養加強去角質等深層清潔，老化型毛孔則要更注意清潔之後的保濕，同時可使用含維他命A的保養品持續細緻粗大毛孔問題。',
        average:
          '油性肌膚出油過多與老廢角質堆積，固化的皮脂進而形成白頭與黑頭粉刺，毛囊內部因長期受到擠壓而顯得粗大。使用含適當濃度的酸類產品煥膚，發揮控油、代謝老化角質等作用便能改善毛孔粗大問題。',
        good:
          '膚質看起來很精緻幾乎零毛孔，記得持續做好保濕與防曬，避免油脂過度堆積。愛曬太陽又不防曬的人毛孔絕對會越來越粗大，因為紫外線會破壞肌底膠原蛋白，使皮膚老化鬆弛，因此，一年四季都要擦防曬。',
      },
      hd_pore_nose: {
        fair:
          '除了痘疤還伴隨著老化型毛孔，尤其兩頰毛孔更為明顯，除了醫學美容之外，平日保養加強去角質等深層清潔，老化型毛孔則要更注意清潔之後的保濕，同時可使用含維他命A的保養品持續細緻粗大毛孔問題。',
        average:
          '油性肌膚出油過多與老廢角質堆積，固化的皮脂進而形成白頭與黑頭粉刺，毛囊內部因長期受到擠壓而顯得粗大。使用含適當濃度的酸類產品煥膚，發揮控油、代謝老化角質等作用便能改善毛孔粗大問題。',
        good:
          '膚質看起來很精緻幾乎零毛孔，記得持續做好保濕與防曬，避免油脂過度堆積。愛曬太陽又不防曬的人毛孔絕對會越來越粗大，因為紫外線會破壞肌底膠原蛋白，使皮膚老化鬆弛，因此，一年四季都要擦防曬。',
      },
      hd_pore_cheek: {
        fair:
          '除了痘疤還伴隨著老化型毛孔，尤其兩頰毛孔更為明顯，除了醫學美容之外，平日保養加強去角質等深層清潔，老化型毛孔則要更注意清潔之後的保濕，同時可使用含維他命A的保養品持續細緻粗大毛孔問題。',
        average:
          '油性肌膚出油過多與老廢角質堆積，固化的皮脂進而形成白頭與黑頭粉刺，毛囊內部因長期受到擠壓而顯得粗大。使用含適當濃度的酸類產品煥膚，發揮控油、代謝老化角質等作用便能改善毛孔粗大問題。',
        good:
          '膚質看起來很精緻幾乎零毛孔，記得持續做好保濕與防曬，避免油脂過度堆積。愛曬太陽又不防曬的人毛孔絕對會越來越粗大，因為紫外線會破壞肌底膠原蛋白，使皮膚老化鬆弛，因此，一年四季都要擦防曬。',
      },
      hd_teartrough: {
        average:
          '感覺有點疲憊嗎？試試含有玻尿酸或黃瓜萃取物的保濕眼霜，能有效滋潤淚溝部位，減少疲勞痕跡。',
        good:
          '你看起來眼睛明亮有神，精神飽滿！繼續保持日常保養習慣，讓肌膚維持清新感覺。',
        fair:
          '是時候解決那些疲憊的眼下問題了！選擇含有胜肽或 A 醇的產品，幫助刺激膠原蛋白生成，恢復淚溝部位的飽滿感，讓你的外表更加年輕有活力。',
      },
      skin_health: {
        average: '',
        good: '',
        fair: '',
      },
    },
    chs: {
      hd_spot: {
        good:
          '肤色均匀没有斑点与瑕疵，平时防晒很到位哟！除日常基础护肤之外，可以尝试抗氧化修复类保养，挑选含有维生素A或Ｃ的修护成分持续优化肤质，让肤色更透亮。',
        average:
          '隐藏的斑点蠢蠢欲动，再不及时加强防晒保护，黑色素就要浮出肌肤表面啦！这时候要用美白精华再搭配能促进色素代谢的护肤品。记得白天不要使用含光敏感成分的护肤品，也要少吃光敏感性食物，以免加深色素沉淀。',
        fair:
          '已经有较为明显的斑点，户外需要高系数的防水型防晒；容易忽略的室内紫外线及3C产品的蓝光，可以选用SPF10～15日常防晒；每天持续美白及修护保养，每周至少敷2次高效美白面膜、至少一次去角质护理。',
      },
      hd_wrinkle: {
        good:
          '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
        average:
          '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
        fair:
          '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
      },
      hd_wrinkle_forehead: {
        good:
          '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
        average:
          '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
        fair:
          '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
      },
      hd_wrinkle_glabellar: {
        good:
          '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
        average:
          '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
        fair:
          '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
      },
      hd_wrinkle_periocular: {
        good:
          '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
        average:
          '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
        fair:
          '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
      },
      hd_wrinkle_crowfeet: {
        good:
          '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
        average:
          '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
        fair:
          '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
      },
      hd_wrinkle_nasolabial: {
        good:
          '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
        average:
          '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
        fair:
          '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
      },
      hd_wrinkle_marionette: {
        good:
          '肤况堪称年轻且充满活力！做好预防初老保养即可，可以使用精华液、抗氧化保养品来预防自由基带来的伤害，同时加强防晒隔离，避免光老化。',
        average:
          '假性皱纹可能找上你了，比如大笑时的眼周与嘴角的表情纹，还有两颊小细纹，这些都是因为光老化所造成，除了持续的抗氧化保养外，记得加强防晒保护，减少紫外线和自由基损伤，同时还要补充适量的维生素和微量元素。',
        fair:
          '迈入熟龄肌，除了肌肤逐渐变薄且脆弱外，鱼尾纹、法令纹及抬头纹纷纷出现，轮廓也失去紧致度，颈纹与双下巴也来凑热闹。选用能发挥紧致、提拉、抚纹功效的精华与乳霜并搭配适当医美疗程，还是能期待重现年轻光彩。',
      },
      hd_texture: {
        good:
          '是人人羡慕的水煮蛋肌！角质代谢良好，想必平时清洁非常彻底，看不见毛孔与细纹，要继续保持哟。基础护肤外再进一步加入维持肌肤微生态平衡的产品，如酵母原液等就很适合。',
        average:
          '肤质乍看还不错，但近看毛孔还是有些黑头、白头、粉刺，可以尝试每周一次的深层清洁护理，或是隔周一次的低浓度果酸焕肤，精华液、乳霜与定期的面膜调理也不能少，就能让肌肤恢复应有的柔嫩细致。',
        fair:
          '忙碌导致代谢循环速度低落，肤色也会黯沉少活力。老废角质细胞堆积造成毛孔阻塞。肌肤表面粗糙不平需要从肌底修护做起，彻底排除肌肤底层的老废物质，记得每周至少一次深层清洁并搭配2～3次焕肤面膜。',
      },
      hd_dark_circle: {
        average:
          '长时间盯着手机和电脑会使眼压变大且循环不良，黑眼圈和眼周细纹就会悄悄出现！每天早晚，在使用眼部保养品时轻轻地用指腹按压眼周可舒缓疲劳，每周敷2次眼膜也能帮助预防熊猫眼与眼周浮肿。',
        fair:
          '经常熬夜的你，使用手机和计算机的时间应该也蛮长的，绝对不能忽略眼周专属保养产品，像是帮助循环的眼部精华及修护眼霜，敷眼膜的频率也可提高到一周2～3次。用眼每小时要休息至少5分钟，帮眼周按按摩。',
        good:
          '作息规律眼睛明亮的你，只需要维持基础眼霜保养并偶尔敷敷眼膜即可。但夏天户外阳光强烈要记得戴上太阳眼镜，也能保护双眼避免黑色素增生。',
      },
      hd_radiance: {
        good:
          '肌肤表面油水平衡超完美，可以均匀反射出光采。比起保养更重要的是清洁，洗脸的水温记得不能比肤温高，用洗面产品的泡沫温和按摩肌肤持续至少一分钟，让清洁成分有效发挥作用再清洗即可。',
        average:
          '局部黯沉但困扰不大，除了清洁之外，可一周使用2～3次去角质产品加强老废角质的排除，并选择深度保湿产品让肌肤充满水分自然就能折射出健康光采。',
        fair:
          '肤色蜡黄暗沉如影随行，看起来精神欠佳！面膜可以在短时间内给予肌肤养分补充，帮助淡化色素沉淀、均匀肤色，还能发挥立即提亮的效果。根据自己的肤质（中/混和/干/敏感性）来选择，才能达到最理想的效果。',
      },
      hd_oiliness: {
        good:
          '控油能力棒棒der！顶多春夏季偶尔在额头鼻部及下巴有小小的出油现象，局部使用控油产品就可以。除了日常护肤还可以尝试更高效的深层清洁或焕肤精华和面膜等产品。',
        average:
          '我相信你的控油还可以做得更好！目前T区（额头、鼻及下巴）偏油，两颊却有可能偏干，可选择为混合性皮肤设计的控油产品，以及不会阻塞毛孔的保湿、防晒及粉底彩妆，恢复本身天然的油水平衡。',
        fair:
          '中东油田就是你！保养时可选择适合油性及痘痘肌的无油配方，底妆以雾光且具皮脂调节作用的产品为佳。少碰甜食和高糖饮料，也不要熬夜让心情放轻松。',
      },
      hd_eye_bag: {
        good:
          '只有卧蚕没有眼袋！保持每天8小时睡眠并提高睡眠的质量，睡前不要喝太多水，平时不要给自己太大的心理压力，平常选择眼部专用精华液轻松保养即可。',
        average:
          '只有早上起来时眼袋较明显，得注意改善眼周血液循环，工作念书的空档多做眼部穴位按摩，可以预防眼袋的恶化。挑选附按摩端的眼部专用保养品，一边涂抹眼霜时还能加强代谢循环。',
        fair:
          '不仅眼袋明显，还伴随了色素暗沉或阴影问题看起来十分老气。但由于眼周肌肤薄且脆弱易引起刺激反应，选择低敏型眼部保养品为佳，添加咖啡因成分的眼霜有助于去水肿，而胜肽等修护成分则能拉提松垮的线条。',
      },
      hd_moisture: {
        average:
          '保水度还有提升的空间哦！日常护肤除了持续补水锁水的精华液之外，可再加一道高保湿乳液预防水分流失。注意不要过度清洁，中午午休后、补妆前可以喷些保湿喷雾，并记得用面纸按掉多余水分，每周敷2～3次面膜以提升肌肤保水度。',
        good:
          '你的肌肤水润光滑，拥有健康的油水平衡又饱满有弹性！日常的保湿产品要继续使用，每周至少一次去角质护理并搭配抗氧化精华，能提供更适当的保护及防御。',
        fair:
          '保水度明显不够，有可能出现干纹或敏感等问题！先以精华类产品能深度补充水分，再以高保湿乳液或乳霜形成锁水膜预防水分流失，且每天至少喝8杯水，不定时补充保湿喷雾，且每周至少敷3次保湿面膜。',
      },
      hd_droopy_upper_eyelid: {
        average:
          '40岁之后出现的眼皮松弛下垂不外乎就是老化问题，但眼睑松弛的程度与速度与体质及保养习惯有很大的关联。除了改用较为滋润的眼霜持续呵护之外，白天出门的防晒也别忘记眼周部位，以避免紫外线加速光老化速度。',
        fair:
          '眼角明显松弛甚至改变眼型，用分子细小的胜肽类保养品，或添加左旋C及其他抗氧化成分的眼部产品，可以透过按摩达到眼皮提拉的效果，并促进眼周的微循环，进而消除眼皮浮肿与松弛。',
        good:
          '20～35岁之间，通常是因为水肿出现的眼皮松弛下垂，通过有去水肿功能的眼部保养产品多半可以获得改善，记得擦眼霜的时候不要过度拉扯，使用3C产品的时间也不要过长，用眼过度也会造成眼周肌肉的负担。',
      },
      hd_droopy_lower_eyelid: {
        good:
          '没有细纹也没有泪沟的饱满好肤质，选择质地清爽的眼部精华或是凝露状产品维持眼周肌肤的保水度，不熬夜也不要经常搓揉眼睛就能拥有电眼明眸。',
        average:
          '眼尾的紧致度稍显不足，涂抹眼部保养品时以水平方向擦拭且力道也要相当轻柔，周间可辅以较润泽的美容油搭配拉提按摩帮助恢复线条的紧致度。',
        fair:
          '出现了明显的泪沟与纹路，代表眼周保养力度不足，饮食方面多摄取丰富维他命Ｃ含量的蔬果，有助于肌底组织更健康。选择抗氧化效果强的胜肽成分眼霜或可刺激胶原增生的保养品更符合需求。',
      },
      hd_firmness: {
        good:
          '整体轮廓紧致有弹性，努力维持胶原蛋白在最佳状态。同样记得防晒避免胶原提早流失，日常则是多补充维他命C含量高的蔬果，保养重视保湿，擦保养品时可搭配轮廓线的拉提按摩。',
        average:
          '眼睑下垂、脸颊或嘴角下垂，五官没有之前立体了。由于人体的含水量超过60％，其中15％集中在肌肤，最重要的护肤守则之一救是每日都要饮用足够的水，除了日常的保湿保养外，每周2~3次可交替使用保湿与拉提紧致面膜。',
        fair:
          '连颈部肌肤都开始下垂或纹路增加（俗称火鸡脖子），再不努力就来不及了！优质睡眠，搭配睡前的紫外线修护调理，让夜晚肌肤黄金修复期得以发挥最好的运作，也能适当使用喜爱的精油增加睡眠质量。',
      },
      hd_redness: {
        average:
          '两颊微微泛红看起来虽可爱，但是毛细血管长期扩张可能形成红斑或血丝，所以，一旦出现泛红现象就要及时镇静舒缓，晒太阳后一定要做好修复并补充大量水分，同时选择物理性防晒产品为佳。',
        good:
          '肌肤很健壮！但随着时间推移结构会越来越脆弱松散，渐渐失去防御能力，天气变化、污染、化学物质等都很容易影响，还是需要使用适合肌肤的保养品来建构天然防御力，才能维持肌表的生态平衡。',
        fair:
          '偏向敏感性肤质！肌肤较薄且表皮屏障较弱，建议选用通过敏感测试的产品，并且不要过度清洁，保养步骤与成分都尽量单纯，使用舒缓性的化妆水或乳液即可，若有微热、搔痒和疹块现象，就必须暂停使用保养品，寻求皮肤科医师的诊断！',
      },
      hd_acne: {
        average:
          '出现痘痘踪迹但没有红疹现象，那就是粉刺，粉刺型青春痘通常使用含A酸的保养品就可以达到不错的控制效果。但初期使用Ａ酸可能会有刺激性，且当照射阳光刺激性会加剧，建议晚上使用即可，白天的防晒品也要选择质地清爽的。',
        fair:
          '脓疱型青春痘，甚至还伴随严重的红肿，表示发炎感染已经到达真皮层，留下痘疤的机率相当高。口服及外用A酸并行是最有效，另外，像果酸、杏仁酸、杜鹃花酸这类成也可辅助使用，但严重面疱问题绝对建议请教专业皮肤科医师一起解决！',
        good:
          '几乎看不见毛孔，让人羡慕的光滑平整肌！做好每天的卸妆与清洁，并注意肌肤表面的油水平衡，但不要过度的清洁或是频繁的使用吸油产品，以免肌肤过度分泌皮脂反而造成痘痘问题。',
      },
      hd_pore: {
        fair:
          '除了痘疤还伴随着老化型毛孔，尤其两颊毛孔更为明显，除了医学美容之外，平日保养加强去角质等深层清洁，老化型毛孔则要更注意清洁之后的保湿，同时可使用含维他命A的保养品持续细致粗大毛孔问题。',
        average:
          '油性肌肤出油过多与老废角质堆积，固化的皮脂进而形成白头与黑头粉刺，毛囊内部因长期受到挤压而显得粗大。使用含适当浓度的酸类产品焕肤，发挥控油、代谢老化角质等作用便能改善毛孔粗大问题。',
        good:
          '肤质看起来很精致几乎零毛孔，记得持续做好保湿与防晒，避免油脂过度堆积。爱晒太阳又不防晒的人毛孔绝对会越来越粗大，因为紫外线会破坏肌底胶原蛋白，使皮肤老化松弛，因此，一年四季都要擦防晒。',
      },
      hd_pore_forehead: {
        fair:
          '除了痘疤还伴随着老化型毛孔，尤其两颊毛孔更为明显，除了医学美容之外，平日保养加强去角质等深层清洁，老化型毛孔则要更注意清洁之后的保湿，同时可使用含维他命A的保养品持续细致粗大毛孔问题。',
        average:
          '油性肌肤出油过多与老废角质堆积，固化的皮脂进而形成白头与黑头粉刺，毛囊内部因长期受到挤压而显得粗大。使用含适当浓度的酸类产品焕肤，发挥控油、代谢老化角质等作用便能改善毛孔粗大问题。',
        good:
          '肤质看起来很精致几乎零毛孔，记得持续做好保湿与防晒，避免油脂过度堆积。爱晒太阳又不防晒的人毛孔绝对会越来越粗大，因为紫外线会破坏肌底胶原蛋白，使皮肤老化松弛，因此，一年四季都要擦防晒。',
      },
      hd_pore_nose: {
        fair:
          '除了痘疤还伴随着老化型毛孔，尤其两颊毛孔更为明显，除了医学美容之外，平日保养加强去角质等深层清洁，老化型毛孔则要更注意清洁之后的保湿，同时可使用含维他命A的保养品持续细致粗大毛孔问题。',
        average:
          '油性肌肤出油过多与老废角质堆积，固化的皮脂进而形成白头与黑头粉刺，毛囊内部因长期受到挤压而显得粗大。使用含适当浓度的酸类产品焕肤，发挥控油、代谢老化角质等作用便能改善毛孔粗大问题。',
        good:
          '肤质看起来很精致几乎零毛孔，记得持续做好保湿与防晒，避免油脂过度堆积。爱晒太阳又不防晒的人毛孔绝对会越来越粗大，因为紫外线会破坏肌底胶原蛋白，使皮肤老化松弛，因此，一年四季都要擦防晒。',
      },
      hd_pore_cheek: {
        fair:
          '除了痘疤还伴随着老化型毛孔，尤其两颊毛孔更为明显，除了医学美容之外，平日保养加强去角质等深层清洁，老化型毛孔则要更注意清洁之后的保湿，同时可使用含维他命A的保养品持续细致粗大毛孔问题。',
        average:
          '油性肌肤出油过多与老废角质堆积，固化的皮脂进而形成白头与黑头粉刺，毛囊内部因长期受到挤压而显得粗大。使用含适当浓度的酸类产品焕肤，发挥控油、代谢老化角质等作用便能改善毛孔粗大问题。',
        good:
          '肤质看起来很精致几乎零毛孔，记得持续做好保湿与防晒，避免油脂过度堆积。爱晒太阳又不防晒的人毛孔绝对会越来越粗大，因为紫外线会破坏肌底胶原蛋白，使皮肤老化松弛，因此，一年四季都要擦防晒。',
      },
      hd_teartrough: {
        average:
          '感觉有点疲惫？试试含有透明质酸或黄瓜萃取物等成分的保湿眼霜，让泪沟部位丰盈起来，减少疲惫感。',
        good: '您看起来眼睛明亮，精神饱满！坚持日常护肤，保持精神焕发。',
        fair:
          '是时候解决那些看似疲惫的眼袋问题了！使用含有肽或视黄醇的护肤品，刺激胶原蛋白的生成，恢复泪沟凹陷，让您看起来更加年轻。',
      },
      skin_health: {
        average: '',
        good: '',
        fair: '',
      },
    },
    ptb: {
      hd_spot: {
        average:
          'Continue com a limpeza facial duas vezes ao dia usando seu produto suave favorito e não se esqueça de hidratar a pele.',
        fair:
          'Mantenha as mãos longe do rosto durante o dia e mantenha uma rotina diligente com os cuidados da pele, incluindo limpeza suave e tratamento contra manchas por acne.',
        good:
          'Olá linda! Sua pele está com um aspecto muito bonito. Mantenha seu hidratante diário e seu FPS.',
      },
      hd_wrinkle: {
        good:
          'Está com aspecto muito bom! Não se esqueça de aplicar o FPS para manter a pele suave, bonita e protegida.',
        average:
          'A exposição ao sol pode causar danos significativos à sua pele e o FPS é sua defesa número um. Procure uma fórmula com pelo menos FPS 30 ou superior e reaplique com frequência.',
        fair:
          'Procure hidratantes com ingredientes hidratantes potentes que possam restaurar e melhorar os níveis de hidratação de sua pele para uma tez mais suave e com aparência mais jovem.',
      },
      hd_wrinkle_forehead: {
        good:
          'Está com aspecto muito bom! Não se esqueça de aplicar o FPS para manter a pele suave, bonita e protegida.',
        average:
          'A exposição ao sol pode causar danos significativos à sua pele e o FPS é sua defesa número um. Procure uma fórmula com pelo menos FPS 30 ou superior e reaplique com frequência.',
        fair:
          'Procure hidratantes com ingredientes hidratantes potentes que possam restaurar e melhorar os níveis de hidratação de sua pele para uma tez mais suave e com aparência mais jovem.',
      },
      hd_wrinkle_glabellar: {
        good:
          'Está com aspecto muito bom! Não se esqueça de aplicar o FPS para manter a pele suave, bonita e protegida.',
        average:
          'A exposição ao sol pode causar danos significativos à sua pele e o FPS é sua defesa número um. Procure uma fórmula com pelo menos FPS 30 ou superior e reaplique com frequência.',
        fair:
          'Procure hidratantes com ingredientes hidratantes potentes que possam restaurar e melhorar os níveis de hidratação de sua pele para uma tez mais suave e com aparência mais jovem.',
      },
      hd_wrinkle_periocular: {
        good:
          'Está com aspecto muito bom! Não se esqueça de aplicar o FPS para manter a pele suave, bonita e protegida.',
        average:
          'A exposição ao sol pode causar danos significativos à sua pele e o FPS é sua defesa número um. Procure uma fórmula com pelo menos FPS 30 ou superior e reaplique com frequência.',
        fair:
          'Procure hidratantes com ingredientes hidratantes potentes que possam restaurar e melhorar os níveis de hidratação de sua pele para uma tez mais suave e com aparência mais jovem.',
      },
      hd_wrinkle_crowfeet: {
        good:
          'Está com aspecto muito bom! Não se esqueça de aplicar o FPS para manter a pele suave, bonita e protegida.',
        average:
          'A exposição ao sol pode causar danos significativos à sua pele e o FPS é sua defesa número um. Procure uma fórmula com pelo menos FPS 30 ou superior e reaplique com frequência.',
        fair:
          'Procure hidratantes com ingredientes hidratantes potentes que possam restaurar e melhorar os níveis de hidratação de sua pele para uma tez mais suave e com aparência mais jovem.',
      },
      hd_wrinkle_nasolabial: {
        good:
          'Está com aspecto muito bom! Não se esqueça de aplicar o FPS para manter a pele suave, bonita e protegida.',
        average:
          'A exposição ao sol pode causar danos significativos à sua pele e o FPS é sua defesa número um. Procure uma fórmula com pelo menos FPS 30 ou superior e reaplique com frequência.',
        fair:
          'Procure hidratantes com ingredientes hidratantes potentes que possam restaurar e melhorar os níveis de hidratação de sua pele para uma tez mais suave e com aparência mais jovem.',
      },
      hd_wrinkle_marionette: {
        good:
          'Está com aspecto muito bom! Não se esqueça de aplicar o FPS para manter a pele suave, bonita e protegida.',
        average:
          'A exposição ao sol pode causar danos significativos à sua pele e o FPS é sua defesa número um. Procure uma fórmula com pelo menos FPS 30 ou superior e reaplique com frequência.',
        fair:
          'Procure hidratantes com ingredientes hidratantes potentes que possam restaurar e melhorar os níveis de hidratação de sua pele para uma tez mais suave e com aparência mais jovem.',
      },
      hd_texture: {
        average:
          'Melhore a textura de sua pele utilizando produtos que contenham nutrientes conhecidos por beneficiarem a pele. Eles melhoram a saúde geral e a aparência de sua pele, dando um brilho revitalizado e saudável.',
        fair:
          'Quer aprimorar a textura de sua pele? Considere o uso de um produto suave criado para remover células mortas da pele uma a duas vezes por semana deixando tez mais radiante e brilhante.',
        good:
          'Sua pele está com aspecto bom, portanto não se esqueça de usar FPS para manter esse lindo rosto protegido.',
      },
      hd_dark_circle: {
        average:
          'Primeiro respire fundo e sinta o peso sair de seus ombros. Em seguida, aplique um creme antioxidante sob os olhos para ajudar a estimular e suavizar a área.',
        fair:
          'Talvez seja hora de procurar meios de estimular a produção de colágeno e restaurar o volume e a firmeza na pele sensível abaixo dos olhos. Isto ajudará a diminuir as olheiras.',
        good:
          'Mantenha sua pela descansada! Sua pele parece saudável e refrescada.',
      },
      hd_radiance: {
        average:
          'Dê à sua pele um novo começo usando um limpador suave de manhã e à noite para remover quaisquer impurezas acumuladas ao longo do dia.',
        fair:
          'Revitalize o brilho natural de sua pele seguindo uma rotina diária simples que inclua limpeza, hidratação e proteção de sua pele.',
        good:
          'Você está brilhante e deslumbrante! Você está indo bem. Continue e desfrute desse belo brilho.',
      },
      hd_oiliness: {
        average:
          'Tendo dificuldades para manter o brilho? Experimente um produto de limpeza com Ácido Salicílico que esfolia suavemente ao limpar os poros, mas não resseca sua pele.',
        good:
          'Você está brilhando em todos os lugares! Deste jeito você irá brilhará em todos os lugares!',
        fair:
          'Se estiver pensando em regular oleosidade e reduzir o brilho na pele, use um toner de pele que contenha ingredientes esfoliantes suaves. Eles mantem seus poros desobstruídos e evitam a acumulação excessiva de oleosidade.',
      },
      hd_eye_bag: {
        average:
          'Experimente uma compressa fria ou sachês de chá para começar ou terminar seu dia. Isso ajuda a reduzir o inchaço sob os olhos. Procure também produtos com pepino ou água de rosas para ajudar a hidratar e acalmar a área.',
        fair:
          'Procure produtos calmantes e anti-inflamatórios com chá verde ou cafeína para ajudar a reduzir o inchaço sob a área sensorial.',
        good:
          'Dobre seu sono de beleza e mantenha esse estilo de vida sem estresse! Sua pele está com linda.',
      },
      hd_moisture: {
        average:
          'Beba água com frequência! Mantenha a saúde de sua pele usando um hidratante diário para manter sua pele suave e macia.',
        good:
          'Olá pele linda e hidratada! Mantenha o uso de hidratante diário e desfrute dessa maciez e suavidade.',
        fair:
          'Use um hidratante diário e um creme para a noite à sua rotina de cuidados com a pele para restaurar e rejuvenescer sua pele. Isto ajudará a restabelecer e nutrir sua pele dando um aspecto fresco e revitalizado pela manhã.',
      },
      hd_droopy_upper_eyelid: {
        average:
          'Precisa levantar um pouco? Ponha duas fatias firas de pepino sobre os olhos de 10 a 20 minutos para firmar naturalmente a pele e reduzir a flacidez.',
        good:
          'Olá, linda! Qual é seu segredo para cuidar da pele? Ela está ótima.',
        fair:
          'Procure produtos com resveratrol que naturalmente ajudem a retardar o envelhecimento celular e manter a pele com aspecto de pele justa e erguida.',
      },
      hd_droopy_lower_eyelid: {
        good:
          'Olá, linda! Qual é seu segredo para cuidar da pele? Ela está ótima.',
        average:
          'Precisa levantar um pouco? Ponha duas fatias firas de pepino sobre os olhos de 10 a 20 minutos para firmar naturalmente a pele e reduzir a flacidez.',
        fair:
          'Procure produtos com resveratrol que naturalmente ajudem a retardar o envelhecimento celular e manter a pele com aspecto de pele justa e erguida.',
      },
      hd_firmness: {
        average:
          'Uma massagem suave no seu rosto ajudará a levantar e firmar sua pele, estimulando músculos que melhorarão seu volume e aparência geral.',
        fair:
          'Precisa de reforço nos cuidados com a pele? Experimente uma máscara de reforço com colágeno para ajudar a devolver volume e firmeza à sua pele.',
        good: 'Você está jovem e brilhante como sempre. Continue assim!',
      },
      hd_redness: {
        good:
          'Continue com o que está fazendo! Esse tom lindo e regular da sua pele fala por si.',
        average:
          'Quer aliviar a vermelhidão na pele? Procure produtos com niacinamida para acalmar a inflamação, fortalecer e tonificar a pele.',
        fair:
          'Deixe os esfoliantes e use hidratante. Procure produtos com ingredientes calmantes como niacinamida, raiz de alcaçuz, aloe, cafeína e pepino que ajudam a reduzir a vermelhidão.',
      },
      hd_acne: {
        average:
          'Trate sua pele com gentileza, mantendo-a limpa e hidratada. A hidratação devolve o equilíbrio às glândulas oleosas da pele para controlar a acne e melhorar a cicatrização.',
        fair:
          'Mantenha as mãos longe do rosto! Mantenha a pele limpa com um produto removedor de impurezas suave para repor a umidade com um hidratante leve que não obstrua os poros. Não se esqueça de manter limpas os pinceis de maquiagem.',
        good:
          'Mantenha suas mãos longe do rosto, não esqueça seu FPS e hidratante diários para manter sua pele clara e protegida.',
      },
      hd_pore: {
        good: 'Alguém sabe como cuidar da pele! Continue assim.',
        average:
          'Mantenha a limpeza duas vezes ao dia para ajudar a remover a impureza e suor do dia que pode se instalar nos poros.',
        fair:
          'Para desobstruir os poros, use um limpador suave duas vezes ao dia e escolha produtos para os cuidados com a pele e maquiagem que não obstrua os poros',
      },
      hd_pore_forehead: {
        good: 'Alguém sabe como cuidar da pele! Continue assim.',
        average:
          'Mantenha a limpeza duas vezes ao dia para ajudar a remover a impureza e suor do dia que pode se instalar nos poros.',
        fair:
          'Para desobstruir os poros, use um limpador suave duas vezes ao dia e escolha produtos para os cuidados com a pele e maquiagem que não obstrua os poros',
      },
      hd_pore_nose: {
        good: 'Alguém sabe como cuidar da pele! Continue assim.',
        average:
          'Mantenha a limpeza duas vezes ao dia para ajudar a remover a impureza e suor do dia que pode se instalar nos poros.',
        fair:
          'Para desobstruir os poros, use um limpador suave duas vezes ao dia e escolha produtos para os cuidados com a pele e maquiagem que não obstrua os poros',
      },
      hd_pore_cheek: {
        good: 'Alguém sabe como cuidar da pele! Continue assim.',
        average:
          'Mantenha a limpeza duas vezes ao dia para ajudar a remover a impureza e suor do dia que pode se instalar nos poros.',
        fair:
          'Para desobstruir os poros, use um limpador suave duas vezes ao dia e escolha produtos para os cuidados com a pele e maquiagem que não obstrua os poros',
      },
      hd_teartrough: {
        average:
          'Está se sentindo cansado? Experimente um creme hidratante para os olhos com ingredientes como ácido hialurônico ou extrato de pepino para preencher a área do canal lacrimal e reduzir os sinais de fadiga.',
        good:
          'Você está com os olhos brilhantes e bem descansado! Mantenha sua rotina diária de cuidados com a pele para ter a aparência renovada.',
        fair:
          'É hora de tratar dessas olheiras! Procure produtos com peptídeos ou retinol ajudando a estimular a produção de colágeno e restaurar o volume nos canais lacrimais, proporcionando uma aparência mais rejuvenescida.',
      },
      skin_health: {
        average: '',
        good: '',
        fair: '',
      },
    },
    ara: {
      hd_spot: {
        average:
          'استمري في التنظيف مرتين يوميًا باستخدام منظفك اللطيف المفضل ولا تنسي الترطيب',
        fair:
          'أبعدي يديك عن وجهك خلال النهار وواظبي على روتين لطيف للعناية بالبشرة بما في ذلك منظف لطيف وعلاج بالبقع وحب الشباب.',
        good:
          'مرحبا بالجميلة! بتبدو بشرتك رائعة . استمري على وضع المرطب اليومي ومستحضر الحماية من الشمس (SPF).',
      },
      hd_wrinkle: {
        average:
          'يمكن أن يتسبب التعرض لأشعة الشمس في إلحاق ضرر كبير ببشرتك، ويعتبر عامل الحماية من أشعة الشمس هو دفاعك الأول. ابحثي عن تركيبة تحتوي على عامل حماية من الشمس 30 على الأقل أو أعلى وكرري تطبيقه كثيرًا.',
        fair:
          'ابحث عن المرطبات ذات المكونات المتحدة مع الماء القوية التي تساعدك في استعادة مستويات رطوبة بشرتك وتحسينها للحصول على بشرة أكثر نعومة وشبابًا.',
        good:
          'تبدو جيدة! الآن ، لا تنسى استخدام مستحضر الحماية من الشمس (SPF) للحفاظ على بشرة ناعمة وجميلة محمية.',
      },
      hd_wrinkle_forehead: {
        average:
          'يمكن أن يتسبب التعرض لأشعة الشمس في إلحاق ضرر كبير ببشرتك، ويعتبر عامل الحماية من أشعة الشمس هو دفاعك الأول. ابحثي عن تركيبة تحتوي على عامل حماية من الشمس 30 على الأقل أو أعلى وكرري تطبيقه كثيرًا.',
        fair:
          'ابحث عن المرطبات ذات المكونات المتحدة مع الماء القوية التي تساعدك في استعادة مستويات رطوبة بشرتك وتحسينها للحصول على بشرة أكثر نعومة وشبابًا.',
        good:
          'تبدو جيدة! الآن ، لا تنسى استخدام مستحضر الحماية من الشمس (SPF) للحفاظ على بشرة ناعمة وجميلة محمية.',
      },
      hd_wrinkle_glabellar: {
        average:
          'يمكن أن يتسبب التعرض لأشعة الشمس في إلحاق ضرر كبير ببشرتك، ويعتبر عامل الحماية من أشعة الشمس هو دفاعك الأول. ابحثي عن تركيبة تحتوي على عامل حماية من الشمس 30 على الأقل أو أعلى وكرري تطبيقه كثيرًا.',
        fair:
          'ابحث عن المرطبات ذات المكونات المتحدة مع الماء القوية التي تساعدك في استعادة مستويات رطوبة بشرتك وتحسينها للحصول على بشرة أكثر نعومة وشبابًا.',
        good:
          'تبدو جيدة! الآن ، لا تنسى استخدام مستحضر الحماية من الشمس (SPF) للحفاظ على بشرة ناعمة وجميلة محمية.',
      },
      hd_wrinkle_periocular: {
        average:
          'يمكن أن يتسبب التعرض لأشعة الشمس في إلحاق ضرر كبير ببشرتك، ويعتبر عامل الحماية من أشعة الشمس هو دفاعك الأول. ابحثي عن تركيبة تحتوي على عامل حماية من الشمس 30 على الأقل أو أعلى وكرري تطبيقه كثيرًا.',
        fair:
          'ابحث عن المرطبات ذات المكونات المتحدة مع الماء القوية التي تساعدك في استعادة مستويات رطوبة بشرتك وتحسينها للحصول على بشرة أكثر نعومة وشبابًا.',
        good:
          'تبدو جيدة! الآن ، لا تنسى استخدام مستحضر الحماية من الشمس (SPF) للحفاظ على بشرة ناعمة وجميلة محمية.',
      },
      hd_wrinkle_crowfeet: {
        average:
          'يمكن أن يتسبب التعرض لأشعة الشمس في إلحاق ضرر كبير ببشرتك، ويعتبر عامل الحماية من أشعة الشمس هو دفاعك الأول. ابحثي عن تركيبة تحتوي على عامل حماية من الشمس 30 على الأقل أو أعلى وكرري تطبيقه كثيرًا.',
        fair:
          'ابحث عن المرطبات ذات المكونات المتحدة مع الماء القوية التي تساعدك في استعادة مستويات رطوبة بشرتك وتحسينها للحصول على بشرة أكثر نعومة وشبابًا.',
        good:
          'تبدو جيدة! الآن ، لا تنسى استخدام مستحضر الحماية من الشمس (SPF) للحفاظ على بشرة ناعمة وجميلة محمية.',
      },
      hd_wrinkle_nasolabial: {
        average:
          'يمكن أن يتسبب التعرض لأشعة الشمس في إلحاق ضرر كبير ببشرتك، ويعتبر عامل الحماية من أشعة الشمس هو دفاعك الأول. ابحثي عن تركيبة تحتوي على عامل حماية من الشمس 30 على الأقل أو أعلى وكرري تطبيقه كثيرًا.',
        fair:
          'ابحث عن المرطبات ذات المكونات المتحدة مع الماء القوية التي تساعدك في استعادة مستويات رطوبة بشرتك وتحسينها للحصول على بشرة أكثر نعومة وشبابًا.',
        good:
          'تبدو جيدة! الآن ، لا تنسى استخدام مستحضر الحماية من الشمس (SPF) للحفاظ على بشرة ناعمة وجميلة محمية.',
      },
      hd_wrinkle_marionette: {
        average:
          'يمكن أن يتسبب التعرض لأشعة الشمس في إلحاق ضرر كبير ببشرتك، ويعتبر عامل الحماية من أشعة الشمس هو دفاعك الأول. ابحثي عن تركيبة تحتوي على عامل حماية من الشمس 30 على الأقل أو أعلى وكرري تطبيقه كثيرًا.',
        fair:
          'ابحث عن المرطبات ذات المكونات المتحدة مع الماء القوية التي تساعدك في استعادة مستويات رطوبة بشرتك وتحسينها للحصول على بشرة أكثر نعومة وشبابًا.',
        good:
          'تبدو جيدة! الآن ، لا تنسى استخدام مستحضر الحماية من الشمس (SPF) للحفاظ على بشرة ناعمة وجميلة محمية.',
      },
      hd_texture: {
        good:
          'تبدو بشرتك جيدة ، لذا لا تنسى تطبيق مستحضر الحماية من الشمس للحفاظ على هذا الوجه الجميل محميًا.',
        average:
          'حسني نسيج بشرتك باستخدام المنتجات التي تحتوي على العناصر الغذائية المعروفة بفائدتها للبشرة. يمكن أن يساعد ذلك في تحسين الصحة العامة ومظهر بشرتك، مما يمنحها توهجًا متجددًا وصحيًا.',
        fair:
          'هل تريدين تحسين ملمس بشرتك؟ اهتمي باستخدام منتج لطيف مصمم لإزالة خلايا الجلد الميتة مرة إلى مرتين في الأسبوع للمساعدة في الكشف عن بشرة أكثر إشراقًا وإشراقًا.',
      },
      hd_dark_circle: {
        average:
          'أولاً ، خذي نفسًا عميقًا واستشعري طرح الأثقال عن كاهلك. ثم ضعي كريمًا غنيًا بمضادات الأكسدة تحت عينيك للمساعدة في تحفيز تلك المنطقة وإشراقها.',
        fair:
          'قد يكون الوقت قد حان للبحث عن طرق للمساعدة في تحفيز انتاج الكولاجين واستعادة قوام ومتانة البشرة الحساسة تحت عينيك. سيساعد هذا على إخفاء الظلام تحت العين.',
        good: 'استريحي من أجل جمالك! تبدو بشرتك صحية ومنتعشة.',
      },
      hd_radiance: {
        good:
          'أنت جميلة و متألقة! استمري في العمل الجيد واستمتعي بهذا الإشراق الجميل.',
        average:
          'امنح بشرتك بداية جديدة باستخدام منظف لطيف صباحًا ومساءً لإزالة أي شوائب قد تكون قد تراكمت على مدار اليوم.',
        fair:
          'عززي توهج بشرتك الطبيعي باتباع روتين يومي بسيط يتضمن تنظيف بشرتك وترطيبها وحمايتها.',
      },
      hd_oiliness: {
        average:
          'هل تريدين إزالة القليل من اللمعان؟ جربي استخدام منظف يحتوي على حمض الساليسيليك الذي يقشر بلطف لتنظيف المسام، لكنه لن يجفف بشرتك في نفس الوقت.',
        fair:
          'إذا كنت تبحثين عن تنظيم إنتاج الزيت ومكافحة اللمعان، ففكري في استخدام تونر للبشرة يحتوي على مكونات تقشير لطيفة. يمكن أن يساعد ذلك في الحفاظ على مسامك نظيفة ومنع تراكم الدهون الزائدة.',
        good:
          'يبدو أنك تتألق في جميع الأماكن! استمر في العمل الجيد وتوهجي دوما!',
      },
      hd_eye_bag: {
        good:
          'ضاعف فترة نومك المريح واتبعي نمط حياة خالي من التوتر! تبدو بشرتك رائعة الجمال.',
        average:
          'جرب الكمادات الباردة أو أكياس الشاي حين بدء اليوم أو نهايته من أجل تقليل الانتفاخ تحت العين. ابحثي أيضًا عن المنتجات التي تحتوي على الخيار أو ماء الورد للمساعدة على ترطيب المنطقة وتهدئتها.',
        fair:
          'ابحثي عن منتجات مهدئة ومضادة للالتهابات تحتوي على الشاي الأخضر أو الكافيين للمساعدة في تقليل الانتفاخ تحت منطقة العين الحساسة.',
      },
      hd_moisture: {
        average:
          'اشربي الماء دوما! يمكنك دعم صحة بشرتك باستخدام مرطب يومي للمساعدة في الحفاظ على بشرتك ناعمة ونضرة.',
        fair:
          'أضفي مرطبًا يوميًا وكريمًا طوال الليل إلى روتين العناية ببشرتك لاستعادة وتجديد شباب بشرتك. سيساعد ذلك على تجديد وتغذية بشرتك للحصول على إطلالة منتعشة ومتجددة في الصباح.',
        good:
          'مرحبًا بالبشرة الجميلة الناعمة! واظبي على تطبيق المرطب اليومي والاستمتاع بتلك النعومة الندية.',
      },
      hd_droopy_upper_eyelid: {
        good:
          'مرحبًا بالإطلالة الجميلة! أخبرنا بكل أسرار العناية بالبشرة - تبدو بشرتك جيدة.',
        average:
          'هل تحتاجين القليل من الشد؟ ضعي شريحتين من الخيار البارد على العينين لمدة 10-20 دقيقة لشد الجلد بشكل طبيعي وتقويم الترهل.',
        fair:
          'ابحثي عن المنتجات التي تحتوي على مادة ريسفيراترول التي تساعد بشكل طبيعي على إبطاء شيخوخة الخلايا والحفاظ على بشرة مشدودة ومتينة.',
      },
      hd_droopy_lower_eyelid: {
        good:
          'مرحبًا بالإطلالة الجميلة! أخبرنا بكل أسرار العناية بالبشرة - تبدو بشرتك جيدة.',
        average:
          'هل تحتاجين القليل من الشد؟ ضعي شريحتين من الخيار البارد على العينين لمدة 10-20 دقيقة لشد الجلد بشكل طبيعي وتقويم الترهل.',
        fair:
          'ابحثي عن المنتجات التي تحتوي على مادة ريسفيراترول التي تساعد بشكل طبيعي على إبطاء شيخوخة الخلايا والحفاظ على بشرة مشدودة ومتينة.',
      },
      hd_firmness: {
        good: 'تبدين شابة ومتوهجًا أكثر من أي وقت مضى. استمري!',
        average:
          'يساعد التدليك اللطيف لوجهك على رفع ونحت بشرتك، وتحفيز العضلات التي من شأنها تحسين حجم بشرتك ومظهرها بشكل عام.',
        fair:
          'هل تحتاجين إلى تعزيز العناية ببشرتك؟ جربي قناعًا معززًا للكولاجين للمساعدة على استعادة قوام بشرتك وثباتها.',
      },
      hd_redness: {
        good: 'استمري بعملك الجيد! دعي جمالك يشرق بنفسه.',
        average:
          'هل ترغبين في تهدئة احمرار البشرة؟ ابحثي عن المنتجات التي تحتوي على النياسيناميد لتهدئة الالتهاب، وحتى لون البشرة ، والمساعدة في تعزيز البشرة.',
        fair:
          'استخدمي المقشرات ثم المرطب. ابحث عن المنتجات التي تحتوي على مكونات مهدئة مثل النياسيناميد وجذر عرق السوس والصبار والكافيين والخيار التي تساعد على تقليل الاحمرار.',
      },
      hd_acne: {
        good:
          'أبعدي يديك عن وجهك ولا تنسى استخدام مستحضر الحماية من الشمس (SPF) والمرطب يوميًا للحفاظ على بشرتك صافية مشرقة ومحمية.',
        average:
          'كوني لطيفة مع بشرتك وحافظ عليها نظيفة وندية. يساعد الترطيب على إعادة توازن الغدد الدهنية في البشرة للسيطرة على حب الشباب وتحسين عملية الشفاء.',
        fair:
          'أبعدي يديك عن بشرتك ركزي على نظافة البشرة باستخدام منظف لطيف وتعزيز النداوة باستخدام مرطب خفيف الوزن لا يسد المسام. تذكري تنظيف فرش المكياج أيضًا.',
      },
      hd_pore: {
        fair:
          "للمساعدة في إزالة انسداد المسام، استخدمي منظفًا لطيفًا مرتين يوميًا واختاري منتجات العناية بالبشرة والماكياج التي لا تسبب انسداد المسام'المسام الواسعة",
        good: 'يشرح أحد الخبراء مكونات الجمال! استري في العمل الجيد',
        average:
          'حافظي على التنظيف مرتين يوميًا للمساعدة في إزالة الأوساخ والعرق والأتربة خلال اليوم والتي يمكن أن تترسب في المسام.',
      },
      hd_pore_forehead: {
        fair:
          "للمساعدة في إزالة انسداد المسام، استخدمي منظفًا لطيفًا مرتين يوميًا واختاري منتجات العناية بالبشرة والماكياج التي لا تسبب انسداد المسام'المسام الواسعة",
        good: 'يشرح أحد الخبراء مكونات الجمال! استري في العمل الجيد',
        average:
          'حافظي على التنظيف مرتين يوميًا للمساعدة في إزالة الأوساخ والعرق والأتربة خلال اليوم والتي يمكن أن تترسب في المسام.',
      },
      hd_pore_nose: {
        fair:
          "للمساعدة في إزالة انسداد المسام، استخدمي منظفًا لطيفًا مرتين يوميًا واختاري منتجات العناية بالبشرة والماكياج التي لا تسبب انسداد المسام'المسام الواسعة",
        good: 'يشرح أحد الخبراء مكونات الجمال! استري في العمل الجيد',
        average:
          'حافظي على التنظيف مرتين يوميًا للمساعدة في إزالة الأوساخ والعرق والأتربة خلال اليوم والتي يمكن أن تترسب في المسام.',
      },
      hd_pore_cheek: {
        fair:
          "للمساعدة في إزالة انسداد المسام، استخدمي منظفًا لطيفًا مرتين يوميًا واختاري منتجات العناية بالبشرة والماكياج التي لا تسبب انسداد المسام'المسام الواسعة",
        good: 'يشرح أحد الخبراء مكونات الجمال! استري في العمل الجيد',
        average:
          'حافظي على التنظيف مرتين يوميًا للمساعدة في إزالة الأوساخ والعرق والأتربة خلال اليوم والتي يمكن أن تترسب في المسام.',
      },
      hd_teartrough: {
        average:
          'هل تشعر بالتعب قليلا؟ جربي كريم ترطيب العين الذي يحتوي على مكونات مثل حمض الهيالورونيك أو مستخلص الخيار لترطيب منطقة أسفل الدموع وتقليل أي علامات للإرهاق.',
        good:
          'أنت تبدو مضيئ العينين ومرتاحًا تمامًا! استمري في اتباع روتين العناية اليومي بالبشرة للحفاظ على هذا المظهر المتألق.',
        fair:
          'حان الوقت لمعالجة تلك الهالات السوداء نتجة الإجهاد تحت العينين! ابحثي عن المنتجات التي تحتوي على الببتيدات أو الريتينول للمساعدة في تحفيز إنتاج الكولاجين واستعادة الحجم في مناطق الدموع، مما يمنحك مظهرًا أكثر تجددًا.',
      },
      skin_health: {
        average: '',
        good: '',
        fair: '',
      },
    },
  },
  buttonText: {
    viewSkinReport: {
      en: 'View Skin Report',
      fr: 'Afficher le rapport sur votre peau',
      ja: '肌分析レポートを表示',
      ko: '피부 보고서 보기',
      de: 'Hautbericht anzeigen',
      es: 'Ver informe de piel',
      it: 'Visualizza report pelle',
      'zh-Hant': '檢視膚質分析',
      'zh-Hans': '查看肤质分析',
      pt: 'Visualizar o diagnóstico de pele',
      ar: 'عرض تقرير البشرة',
    },
  },
  getSkinReportButtonText: {
    enu: 'GET SKIN REPORT',
    fra: 'OBTENIR VOTRE RAPPORT DE PEAU',
    jpn: '肌分析レポートを取得します',
    cht: '取得膚質分析',
    chs: '获取肤质分析',
    kor: '피부 보고서 받기',
    deu: 'HAUTBERICHT ERHALTEN',
    esp: 'OBTENER INFORME DE PIEL',
    ita: 'OTTIENI REPORT PELLE',
    ptb: 'OBTER RELATÓRIO DA PELE',
    ara: 'احصلي على تقرير بشرتك',
  },
};
